function ___$insertStylesToHeader(css) {
  if (!css) {
    return
  }
  if (typeof window === 'undefined') {
    return
  }

  const style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css
}

function noop() { }
const identity = x => x;
// Adapted from https://github.com/then/is-promise/blob/master/index.js
// Distributed under MIT License https://github.com/then/is-promise/blob/master/LICENSE
function is_promise(value) {
    return !!value && (typeof value === 'object' || typeof value === 'function') && typeof value.then === 'function';
}
function run(fn) {
    return fn();
}
function blank_object() {
    return Object.create(null);
}
function run_all(fns) {
    fns.forEach(run);
}
function is_function(thing) {
    return typeof thing === 'function';
}
function safe_not_equal(a, b) {
    return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
}
function is_empty(obj) {
    return Object.keys(obj).length === 0;
}
function subscribe(store, ...callbacks) {
    if (store == null) {
        return noop;
    }
    const unsub = store.subscribe(...callbacks);
    return unsub.unsubscribe ? () => unsub.unsubscribe() : unsub;
}
function component_subscribe(component, store, callback) {
    component.$$.on_destroy.push(subscribe(store, callback));
}
function null_to_empty(value) {
    return value == null ? '' : value;
}
function split_css_unit(value) {
    const split = typeof value === 'string' && value.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
    return split ? [parseFloat(split[1]), split[2] || 'px'] : [value, 'px'];
}

const is_client = typeof window !== 'undefined';
let now = is_client
    ? () => window.performance.now()
    : () => Date.now();
let raf = is_client ? cb => requestAnimationFrame(cb) : noop;

const tasks = new Set();
function run_tasks(now) {
    tasks.forEach(task => {
        if (!task.c(now)) {
            tasks.delete(task);
            task.f();
        }
    });
    if (tasks.size !== 0)
        raf(run_tasks);
}
/**
 * Creates a new task that runs on each raf frame
 * until it returns a falsy value or is aborted
 */
function loop(callback) {
    let task;
    if (tasks.size === 0)
        raf(run_tasks);
    return {
        promise: new Promise(fulfill => {
            tasks.add(task = { c: callback, f: fulfill });
        }),
        abort() {
            tasks.delete(task);
        }
    };
}
function append(target, node) {
    target.appendChild(node);
}
function get_root_for_style(node) {
    if (!node)
        return document;
    const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
    if (root && root.host) {
        return root;
    }
    return node.ownerDocument;
}
function append_empty_stylesheet(node) {
    const style_element = element('style');
    append_stylesheet(get_root_for_style(node), style_element);
    return style_element.sheet;
}
function append_stylesheet(node, style) {
    append(node.head || node, style);
    return style.sheet;
}
function insert(target, node, anchor) {
    target.insertBefore(node, anchor || null);
}
function detach(node) {
    if (node.parentNode) {
        node.parentNode.removeChild(node);
    }
}
function destroy_each(iterations, detaching) {
    for (let i = 0; i < iterations.length; i += 1) {
        if (iterations[i])
            iterations[i].d(detaching);
    }
}
function element(name) {
    return document.createElement(name);
}
function svg_element(name) {
    return document.createElementNS('http://www.w3.org/2000/svg', name);
}
function text(data) {
    return document.createTextNode(data);
}
function space() {
    return text(' ');
}
function empty() {
    return text('');
}
function listen(node, event, handler, options) {
    node.addEventListener(event, handler, options);
    return () => node.removeEventListener(event, handler, options);
}
function attr(node, attribute, value) {
    if (value == null)
        node.removeAttribute(attribute);
    else if (node.getAttribute(attribute) !== value)
        node.setAttribute(attribute, value);
}
function children(element) {
    return Array.from(element.childNodes);
}
function set_data(text, data) {
    data = '' + data;
    if (text.wholeText !== data)
        text.data = data;
}
function set_style(node, key, value, important) {
    if (value === null) {
        node.style.removeProperty(key);
    }
    else {
        node.style.setProperty(key, value, important ? 'important' : '');
    }
}
function custom_event(type, detail, { bubbles = false, cancelable = false } = {}) {
    const e = document.createEvent('CustomEvent');
    e.initCustomEvent(type, bubbles, cancelable, detail);
    return e;
}
function construct_svelte_component(component, props) {
    return new component(props);
}

// we need to store the information for multiple documents because a Svelte application could also contain iframes
// https://github.com/sveltejs/svelte/issues/3624
const managed_styles = new Map();
let active = 0;
// https://github.com/darkskyapp/string-hash/blob/master/index.js
function hash(str) {
    let hash = 5381;
    let i = str.length;
    while (i--)
        hash = ((hash << 5) - hash) ^ str.charCodeAt(i);
    return hash >>> 0;
}
function create_style_information(doc, node) {
    const info = { stylesheet: append_empty_stylesheet(node), rules: {} };
    managed_styles.set(doc, info);
    return info;
}
function create_rule(node, a, b, duration, delay, ease, fn, uid = 0) {
    const step = 16.666 / duration;
    let keyframes = '{\n';
    for (let p = 0; p <= 1; p += step) {
        const t = a + (b - a) * ease(p);
        keyframes += p * 100 + `%{${fn(t, 1 - t)}}\n`;
    }
    const rule = keyframes + `100% {${fn(b, 1 - b)}}\n}`;
    const name = `__svelte_${hash(rule)}_${uid}`;
    const doc = get_root_for_style(node);
    const { stylesheet, rules } = managed_styles.get(doc) || create_style_information(doc, node);
    if (!rules[name]) {
        rules[name] = true;
        stylesheet.insertRule(`@keyframes ${name} ${rule}`, stylesheet.cssRules.length);
    }
    const animation = node.style.animation || '';
    node.style.animation = `${animation ? `${animation}, ` : ''}${name} ${duration}ms linear ${delay}ms 1 both`;
    active += 1;
    return name;
}
function delete_rule(node, name) {
    const previous = (node.style.animation || '').split(', ');
    const next = previous.filter(name
        ? anim => anim.indexOf(name) < 0 // remove specific animation
        : anim => anim.indexOf('__svelte') === -1 // remove all Svelte animations
    );
    const deleted = previous.length - next.length;
    if (deleted) {
        node.style.animation = next.join(', ');
        active -= deleted;
        if (!active)
            clear_rules();
    }
}
function clear_rules() {
    raf(() => {
        if (active)
            return;
        managed_styles.forEach(info => {
            const { ownerNode } = info.stylesheet;
            // there is no ownerNode if it runs on jsdom.
            if (ownerNode)
                detach(ownerNode);
        });
        managed_styles.clear();
    });
}

let current_component;
function set_current_component(component) {
    current_component = component;
}
function get_current_component() {
    if (!current_component)
        throw new Error('Function called outside component initialization');
    return current_component;
}

const dirty_components = [];
const binding_callbacks = [];
let render_callbacks = [];
const flush_callbacks = [];
const resolved_promise = /* @__PURE__ */ Promise.resolve();
let update_scheduled = false;
function schedule_update() {
    if (!update_scheduled) {
        update_scheduled = true;
        resolved_promise.then(flush);
    }
}
function add_render_callback(fn) {
    render_callbacks.push(fn);
}
// flush() calls callbacks in this order:
// 1. All beforeUpdate callbacks, in order: parents before children
// 2. All bind:this callbacks, in reverse order: children before parents.
// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
//    for afterUpdates called during the initial onMount, which are called in
//    reverse order: children before parents.
// Since callbacks might update component values, which could trigger another
// call to flush(), the following steps guard against this:
// 1. During beforeUpdate, any updated components will be added to the
//    dirty_components array and will cause a reentrant call to flush(). Because
//    the flush index is kept outside the function, the reentrant call will pick
//    up where the earlier call left off and go through all dirty components. The
//    current_component value is saved and restored so that the reentrant call will
//    not interfere with the "parent" flush() call.
// 2. bind:this callbacks cannot trigger new flush() calls.
// 3. During afterUpdate, any updated components will NOT have their afterUpdate
//    callback called a second time; the seen_callbacks set, outside the flush()
//    function, guarantees this behavior.
const seen_callbacks = new Set();
let flushidx = 0; // Do *not* move this inside the flush() function
function flush() {
    // Do not reenter flush while dirty components are updated, as this can
    // result in an infinite loop. Instead, let the inner flush handle it.
    // Reentrancy is ok afterwards for bindings etc.
    if (flushidx !== 0) {
        return;
    }
    const saved_component = current_component;
    do {
        // first, call beforeUpdate functions
        // and update components
        try {
            while (flushidx < dirty_components.length) {
                const component = dirty_components[flushidx];
                flushidx++;
                set_current_component(component);
                update(component.$$);
            }
        }
        catch (e) {
            // reset dirty state to not end up in a deadlocked state and then rethrow
            dirty_components.length = 0;
            flushidx = 0;
            throw e;
        }
        set_current_component(null);
        dirty_components.length = 0;
        flushidx = 0;
        while (binding_callbacks.length)
            binding_callbacks.pop()();
        // then, once components are updated, call
        // afterUpdate functions. This may cause
        // subsequent updates...
        for (let i = 0; i < render_callbacks.length; i += 1) {
            const callback = render_callbacks[i];
            if (!seen_callbacks.has(callback)) {
                // ...so guard against infinite loops
                seen_callbacks.add(callback);
                callback();
            }
        }
        render_callbacks.length = 0;
    } while (dirty_components.length);
    while (flush_callbacks.length) {
        flush_callbacks.pop()();
    }
    update_scheduled = false;
    seen_callbacks.clear();
    set_current_component(saved_component);
}
function update($$) {
    if ($$.fragment !== null) {
        $$.update();
        run_all($$.before_update);
        const dirty = $$.dirty;
        $$.dirty = [-1];
        $$.fragment && $$.fragment.p($$.ctx, dirty);
        $$.after_update.forEach(add_render_callback);
    }
}
/**
 * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
 */
function flush_render_callbacks(fns) {
    const filtered = [];
    const targets = [];
    render_callbacks.forEach((c) => fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c));
    targets.forEach((c) => c());
    render_callbacks = filtered;
}

let promise;
function wait() {
    if (!promise) {
        promise = Promise.resolve();
        promise.then(() => {
            promise = null;
        });
    }
    return promise;
}
function dispatch(node, direction, kind) {
    node.dispatchEvent(custom_event(`${direction ? 'intro' : 'outro'}${kind}`));
}
const outroing = new Set();
let outros;
function group_outros() {
    outros = {
        r: 0,
        c: [],
        p: outros // parent group
    };
}
function check_outros() {
    if (!outros.r) {
        run_all(outros.c);
    }
    outros = outros.p;
}
function transition_in(block, local) {
    if (block && block.i) {
        outroing.delete(block);
        block.i(local);
    }
}
function transition_out(block, local, detach, callback) {
    if (block && block.o) {
        if (outroing.has(block))
            return;
        outroing.add(block);
        outros.c.push(() => {
            outroing.delete(block);
            if (callback) {
                if (detach)
                    block.d(1);
                callback();
            }
        });
        block.o(local);
    }
    else if (callback) {
        callback();
    }
}
const null_transition = { duration: 0 };
function create_bidirectional_transition(node, fn, params, intro) {
    const options = { direction: 'both' };
    let config = fn(node, params, options);
    let t = intro ? 0 : 1;
    let running_program = null;
    let pending_program = null;
    let animation_name = null;
    function clear_animation() {
        if (animation_name)
            delete_rule(node, animation_name);
    }
    function init(program, duration) {
        const d = (program.b - t);
        duration *= Math.abs(d);
        return {
            a: t,
            b: program.b,
            d,
            duration,
            start: program.start,
            end: program.start + duration,
            group: program.group
        };
    }
    function go(b) {
        const { delay = 0, duration = 300, easing = identity, tick = noop, css } = config || null_transition;
        const program = {
            start: now() + delay,
            b
        };
        if (!b) {
            // @ts-ignore todo: improve typings
            program.group = outros;
            outros.r += 1;
        }
        if (running_program || pending_program) {
            pending_program = program;
        }
        else {
            // if this is an intro, and there's a delay, we need to do
            // an initial tick and/or apply CSS animation immediately
            if (css) {
                clear_animation();
                animation_name = create_rule(node, t, b, duration, delay, easing, css);
            }
            if (b)
                tick(0, 1);
            running_program = init(program, duration);
            add_render_callback(() => dispatch(node, b, 'start'));
            loop(now => {
                if (pending_program && now > pending_program.start) {
                    running_program = init(pending_program, duration);
                    pending_program = null;
                    dispatch(node, running_program.b, 'start');
                    if (css) {
                        clear_animation();
                        animation_name = create_rule(node, t, running_program.b, running_program.duration, 0, easing, config.css);
                    }
                }
                if (running_program) {
                    if (now >= running_program.end) {
                        tick(t = running_program.b, 1 - t);
                        dispatch(node, running_program.b, 'end');
                        if (!pending_program) {
                            // we're done
                            if (running_program.b) {
                                // intro — we can tidy up immediately
                                clear_animation();
                            }
                            else {
                                // outro — needs to be coordinated
                                if (!--running_program.group.r)
                                    run_all(running_program.group.c);
                            }
                        }
                        running_program = null;
                    }
                    else if (now >= running_program.start) {
                        const p = now - running_program.start;
                        t = running_program.a + running_program.d * easing(p / running_program.duration);
                        tick(t, 1 - t);
                    }
                }
                return !!(running_program || pending_program);
            });
        }
    }
    return {
        run(b) {
            if (is_function(config)) {
                wait().then(() => {
                    // @ts-ignore
                    config = config(options);
                    go(b);
                });
            }
            else {
                go(b);
            }
        },
        end() {
            clear_animation();
            running_program = pending_program = null;
        }
    };
}

function handle_promise(promise, info) {
    const token = info.token = {};
    function update(type, index, key, value) {
        if (info.token !== token)
            return;
        info.resolved = value;
        let child_ctx = info.ctx;
        if (key !== undefined) {
            child_ctx = child_ctx.slice();
            child_ctx[key] = value;
        }
        const block = type && (info.current = type)(child_ctx);
        let needs_flush = false;
        if (info.block) {
            if (info.blocks) {
                info.blocks.forEach((block, i) => {
                    if (i !== index && block) {
                        group_outros();
                        transition_out(block, 1, 1, () => {
                            if (info.blocks[i] === block) {
                                info.blocks[i] = null;
                            }
                        });
                        check_outros();
                    }
                });
            }
            else {
                info.block.d(1);
            }
            block.c();
            transition_in(block, 1);
            block.m(info.mount(), info.anchor);
            needs_flush = true;
        }
        info.block = block;
        if (info.blocks)
            info.blocks[index] = block;
        if (needs_flush) {
            flush();
        }
    }
    if (is_promise(promise)) {
        const current_component = get_current_component();
        promise.then(value => {
            set_current_component(current_component);
            update(info.then, 1, info.value, value);
            set_current_component(null);
        }, error => {
            set_current_component(current_component);
            update(info.catch, 2, info.error, error);
            set_current_component(null);
            if (!info.hasCatch) {
                throw error;
            }
        });
        // if we previously had a then/catch block, destroy it
        if (info.current !== info.pending) {
            update(info.pending, 0);
            return true;
        }
    }
    else {
        if (info.current !== info.then) {
            update(info.then, 1, info.value, promise);
            return true;
        }
        info.resolved = promise;
    }
}
function update_await_block_branch(info, ctx, dirty) {
    const child_ctx = ctx.slice();
    const { resolved } = info;
    if (info.current === info.then) {
        child_ctx[info.value] = resolved;
    }
    if (info.current === info.catch) {
        child_ctx[info.error] = resolved;
    }
    info.block.p(child_ctx, dirty);
}
function outro_and_destroy_block(block, lookup) {
    transition_out(block, 1, 1, () => {
        lookup.delete(block.key);
    });
}
function update_keyed_each(old_blocks, dirty, get_key, dynamic, ctx, list, lookup, node, destroy, create_each_block, next, get_context) {
    let o = old_blocks.length;
    let n = list.length;
    let i = o;
    const old_indexes = {};
    while (i--)
        old_indexes[old_blocks[i].key] = i;
    const new_blocks = [];
    const new_lookup = new Map();
    const deltas = new Map();
    const updates = [];
    i = n;
    while (i--) {
        const child_ctx = get_context(ctx, list, i);
        const key = get_key(child_ctx);
        let block = lookup.get(key);
        if (!block) {
            block = create_each_block(key, child_ctx);
            block.c();
        }
        else if (dynamic) {
            // defer updates until all the DOM shuffling is done
            updates.push(() => block.p(child_ctx, dirty));
        }
        new_lookup.set(key, new_blocks[i] = block);
        if (key in old_indexes)
            deltas.set(key, Math.abs(i - old_indexes[key]));
    }
    const will_move = new Set();
    const did_move = new Set();
    function insert(block) {
        transition_in(block, 1);
        block.m(node, next);
        lookup.set(block.key, block);
        next = block.first;
        n--;
    }
    while (o && n) {
        const new_block = new_blocks[n - 1];
        const old_block = old_blocks[o - 1];
        const new_key = new_block.key;
        const old_key = old_block.key;
        if (new_block === old_block) {
            // do nothing
            next = new_block.first;
            o--;
            n--;
        }
        else if (!new_lookup.has(old_key)) {
            // remove old block
            destroy(old_block, lookup);
            o--;
        }
        else if (!lookup.has(new_key) || will_move.has(new_key)) {
            insert(new_block);
        }
        else if (did_move.has(old_key)) {
            o--;
        }
        else if (deltas.get(new_key) > deltas.get(old_key)) {
            did_move.add(new_key);
            insert(new_block);
        }
        else {
            will_move.add(old_key);
            o--;
        }
    }
    while (o--) {
        const old_block = old_blocks[o];
        if (!new_lookup.has(old_block.key))
            destroy(old_block, lookup);
    }
    while (n)
        insert(new_blocks[n - 1]);
    run_all(updates);
    return new_blocks;
}
function create_component(block) {
    block && block.c();
}
function mount_component(component, target, anchor, customElement) {
    const { fragment, after_update } = component.$$;
    fragment && fragment.m(target, anchor);
    if (!customElement) {
        // onMount happens before the initial afterUpdate
        add_render_callback(() => {
            const new_on_destroy = component.$$.on_mount.map(run).filter(is_function);
            // if the component was destroyed immediately
            // it will update the `$$.on_destroy` reference to `null`.
            // the destructured on_destroy may still reference to the old array
            if (component.$$.on_destroy) {
                component.$$.on_destroy.push(...new_on_destroy);
            }
            else {
                // Edge case - component was destroyed immediately,
                // most likely as a result of a binding initialising
                run_all(new_on_destroy);
            }
            component.$$.on_mount = [];
        });
    }
    after_update.forEach(add_render_callback);
}
function destroy_component(component, detaching) {
    const $$ = component.$$;
    if ($$.fragment !== null) {
        flush_render_callbacks($$.after_update);
        run_all($$.on_destroy);
        $$.fragment && $$.fragment.d(detaching);
        // TODO null out other refs, including component.$$ (but need to
        // preserve final state?)
        $$.on_destroy = $$.fragment = null;
        $$.ctx = [];
    }
}
function make_dirty(component, i) {
    if (component.$$.dirty[0] === -1) {
        dirty_components.push(component);
        schedule_update();
        component.$$.dirty.fill(0);
    }
    component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
}
function init(component, options, instance, create_fragment, not_equal, props, append_styles, dirty = [-1]) {
    const parent_component = current_component;
    set_current_component(component);
    const $$ = component.$$ = {
        fragment: null,
        ctx: [],
        // state
        props,
        update: noop,
        not_equal,
        bound: blank_object(),
        // lifecycle
        on_mount: [],
        on_destroy: [],
        on_disconnect: [],
        before_update: [],
        after_update: [],
        context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
        // everything else
        callbacks: blank_object(),
        dirty,
        skip_bound: false,
        root: options.target || parent_component.$$.root
    };
    append_styles && append_styles($$.root);
    let ready = false;
    $$.ctx = instance
        ? instance(component, options.props || {}, (i, ret, ...rest) => {
            const value = rest.length ? rest[0] : ret;
            if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
                if (!$$.skip_bound && $$.bound[i])
                    $$.bound[i](value);
                if (ready)
                    make_dirty(component, i);
            }
            return ret;
        })
        : [];
    $$.update();
    ready = true;
    run_all($$.before_update);
    // `false` as a special case of no DOM component
    $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
    if (options.target) {
        if (options.hydrate) {
            const nodes = children(options.target);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $$.fragment && $$.fragment.l(nodes);
            nodes.forEach(detach);
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $$.fragment && $$.fragment.c();
        }
        if (options.intro)
            transition_in(component.$$.fragment);
        mount_component(component, options.target, options.anchor, options.customElement);
        flush();
    }
    set_current_component(parent_component);
}
/**
 * Base class for Svelte components. Used when dev=false.
 */
class SvelteComponent {
    $destroy() {
        destroy_component(this, 1);
        this.$destroy = noop;
    }
    $on(type, callback) {
        if (!is_function(callback)) {
            return noop;
        }
        const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
        callbacks.push(callback);
        return () => {
            const index = callbacks.indexOf(callback);
            if (index !== -1)
                callbacks.splice(index, 1);
        };
    }
    $set($$props) {
        if (this.$$set && !is_empty($$props)) {
            this.$$.skip_bound = true;
            this.$$set($$props);
            this.$$.skip_bound = false;
        }
    }
}

const subscriber_queue = [];
/**
 * Creates a `Readable` store that allows reading by subscription.
 * @param value initial value
 * @param {StartStopNotifier}start start and stop notifications for subscriptions
 */
function readable(value, start) {
    return {
        subscribe: writable(value, start).subscribe
    };
}
/**
 * Create a `Writable` store that allows both updating and reading by subscription.
 * @param {*=}value initial value
 * @param {StartStopNotifier=}start start and stop notifications for subscriptions
 */
function writable(value, start = noop) {
    let stop;
    const subscribers = new Set();
    function set(new_value) {
        if (safe_not_equal(value, new_value)) {
            value = new_value;
            if (stop) { // store is ready
                const run_queue = !subscriber_queue.length;
                for (const subscriber of subscribers) {
                    subscriber[1]();
                    subscriber_queue.push(subscriber, value);
                }
                if (run_queue) {
                    for (let i = 0; i < subscriber_queue.length; i += 2) {
                        subscriber_queue[i][0](subscriber_queue[i + 1]);
                    }
                    subscriber_queue.length = 0;
                }
            }
        }
    }
    function update(fn) {
        set(fn(value));
    }
    function subscribe(run, invalidate = noop) {
        const subscriber = [run, invalidate];
        subscribers.add(subscriber);
        if (subscribers.size === 1) {
            stop = start(set) || noop;
        }
        run(value);
        return () => {
            subscribers.delete(subscriber);
            if (subscribers.size === 0 && stop) {
                stop();
                stop = null;
            }
        };
    }
    return { set, update, subscribe };
}
function derived(stores, fn, initial_value) {
    const single = !Array.isArray(stores);
    const stores_array = single
        ? [stores]
        : stores;
    const auto = fn.length < 2;
    return readable(initial_value, (set) => {
        let started = false;
        const values = [];
        let pending = 0;
        let cleanup = noop;
        const sync = () => {
            if (pending) {
                return;
            }
            cleanup();
            const result = fn(single ? values[0] : values, set);
            if (auto) {
                set(result);
            }
            else {
                cleanup = is_function(result) ? result : noop;
            }
        };
        const unsubscribers = stores_array.map((store, i) => subscribe(store, (value) => {
            values[i] = value;
            pending &= ~(1 << i);
            if (started) {
                sync();
            }
        }, () => {
            pending |= (1 << i);
        }));
        started = true;
        sync();
        return function stop() {
            run_all(unsubscribers);
            cleanup();
            // We need to set this to false because callbacks can still happen despite having unsubscribed:
            // Callbacks might already be placed in the queue which doesn't know it should no longer
            // invoke this derived store.
            started = false;
        };
    });
}

var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
})(TYPE || (TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === 0 /* number */);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === 1 /* dateTime */);
}

// tslint:disable:only-arrow-functions
// tslint:disable:object-literal-shorthand
// tslint:disable:trailing-comma
// tslint:disable:object-literal-sort-keys
// tslint:disable:one-variable-per-declaration
// tslint:disable:max-line-length
// tslint:disable:no-consecutive-blank-lines
// tslint:disable:align
var __extends$1 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$2 = (undefined && undefined.__assign) || function () {
    __assign$2 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};
var SyntaxError = /** @class */ (function (_super) {
    __extends$1(SyntaxError, _super);
    function SyntaxError(message, expected, found, location) {
        var _this = _super.call(this) || this;
        _this.message = message;
        _this.expected = expected;
        _this.found = found;
        _this.location = location;
        _this.name = "SyntaxError";
        if (typeof Error.captureStackTrace === "function") {
            Error.captureStackTrace(_this, SyntaxError);
        }
        return _this;
    }
    SyntaxError.buildMessage = function (expected, found) {
        function hex(ch) {
            return ch.charCodeAt(0).toString(16).toUpperCase();
        }
        function literalEscape(s) {
            return s
                .replace(/\\/g, "\\\\")
                .replace(/"/g, "\\\"")
                .replace(/\0/g, "\\0")
                .replace(/\t/g, "\\t")
                .replace(/\n/g, "\\n")
                .replace(/\r/g, "\\r")
                .replace(/[\x00-\x0F]/g, function (ch) { return "\\x0" + hex(ch); })
                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) { return "\\x" + hex(ch); });
        }
        function classEscape(s) {
            return s
                .replace(/\\/g, "\\\\")
                .replace(/\]/g, "\\]")
                .replace(/\^/g, "\\^")
                .replace(/-/g, "\\-")
                .replace(/\0/g, "\\0")
                .replace(/\t/g, "\\t")
                .replace(/\n/g, "\\n")
                .replace(/\r/g, "\\r")
                .replace(/[\x00-\x0F]/g, function (ch) { return "\\x0" + hex(ch); })
                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) { return "\\x" + hex(ch); });
        }
        function describeExpectation(expectation) {
            switch (expectation.type) {
                case "literal":
                    return "\"" + literalEscape(expectation.text) + "\"";
                case "class":
                    var escapedParts = expectation.parts.map(function (part) {
                        return Array.isArray(part)
                            ? classEscape(part[0]) + "-" + classEscape(part[1])
                            : classEscape(part);
                    });
                    return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
                case "any":
                    return "any character";
                case "end":
                    return "end of input";
                case "other":
                    return expectation.description;
            }
        }
        function describeExpected(expected1) {
            var descriptions = expected1.map(describeExpectation);
            var i;
            var j;
            descriptions.sort();
            if (descriptions.length > 0) {
                for (i = 1, j = 1; i < descriptions.length; i++) {
                    if (descriptions[i - 1] !== descriptions[i]) {
                        descriptions[j] = descriptions[i];
                        j++;
                    }
                }
                descriptions.length = j;
            }
            switch (descriptions.length) {
                case 1:
                    return descriptions[0];
                case 2:
                    return descriptions[0] + " or " + descriptions[1];
                default:
                    return descriptions.slice(0, -1).join(", ")
                        + ", or "
                        + descriptions[descriptions.length - 1];
            }
        }
        function describeFound(found1) {
            return found1 ? "\"" + literalEscape(found1) + "\"" : "end of input";
        }
        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
    };
    return SyntaxError;
}(Error));
function peg$parse(input, options) {
    options = options !== undefined ? options : {};
    var peg$FAILED = {};
    var peg$startRuleFunctions = { start: peg$parsestart };
    var peg$startRuleFunction = peg$parsestart;
    var peg$c0 = function (parts) {
        return parts.join('');
    };
    var peg$c1 = function (messageText) {
        return __assign$2({ type: TYPE.literal, value: messageText }, insertLocation());
    };
    var peg$c2 = "#";
    var peg$c3 = peg$literalExpectation("#", false);
    var peg$c4 = function () {
        return __assign$2({ type: TYPE.pound }, insertLocation());
    };
    var peg$c5 = peg$otherExpectation("argumentElement");
    var peg$c6 = "{";
    var peg$c7 = peg$literalExpectation("{", false);
    var peg$c8 = "}";
    var peg$c9 = peg$literalExpectation("}", false);
    var peg$c10 = function (value) {
        return __assign$2({ type: TYPE.argument, value: value }, insertLocation());
    };
    var peg$c11 = peg$otherExpectation("numberSkeletonId");
    var peg$c12 = /^['\/{}]/;
    var peg$c13 = peg$classExpectation(["'", "/", "{", "}"], false, false);
    var peg$c14 = peg$anyExpectation();
    var peg$c15 = peg$otherExpectation("numberSkeletonTokenOption");
    var peg$c16 = "/";
    var peg$c17 = peg$literalExpectation("/", false);
    var peg$c18 = function (option) { return option; };
    var peg$c19 = peg$otherExpectation("numberSkeletonToken");
    var peg$c20 = function (stem, options) {
        return { stem: stem, options: options };
    };
    var peg$c21 = function (tokens) {
        return __assign$2({ type: 0 /* number */, tokens: tokens }, insertLocation());
    };
    var peg$c22 = "::";
    var peg$c23 = peg$literalExpectation("::", false);
    var peg$c24 = function (skeleton) { return skeleton; };
    var peg$c25 = function () { messageCtx.push('numberArgStyle'); return true; };
    var peg$c26 = function (style) {
        messageCtx.pop();
        return style.replace(/\s*$/, '');
    };
    var peg$c27 = ",";
    var peg$c28 = peg$literalExpectation(",", false);
    var peg$c29 = "number";
    var peg$c30 = peg$literalExpectation("number", false);
    var peg$c31 = function (value, type, style) {
        return __assign$2({ type: type === 'number' ? TYPE.number : type === 'date' ? TYPE.date : TYPE.time, style: style && style[2], value: value }, insertLocation());
    };
    var peg$c32 = "'";
    var peg$c33 = peg$literalExpectation("'", false);
    var peg$c34 = /^[^']/;
    var peg$c35 = peg$classExpectation(["'"], true, false);
    var peg$c36 = /^[^a-zA-Z'{}]/;
    var peg$c37 = peg$classExpectation([["a", "z"], ["A", "Z"], "'", "{", "}"], true, false);
    var peg$c38 = /^[a-zA-Z]/;
    var peg$c39 = peg$classExpectation([["a", "z"], ["A", "Z"]], false, false);
    var peg$c40 = function (pattern) {
        return __assign$2({ type: 1 /* dateTime */, pattern: pattern }, insertLocation());
    };
    var peg$c41 = function () { messageCtx.push('dateOrTimeArgStyle'); return true; };
    var peg$c42 = "date";
    var peg$c43 = peg$literalExpectation("date", false);
    var peg$c44 = "time";
    var peg$c45 = peg$literalExpectation("time", false);
    var peg$c46 = "plural";
    var peg$c47 = peg$literalExpectation("plural", false);
    var peg$c48 = "selectordinal";
    var peg$c49 = peg$literalExpectation("selectordinal", false);
    var peg$c50 = "offset:";
    var peg$c51 = peg$literalExpectation("offset:", false);
    var peg$c52 = function (value, pluralType, offset, options) {
        return __assign$2({ type: TYPE.plural, pluralType: pluralType === 'plural' ? 'cardinal' : 'ordinal', value: value, offset: offset ? offset[2] : 0, options: options.reduce(function (all, _a) {
                var id = _a.id, value = _a.value, optionLocation = _a.location;
                if (id in all) {
                    error("Duplicate option \"" + id + "\" in plural element: \"" + text() + "\"", location());
                }
                all[id] = {
                    value: value,
                    location: optionLocation
                };
                return all;
            }, {}) }, insertLocation());
    };
    var peg$c53 = "select";
    var peg$c54 = peg$literalExpectation("select", false);
    var peg$c55 = function (value, options) {
        return __assign$2({ type: TYPE.select, value: value, options: options.reduce(function (all, _a) {
                var id = _a.id, value = _a.value, optionLocation = _a.location;
                if (id in all) {
                    error("Duplicate option \"" + id + "\" in select element: \"" + text() + "\"", location());
                }
                all[id] = {
                    value: value,
                    location: optionLocation
                };
                return all;
            }, {}) }, insertLocation());
    };
    var peg$c56 = "=";
    var peg$c57 = peg$literalExpectation("=", false);
    var peg$c58 = function (id) { messageCtx.push('select'); return true; };
    var peg$c59 = function (id, value) {
        messageCtx.pop();
        return __assign$2({ id: id,
            value: value }, insertLocation());
    };
    var peg$c60 = function (id) { messageCtx.push('plural'); return true; };
    var peg$c61 = function (id, value) {
        messageCtx.pop();
        return __assign$2({ id: id,
            value: value }, insertLocation());
    };
    var peg$c62 = peg$otherExpectation("whitespace");
    var peg$c63 = /^[\t-\r \x85\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;
    var peg$c64 = peg$classExpectation([["\t", "\r"], " ", "\x85", "\xA0", "\u1680", ["\u2000", "\u200A"], "\u2028", "\u2029", "\u202F", "\u205F", "\u3000"], false, false);
    var peg$c65 = peg$otherExpectation("syntax pattern");
    var peg$c66 = /^[!-\/:-@[-\^`{-~\xA1-\xA7\xA9\xAB\xAC\xAE\xB0\xB1\xB6\xBB\xBF\xD7\xF7\u2010-\u2027\u2030-\u203E\u2041-\u2053\u2055-\u205E\u2190-\u245F\u2500-\u2775\u2794-\u2BFF\u2E00-\u2E7F\u3001-\u3003\u3008-\u3020\u3030\uFD3E\uFD3F\uFE45\uFE46]/;
    var peg$c67 = peg$classExpectation([["!", "/"], [":", "@"], ["[", "^"], "`", ["{", "~"], ["\xA1", "\xA7"], "\xA9", "\xAB", "\xAC", "\xAE", "\xB0", "\xB1", "\xB6", "\xBB", "\xBF", "\xD7", "\xF7", ["\u2010", "\u2027"], ["\u2030", "\u203E"], ["\u2041", "\u2053"], ["\u2055", "\u205E"], ["\u2190", "\u245F"], ["\u2500", "\u2775"], ["\u2794", "\u2BFF"], ["\u2E00", "\u2E7F"], ["\u3001", "\u3003"], ["\u3008", "\u3020"], "\u3030", "\uFD3E", "\uFD3F", "\uFE45", "\uFE46"], false, false);
    var peg$c68 = peg$otherExpectation("optional whitespace");
    var peg$c69 = peg$otherExpectation("number");
    var peg$c70 = "-";
    var peg$c71 = peg$literalExpectation("-", false);
    var peg$c72 = function (negative, num) {
        return num
            ? negative
                ? -num
                : num
            : 0;
    };
    var peg$c74 = peg$otherExpectation("double apostrophes");
    var peg$c75 = "''";
    var peg$c76 = peg$literalExpectation("''", false);
    var peg$c77 = function () { return "'"; };
    var peg$c78 = function (escapedChar, quotedChars) {
        return escapedChar + quotedChars.replace("''", "'");
    };
    var peg$c79 = function (x) {
        return (x !== '{' &&
            !(isInPluralOption() && x === '#') &&
            !(isNestedMessageText() && x === '}'));
    };
    var peg$c80 = "\n";
    var peg$c81 = peg$literalExpectation("\n", false);
    var peg$c82 = function (x) {
        return x === '{' || x === '}' || (isInPluralOption() && x === '#');
    };
    var peg$c83 = peg$otherExpectation("argNameOrNumber");
    var peg$c84 = peg$otherExpectation("argNumber");
    var peg$c85 = "0";
    var peg$c86 = peg$literalExpectation("0", false);
    var peg$c87 = function () { return 0; };
    var peg$c88 = /^[1-9]/;
    var peg$c89 = peg$classExpectation([["1", "9"]], false, false);
    var peg$c90 = /^[0-9]/;
    var peg$c91 = peg$classExpectation([["0", "9"]], false, false);
    var peg$c92 = function (digits) {
        return parseInt(digits.join(''), 10);
    };
    var peg$c93 = peg$otherExpectation("argName");
    var peg$currPos = 0;
    var peg$savedPos = 0;
    var peg$posDetailsCache = [{ line: 1, column: 1 }];
    var peg$maxFailPos = 0;
    var peg$maxFailExpected = [];
    var peg$silentFails = 0;
    var peg$result;
    if (options.startRule !== undefined) {
        if (!(options.startRule in peg$startRuleFunctions)) {
            throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
        }
        peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }
    function text() {
        return input.substring(peg$savedPos, peg$currPos);
    }
    function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos);
    }
    function error(message, location1) {
        location1 = location1 !== undefined
            ? location1
            : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildSimpleError(message, location1);
    }
    function peg$literalExpectation(text1, ignoreCase) {
        return { type: "literal", text: text1, ignoreCase: ignoreCase };
    }
    function peg$classExpectation(parts, inverted, ignoreCase) {
        return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
    }
    function peg$anyExpectation() {
        return { type: "any" };
    }
    function peg$endExpectation() {
        return { type: "end" };
    }
    function peg$otherExpectation(description) {
        return { type: "other", description: description };
    }
    function peg$computePosDetails(pos) {
        var details = peg$posDetailsCache[pos];
        var p;
        if (details) {
            return details;
        }
        else {
            p = pos - 1;
            while (!peg$posDetailsCache[p]) {
                p--;
            }
            details = peg$posDetailsCache[p];
            details = {
                line: details.line,
                column: details.column
            };
            while (p < pos) {
                if (input.charCodeAt(p) === 10) {
                    details.line++;
                    details.column = 1;
                }
                else {
                    details.column++;
                }
                p++;
            }
            peg$posDetailsCache[pos] = details;
            return details;
        }
    }
    function peg$computeLocation(startPos, endPos) {
        var startPosDetails = peg$computePosDetails(startPos);
        var endPosDetails = peg$computePosDetails(endPos);
        return {
            start: {
                offset: startPos,
                line: startPosDetails.line,
                column: startPosDetails.column
            },
            end: {
                offset: endPos,
                line: endPosDetails.line,
                column: endPosDetails.column
            }
        };
    }
    function peg$fail(expected1) {
        if (peg$currPos < peg$maxFailPos) {
            return;
        }
        if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
        }
        peg$maxFailExpected.push(expected1);
    }
    function peg$buildSimpleError(message, location1) {
        return new SyntaxError(message, [], "", location1);
    }
    function peg$buildStructuredError(expected1, found, location1) {
        return new SyntaxError(SyntaxError.buildMessage(expected1, found), expected1, found, location1);
    }
    function peg$parsestart() {
        var s0;
        s0 = peg$parsemessage();
        return s0;
    }
    function peg$parsemessage() {
        var s0, s1;
        s0 = [];
        s1 = peg$parsemessageElement();
        while (s1 !== peg$FAILED) {
            s0.push(s1);
            s1 = peg$parsemessageElement();
        }
        return s0;
    }
    function peg$parsemessageElement() {
        var s0;
        s0 = peg$parseliteralElement();
        if (s0 === peg$FAILED) {
            s0 = peg$parseargumentElement();
            if (s0 === peg$FAILED) {
                s0 = peg$parsesimpleFormatElement();
                if (s0 === peg$FAILED) {
                    s0 = peg$parsepluralElement();
                    if (s0 === peg$FAILED) {
                        s0 = peg$parseselectElement();
                        if (s0 === peg$FAILED) {
                            s0 = peg$parsepoundElement();
                        }
                    }
                }
            }
        }
        return s0;
    }
    function peg$parsemessageText() {
        var s0, s1, s2;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsedoubleApostrophes();
        if (s2 === peg$FAILED) {
            s2 = peg$parsequotedString();
            if (s2 === peg$FAILED) {
                s2 = peg$parseunquotedString();
            }
        }
        if (s2 !== peg$FAILED) {
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$parsedoubleApostrophes();
                if (s2 === peg$FAILED) {
                    s2 = peg$parsequotedString();
                    if (s2 === peg$FAILED) {
                        s2 = peg$parseunquotedString();
                    }
                }
            }
        }
        else {
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c0(s1);
        }
        s0 = s1;
        return s0;
    }
    function peg$parseliteralElement() {
        var s0, s1;
        s0 = peg$currPos;
        s1 = peg$parsemessageText();
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c1(s1);
        }
        s0 = s1;
        return s0;
    }
    function peg$parsepoundElement() {
        var s0, s1;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 35) {
            s1 = peg$c2;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c3);
            }
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c4();
        }
        s0 = s1;
        return s0;
    }
    function peg$parseargumentElement() {
        var s0, s1, s2, s3, s4, s5;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
            s1 = peg$c6;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c7);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseargNameOrNumber();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 125) {
                            s5 = peg$c8;
                            peg$currPos++;
                        }
                        else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c9);
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c10(s3);
                            s0 = s1;
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c5);
            }
        }
        return s0;
    }
    function peg$parsenumberSkeletonId() {
        var s0, s1, s2, s3, s4;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$currPos;
        s3 = peg$currPos;
        peg$silentFails++;
        s4 = peg$parsewhiteSpace();
        if (s4 === peg$FAILED) {
            if (peg$c12.test(input.charAt(peg$currPos))) {
                s4 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c13);
                }
            }
        }
        peg$silentFails--;
        if (s4 === peg$FAILED) {
            s3 = undefined;
        }
        else {
            peg$currPos = s3;
            s3 = peg$FAILED;
        }
        if (s3 !== peg$FAILED) {
            if (input.length > peg$currPos) {
                s4 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c14);
                }
            }
            if (s4 !== peg$FAILED) {
                s3 = [s3, s4];
                s2 = s3;
            }
            else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s2;
            s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$currPos;
                s3 = peg$currPos;
                peg$silentFails++;
                s4 = peg$parsewhiteSpace();
                if (s4 === peg$FAILED) {
                    if (peg$c12.test(input.charAt(peg$currPos))) {
                        s4 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c13);
                        }
                    }
                }
                peg$silentFails--;
                if (s4 === peg$FAILED) {
                    s3 = undefined;
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
                if (s3 !== peg$FAILED) {
                    if (input.length > peg$currPos) {
                        s4 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c14);
                        }
                    }
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            }
        }
        else {
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c11);
            }
        }
        return s0;
    }
    function peg$parsenumberSkeletonTokenOption() {
        var s0, s1, s2;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 47) {
            s1 = peg$c16;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c17);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsenumberSkeletonId();
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c18(s2);
                s0 = s1;
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c15);
            }
        }
        return s0;
    }
    function peg$parsenumberSkeletonToken() {
        var s0, s1, s2, s3, s4;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parse_();
        if (s1 !== peg$FAILED) {
            s2 = peg$parsenumberSkeletonId();
            if (s2 !== peg$FAILED) {
                s3 = [];
                s4 = peg$parsenumberSkeletonTokenOption();
                while (s4 !== peg$FAILED) {
                    s3.push(s4);
                    s4 = peg$parsenumberSkeletonTokenOption();
                }
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c20(s2, s3);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c19);
            }
        }
        return s0;
    }
    function peg$parsenumberSkeleton() {
        var s0, s1, s2;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsenumberSkeletonToken();
        if (s2 !== peg$FAILED) {
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$parsenumberSkeletonToken();
            }
        }
        else {
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c21(s1);
        }
        s0 = s1;
        return s0;
    }
    function peg$parsenumberArgStyle() {
        var s0, s1, s2;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c22) {
            s1 = peg$c22;
            peg$currPos += 2;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c23);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsenumberSkeleton();
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s2);
                s0 = s1;
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            peg$savedPos = peg$currPos;
            s1 = peg$c25();
            if (s1) {
                s1 = undefined;
            }
            else {
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parsemessageText();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c26(s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parsenumberFormatElement() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
            s1 = peg$c6;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c7);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseargNameOrNumber();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s5 = peg$c27;
                            peg$currPos++;
                        }
                        else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c28);
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parse_();
                            if (s6 !== peg$FAILED) {
                                if (input.substr(peg$currPos, 6) === peg$c29) {
                                    s7 = peg$c29;
                                    peg$currPos += 6;
                                }
                                else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c30);
                                    }
                                }
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parse_();
                                    if (s8 !== peg$FAILED) {
                                        s9 = peg$currPos;
                                        if (input.charCodeAt(peg$currPos) === 44) {
                                            s10 = peg$c27;
                                            peg$currPos++;
                                        }
                                        else {
                                            s10 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c28);
                                            }
                                        }
                                        if (s10 !== peg$FAILED) {
                                            s11 = peg$parse_();
                                            if (s11 !== peg$FAILED) {
                                                s12 = peg$parsenumberArgStyle();
                                                if (s12 !== peg$FAILED) {
                                                    s10 = [s10, s11, s12];
                                                    s9 = s10;
                                                }
                                                else {
                                                    peg$currPos = s9;
                                                    s9 = peg$FAILED;
                                                }
                                            }
                                            else {
                                                peg$currPos = s9;
                                                s9 = peg$FAILED;
                                            }
                                        }
                                        else {
                                            peg$currPos = s9;
                                            s9 = peg$FAILED;
                                        }
                                        if (s9 === peg$FAILED) {
                                            s9 = null;
                                        }
                                        if (s9 !== peg$FAILED) {
                                            s10 = peg$parse_();
                                            if (s10 !== peg$FAILED) {
                                                if (input.charCodeAt(peg$currPos) === 125) {
                                                    s11 = peg$c8;
                                                    peg$currPos++;
                                                }
                                                else {
                                                    s11 = peg$FAILED;
                                                    if (peg$silentFails === 0) {
                                                        peg$fail(peg$c9);
                                                    }
                                                }
                                                if (s11 !== peg$FAILED) {
                                                    peg$savedPos = s0;
                                                    s1 = peg$c31(s3, s7, s9);
                                                    s0 = s1;
                                                }
                                                else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            }
                                            else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        }
                                        else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsedateTimeSkeletonLiteral() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 39) {
            s1 = peg$c32;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c33);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsedoubleApostrophes();
            if (s3 === peg$FAILED) {
                if (peg$c34.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c35);
                    }
                }
            }
            if (s3 !== peg$FAILED) {
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parsedoubleApostrophes();
                    if (s3 === peg$FAILED) {
                        if (peg$c34.test(input.charAt(peg$currPos))) {
                            s3 = input.charAt(peg$currPos);
                            peg$currPos++;
                        }
                        else {
                            s3 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c35);
                            }
                        }
                    }
                }
            }
            else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 39) {
                    s3 = peg$c32;
                    peg$currPos++;
                }
                else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c33);
                    }
                }
                if (s3 !== peg$FAILED) {
                    s1 = [s1, s2, s3];
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = [];
            s1 = peg$parsedoubleApostrophes();
            if (s1 === peg$FAILED) {
                if (peg$c36.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c37);
                    }
                }
            }
            if (s1 !== peg$FAILED) {
                while (s1 !== peg$FAILED) {
                    s0.push(s1);
                    s1 = peg$parsedoubleApostrophes();
                    if (s1 === peg$FAILED) {
                        if (peg$c36.test(input.charAt(peg$currPos))) {
                            s1 = input.charAt(peg$currPos);
                            peg$currPos++;
                        }
                        else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c37);
                            }
                        }
                    }
                }
            }
            else {
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parsedateTimeSkeletonPattern() {
        var s0, s1;
        s0 = [];
        if (peg$c38.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c39);
            }
        }
        if (s1 !== peg$FAILED) {
            while (s1 !== peg$FAILED) {
                s0.push(s1);
                if (peg$c38.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c39);
                    }
                }
            }
        }
        else {
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsedateTimeSkeleton() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = peg$parsedateTimeSkeletonLiteral();
        if (s3 === peg$FAILED) {
            s3 = peg$parsedateTimeSkeletonPattern();
        }
        if (s3 !== peg$FAILED) {
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$parsedateTimeSkeletonLiteral();
                if (s3 === peg$FAILED) {
                    s3 = peg$parsedateTimeSkeletonPattern();
                }
            }
        }
        else {
            s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
            s1 = input.substring(s1, peg$currPos);
        }
        else {
            s1 = s2;
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c40(s1);
        }
        s0 = s1;
        return s0;
    }
    function peg$parsedateOrTimeArgStyle() {
        var s0, s1, s2;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c22) {
            s1 = peg$c22;
            peg$currPos += 2;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c23);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsedateTimeSkeleton();
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s2);
                s0 = s1;
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            peg$savedPos = peg$currPos;
            s1 = peg$c41();
            if (s1) {
                s1 = undefined;
            }
            else {
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parsemessageText();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c26(s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parsedateOrTimeFormatElement() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
            s1 = peg$c6;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c7);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseargNameOrNumber();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s5 = peg$c27;
                            peg$currPos++;
                        }
                        else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c28);
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parse_();
                            if (s6 !== peg$FAILED) {
                                if (input.substr(peg$currPos, 4) === peg$c42) {
                                    s7 = peg$c42;
                                    peg$currPos += 4;
                                }
                                else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c43);
                                    }
                                }
                                if (s7 === peg$FAILED) {
                                    if (input.substr(peg$currPos, 4) === peg$c44) {
                                        s7 = peg$c44;
                                        peg$currPos += 4;
                                    }
                                    else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$c45);
                                        }
                                    }
                                }
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parse_();
                                    if (s8 !== peg$FAILED) {
                                        s9 = peg$currPos;
                                        if (input.charCodeAt(peg$currPos) === 44) {
                                            s10 = peg$c27;
                                            peg$currPos++;
                                        }
                                        else {
                                            s10 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c28);
                                            }
                                        }
                                        if (s10 !== peg$FAILED) {
                                            s11 = peg$parse_();
                                            if (s11 !== peg$FAILED) {
                                                s12 = peg$parsedateOrTimeArgStyle();
                                                if (s12 !== peg$FAILED) {
                                                    s10 = [s10, s11, s12];
                                                    s9 = s10;
                                                }
                                                else {
                                                    peg$currPos = s9;
                                                    s9 = peg$FAILED;
                                                }
                                            }
                                            else {
                                                peg$currPos = s9;
                                                s9 = peg$FAILED;
                                            }
                                        }
                                        else {
                                            peg$currPos = s9;
                                            s9 = peg$FAILED;
                                        }
                                        if (s9 === peg$FAILED) {
                                            s9 = null;
                                        }
                                        if (s9 !== peg$FAILED) {
                                            s10 = peg$parse_();
                                            if (s10 !== peg$FAILED) {
                                                if (input.charCodeAt(peg$currPos) === 125) {
                                                    s11 = peg$c8;
                                                    peg$currPos++;
                                                }
                                                else {
                                                    s11 = peg$FAILED;
                                                    if (peg$silentFails === 0) {
                                                        peg$fail(peg$c9);
                                                    }
                                                }
                                                if (s11 !== peg$FAILED) {
                                                    peg$savedPos = s0;
                                                    s1 = peg$c31(s3, s7, s9);
                                                    s0 = s1;
                                                }
                                                else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            }
                                            else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        }
                                        else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsesimpleFormatElement() {
        var s0;
        s0 = peg$parsenumberFormatElement();
        if (s0 === peg$FAILED) {
            s0 = peg$parsedateOrTimeFormatElement();
        }
        return s0;
    }
    function peg$parsepluralElement() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
            s1 = peg$c6;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c7);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseargNameOrNumber();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s5 = peg$c27;
                            peg$currPos++;
                        }
                        else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c28);
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parse_();
                            if (s6 !== peg$FAILED) {
                                if (input.substr(peg$currPos, 6) === peg$c46) {
                                    s7 = peg$c46;
                                    peg$currPos += 6;
                                }
                                else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c47);
                                    }
                                }
                                if (s7 === peg$FAILED) {
                                    if (input.substr(peg$currPos, 13) === peg$c48) {
                                        s7 = peg$c48;
                                        peg$currPos += 13;
                                    }
                                    else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$c49);
                                        }
                                    }
                                }
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parse_();
                                    if (s8 !== peg$FAILED) {
                                        if (input.charCodeAt(peg$currPos) === 44) {
                                            s9 = peg$c27;
                                            peg$currPos++;
                                        }
                                        else {
                                            s9 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c28);
                                            }
                                        }
                                        if (s9 !== peg$FAILED) {
                                            s10 = peg$parse_();
                                            if (s10 !== peg$FAILED) {
                                                s11 = peg$currPos;
                                                if (input.substr(peg$currPos, 7) === peg$c50) {
                                                    s12 = peg$c50;
                                                    peg$currPos += 7;
                                                }
                                                else {
                                                    s12 = peg$FAILED;
                                                    if (peg$silentFails === 0) {
                                                        peg$fail(peg$c51);
                                                    }
                                                }
                                                if (s12 !== peg$FAILED) {
                                                    s13 = peg$parse_();
                                                    if (s13 !== peg$FAILED) {
                                                        s14 = peg$parsenumber();
                                                        if (s14 !== peg$FAILED) {
                                                            s12 = [s12, s13, s14];
                                                            s11 = s12;
                                                        }
                                                        else {
                                                            peg$currPos = s11;
                                                            s11 = peg$FAILED;
                                                        }
                                                    }
                                                    else {
                                                        peg$currPos = s11;
                                                        s11 = peg$FAILED;
                                                    }
                                                }
                                                else {
                                                    peg$currPos = s11;
                                                    s11 = peg$FAILED;
                                                }
                                                if (s11 === peg$FAILED) {
                                                    s11 = null;
                                                }
                                                if (s11 !== peg$FAILED) {
                                                    s12 = peg$parse_();
                                                    if (s12 !== peg$FAILED) {
                                                        s13 = [];
                                                        s14 = peg$parsepluralOption();
                                                        if (s14 !== peg$FAILED) {
                                                            while (s14 !== peg$FAILED) {
                                                                s13.push(s14);
                                                                s14 = peg$parsepluralOption();
                                                            }
                                                        }
                                                        else {
                                                            s13 = peg$FAILED;
                                                        }
                                                        if (s13 !== peg$FAILED) {
                                                            s14 = peg$parse_();
                                                            if (s14 !== peg$FAILED) {
                                                                if (input.charCodeAt(peg$currPos) === 125) {
                                                                    s15 = peg$c8;
                                                                    peg$currPos++;
                                                                }
                                                                else {
                                                                    s15 = peg$FAILED;
                                                                    if (peg$silentFails === 0) {
                                                                        peg$fail(peg$c9);
                                                                    }
                                                                }
                                                                if (s15 !== peg$FAILED) {
                                                                    peg$savedPos = s0;
                                                                    s1 = peg$c52(s3, s7, s11, s13);
                                                                    s0 = s1;
                                                                }
                                                                else {
                                                                    peg$currPos = s0;
                                                                    s0 = peg$FAILED;
                                                                }
                                                            }
                                                            else {
                                                                peg$currPos = s0;
                                                                s0 = peg$FAILED;
                                                            }
                                                        }
                                                        else {
                                                            peg$currPos = s0;
                                                            s0 = peg$FAILED;
                                                        }
                                                    }
                                                    else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                    }
                                                }
                                                else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            }
                                            else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        }
                                        else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseselectElement() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
            s1 = peg$c6;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c7);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (s2 !== peg$FAILED) {
                s3 = peg$parseargNameOrNumber();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s5 = peg$c27;
                            peg$currPos++;
                        }
                        else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c28);
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parse_();
                            if (s6 !== peg$FAILED) {
                                if (input.substr(peg$currPos, 6) === peg$c53) {
                                    s7 = peg$c53;
                                    peg$currPos += 6;
                                }
                                else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c54);
                                    }
                                }
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parse_();
                                    if (s8 !== peg$FAILED) {
                                        if (input.charCodeAt(peg$currPos) === 44) {
                                            s9 = peg$c27;
                                            peg$currPos++;
                                        }
                                        else {
                                            s9 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c28);
                                            }
                                        }
                                        if (s9 !== peg$FAILED) {
                                            s10 = peg$parse_();
                                            if (s10 !== peg$FAILED) {
                                                s11 = [];
                                                s12 = peg$parseselectOption();
                                                if (s12 !== peg$FAILED) {
                                                    while (s12 !== peg$FAILED) {
                                                        s11.push(s12);
                                                        s12 = peg$parseselectOption();
                                                    }
                                                }
                                                else {
                                                    s11 = peg$FAILED;
                                                }
                                                if (s11 !== peg$FAILED) {
                                                    s12 = peg$parse_();
                                                    if (s12 !== peg$FAILED) {
                                                        if (input.charCodeAt(peg$currPos) === 125) {
                                                            s13 = peg$c8;
                                                            peg$currPos++;
                                                        }
                                                        else {
                                                            s13 = peg$FAILED;
                                                            if (peg$silentFails === 0) {
                                                                peg$fail(peg$c9);
                                                            }
                                                        }
                                                        if (s13 !== peg$FAILED) {
                                                            peg$savedPos = s0;
                                                            s1 = peg$c55(s3, s11);
                                                            s0 = s1;
                                                        }
                                                        else {
                                                            peg$currPos = s0;
                                                            s0 = peg$FAILED;
                                                        }
                                                    }
                                                    else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                    }
                                                }
                                                else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            }
                                            else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        }
                                        else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsepluralRuleSelectValue() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 61) {
            s2 = peg$c56;
            peg$currPos++;
        }
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c57);
            }
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parsenumber();
            if (s3 !== peg$FAILED) {
                s2 = [s2, s3];
                s1 = s2;
            }
            else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$parseargName();
        }
        return s0;
    }
    function peg$parseselectOption() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = peg$parse_();
        if (s1 !== peg$FAILED) {
            s2 = peg$parseargName();
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 123) {
                        s4 = peg$c6;
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c7);
                        }
                    }
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = peg$currPos;
                        s5 = peg$c58();
                        if (s5) {
                            s5 = undefined;
                        }
                        else {
                            s5 = peg$FAILED;
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parsemessage();
                            if (s6 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 125) {
                                    s7 = peg$c8;
                                    peg$currPos++;
                                }
                                else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c9);
                                    }
                                }
                                if (s7 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c59(s2, s6);
                                    s0 = s1;
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsepluralOption() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = peg$parse_();
        if (s1 !== peg$FAILED) {
            s2 = peg$parsepluralRuleSelectValue();
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 123) {
                        s4 = peg$c6;
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c7);
                        }
                    }
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = peg$currPos;
                        s5 = peg$c60();
                        if (s5) {
                            s5 = undefined;
                        }
                        else {
                            s5 = peg$FAILED;
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parsemessage();
                            if (s6 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 125) {
                                    s7 = peg$c8;
                                    peg$currPos++;
                                }
                                else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c9);
                                    }
                                }
                                if (s7 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c61(s2, s6);
                                    s0 = s1;
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsewhiteSpace() {
        var s0;
        peg$silentFails++;
        if (peg$c63.test(input.charAt(peg$currPos))) {
            s0 = input.charAt(peg$currPos);
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c64);
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            if (peg$silentFails === 0) {
                peg$fail(peg$c62);
            }
        }
        return s0;
    }
    function peg$parsepatternSyntax() {
        var s0;
        peg$silentFails++;
        if (peg$c66.test(input.charAt(peg$currPos))) {
            s0 = input.charAt(peg$currPos);
            peg$currPos++;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c67);
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            if (peg$silentFails === 0) {
                peg$fail(peg$c65);
            }
        }
        return s0;
    }
    function peg$parse_() {
        var s0, s1, s2;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsewhiteSpace();
        while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parsewhiteSpace();
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c68);
            }
        }
        return s0;
    }
    function peg$parsenumber() {
        var s0, s1, s2;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 45) {
            s1 = peg$c70;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c71);
            }
        }
        if (s1 === peg$FAILED) {
            s1 = null;
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parseargNumber();
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c72(s1, s2);
                s0 = s1;
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c69);
            }
        }
        return s0;
    }
    function peg$parsedoubleApostrophes() {
        var s0, s1;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c75) {
            s1 = peg$c75;
            peg$currPos += 2;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c76);
            }
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c77();
        }
        s0 = s1;
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c74);
            }
        }
        return s0;
    }
    function peg$parsequotedString() {
        var s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 39) {
            s1 = peg$c32;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c33);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parseescapedChar();
            if (s2 !== peg$FAILED) {
                s3 = peg$currPos;
                s4 = [];
                if (input.substr(peg$currPos, 2) === peg$c75) {
                    s5 = peg$c75;
                    peg$currPos += 2;
                }
                else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c76);
                    }
                }
                if (s5 === peg$FAILED) {
                    if (peg$c34.test(input.charAt(peg$currPos))) {
                        s5 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c35);
                        }
                    }
                }
                while (s5 !== peg$FAILED) {
                    s4.push(s5);
                    if (input.substr(peg$currPos, 2) === peg$c75) {
                        s5 = peg$c75;
                        peg$currPos += 2;
                    }
                    else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c76);
                        }
                    }
                    if (s5 === peg$FAILED) {
                        if (peg$c34.test(input.charAt(peg$currPos))) {
                            s5 = input.charAt(peg$currPos);
                            peg$currPos++;
                        }
                        else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c35);
                            }
                        }
                    }
                }
                if (s4 !== peg$FAILED) {
                    s3 = input.substring(s3, peg$currPos);
                }
                else {
                    s3 = s4;
                }
                if (s3 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 39) {
                        s4 = peg$c32;
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c33);
                        }
                    }
                    if (s4 === peg$FAILED) {
                        s4 = null;
                    }
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c78(s2, s3);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseunquotedString() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        if (input.length > peg$currPos) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
        }
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c14);
            }
        }
        if (s2 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s3 = peg$c79(s2);
            if (s3) {
                s3 = undefined;
            }
            else {
                s3 = peg$FAILED;
            }
            if (s3 !== peg$FAILED) {
                s2 = [s2, s3];
                s1 = s2;
            }
            else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 10) {
                s1 = peg$c80;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c81);
                }
            }
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        return s0;
    }
    function peg$parseescapedChar() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        if (input.length > peg$currPos) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
        }
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c14);
            }
        }
        if (s2 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s3 = peg$c82(s2);
            if (s3) {
                s3 = undefined;
            }
            else {
                s3 = peg$FAILED;
            }
            if (s3 !== peg$FAILED) {
                s2 = [s2, s3];
                s1 = s2;
            }
            else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        return s0;
    }
    function peg$parseargNameOrNumber() {
        var s0, s1;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parseargNumber();
        if (s1 === peg$FAILED) {
            s1 = peg$parseargName();
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c83);
            }
        }
        return s0;
    }
    function peg$parseargNumber() {
        var s0, s1, s2, s3, s4;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 48) {
            s1 = peg$c85;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c86);
            }
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c87();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$currPos;
            if (peg$c88.test(input.charAt(peg$currPos))) {
                s2 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c89);
                }
            }
            if (s2 !== peg$FAILED) {
                s3 = [];
                if (peg$c90.test(input.charAt(peg$currPos))) {
                    s4 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c91);
                    }
                }
                while (s4 !== peg$FAILED) {
                    s3.push(s4);
                    if (peg$c90.test(input.charAt(peg$currPos))) {
                        s4 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c91);
                        }
                    }
                }
                if (s3 !== peg$FAILED) {
                    s2 = [s2, s3];
                    s1 = s2;
                }
                else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c92(s1);
            }
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c84);
            }
        }
        return s0;
    }
    function peg$parseargName() {
        var s0, s1, s2, s3, s4;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$currPos;
        s3 = peg$currPos;
        peg$silentFails++;
        s4 = peg$parsewhiteSpace();
        if (s4 === peg$FAILED) {
            s4 = peg$parsepatternSyntax();
        }
        peg$silentFails--;
        if (s4 === peg$FAILED) {
            s3 = undefined;
        }
        else {
            peg$currPos = s3;
            s3 = peg$FAILED;
        }
        if (s3 !== peg$FAILED) {
            if (input.length > peg$currPos) {
                s4 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c14);
                }
            }
            if (s4 !== peg$FAILED) {
                s3 = [s3, s4];
                s2 = s3;
            }
            else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s2;
            s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$currPos;
                s3 = peg$currPos;
                peg$silentFails++;
                s4 = peg$parsewhiteSpace();
                if (s4 === peg$FAILED) {
                    s4 = peg$parsepatternSyntax();
                }
                peg$silentFails--;
                if (s4 === peg$FAILED) {
                    s3 = undefined;
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
                if (s3 !== peg$FAILED) {
                    if (input.length > peg$currPos) {
                        s4 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c14);
                        }
                    }
                    if (s4 !== peg$FAILED) {
                        s3 = [s3, s4];
                        s2 = s3;
                    }
                    else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            }
        }
        else {
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
        }
        else {
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$c93);
            }
        }
        return s0;
    }
    var messageCtx = ['root'];
    function isNestedMessageText() {
        return messageCtx.length > 1;
    }
    function isInPluralOption() {
        return messageCtx[messageCtx.length - 1] === 'plural';
    }
    function insertLocation() {
        return options && options.captureLocation ? {
            location: location()
        } : {};
    }
    peg$result = peg$startRuleFunction();
    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
        return peg$result;
    }
    else {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) {
            peg$fail(peg$endExpectation());
        }
        throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length
            ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
            : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
}
var pegParse = peg$parse;

var __spreadArrays$2 = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var PLURAL_HASHTAG_REGEX = /(^|[^\\])#/g;
/**
 * Whether to convert `#` in plural rule options
 * to `{var, number}`
 * @param el AST Element
 * @param pluralStack current plural stack
 */
function normalizeHashtagInPlural(els) {
    els.forEach(function (el) {
        // If we're encountering a plural el
        if (!isPluralElement(el) && !isSelectElement(el)) {
            return;
        }
        // Go down the options and search for # in any literal element
        Object.keys(el.options).forEach(function (id) {
            var _a;
            var opt = el.options[id];
            // If we got a match, we have to split this
            // and inject a NumberElement in the middle
            var matchingLiteralElIndex = -1;
            var literalEl = undefined;
            for (var i = 0; i < opt.value.length; i++) {
                var el_1 = opt.value[i];
                if (isLiteralElement(el_1) && PLURAL_HASHTAG_REGEX.test(el_1.value)) {
                    matchingLiteralElIndex = i;
                    literalEl = el_1;
                    break;
                }
            }
            if (literalEl) {
                var newValue = literalEl.value.replace(PLURAL_HASHTAG_REGEX, "$1{" + el.value + ", number}");
                var newEls = pegParse(newValue);
                (_a = opt.value).splice.apply(_a, __spreadArrays$2([matchingLiteralElIndex, 1], newEls));
            }
            normalizeHashtagInPlural(opt.value);
        });
    });
}

var __assign$1 = (undefined && undefined.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) pattenrs are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: miliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) pattenrs are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\+|#+)?)?$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?$/g;
function parseSignificantPrecision(str) {
    var result = {};
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
            return {
                signDisplay: 'never',
            };
    }
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function convertNumberSkeletonToNumberFormatOptions(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
                result.style = 'percent';
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = __assign$1(__assign$1(__assign$1({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return (__assign$1(__assign$1({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = __assign$1(__assign$1(__assign$1({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return (__assign$1(__assign$1({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
        }
        // Precision
        // https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#fraction-precision
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (match, g1, g2) {
                // precision-integer case
                if (match === '.') {
                    result.maximumFractionDigits = 0;
                }
                // .000+ case
                else if (g2 === '+') {
                    result.minimumFractionDigits = g2.length;
                }
                // .### case
                else if (g1[0] === '#') {
                    result.maximumFractionDigits = g1.length;
                }
                // .00## or .000 case
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits =
                        g1.length + (typeof g2 === 'string' ? g2.length : 0);
                }
                return '';
            });
            if (token.options.length) {
                result = __assign$1(__assign$1({}, result), parseSignificantPrecision(token.options[0]));
            }
            continue;
        }
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = __assign$1(__assign$1({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = __assign$1(__assign$1({}, result), signOpts);
        }
    }
    return result;
}

function parse(input, opts) {
    var els = pegParse(input, opts);
    if (!opts || opts.normalizeHashtagInPlural !== false) {
        normalizeHashtagInPlural(els);
    }
    return els;
}

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
var __spreadArrays$1 = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// -- Utilities ----------------------------------------------------------------
function getCacheId(inputs) {
    return JSON.stringify(inputs.map(function (input) {
        return input && typeof input === 'object' ? orderedProps(input) : input;
    }));
}
function orderedProps(obj) {
    return Object.keys(obj)
        .sort()
        .map(function (k) {
        var _a;
        return (_a = {}, _a[k] = obj[k], _a);
    });
}
var memoizeFormatConstructor = function (FormatConstructor, cache) {
    if (cache === void 0) { cache = {}; }
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cacheId = getCacheId(args);
        var format = cacheId && cache[cacheId];
        if (!format) {
            format = new ((_a = FormatConstructor).bind.apply(_a, __spreadArrays$1([void 0], args)))();
            if (cacheId) {
                cache[cacheId] = format;
            }
        }
        return format;
    };
};
var memoizeIntlConstructor = memoizeFormatConstructor;

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var FormatError = /** @class */ (function (_super) {
    __extends(FormatError, _super);
    function FormatError(msg, variableId) {
        var _this = _super.call(this, msg) || this;
        _this.variableId = variableId;
        return _this;
    }
    return FormatError;
}(Error));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== 0 /* literal */ ||
            part.type !== 0 /* literal */) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && isLiteralElement(els[0])) {
        return [
            {
                type: 0 /* literal */,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if (isLiteralElement(el)) {
            result.push({
                type: 0 /* literal */,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if (isPoundElement(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: 0 /* literal */,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new FormatError("The intl string context variable \"" + varName + "\" was not provided to the string \"" + originalMessage + "\"");
        }
        var value = values[varName];
        if (isArgumentElement(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: 1 /* argument */,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (isDateElement(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : undefined;
            result.push({
                type: 0 /* literal */,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isTimeElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : isDateTimeSkeleton(el.style)
                    ? parseDateTimeSkeleton(el.style.pattern)
                    : undefined;
            result.push({
                type: 0 /* literal */,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isNumberElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : isNumberSkeleton(el.style)
                    ? convertNumberSkeletonToNumberFormatOptions(el.style.tokens)
                    : undefined;
            result.push({
                type: 0 /* literal */,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isSelectElement(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new RangeError("Invalid values for \"" + el.value + "\": \"" + value + "\". Options are \"" + Object.keys(el.options).join('", "') + "\"");
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if (isPluralElement(el)) {
            var opt = el.options["=" + value];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n");
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new RangeError("Invalid values for \"" + el.value + "\": \"" + value + "\". Options are \"" + Object.keys(el.options).join('", "') + "\"");
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}
function formatToString(els, locales, formatters, formats, values, 
// For debugging
originalMessage) {
    var parts = formatToParts(els, locales, formatters, formats, values, undefined, originalMessage);
    // Hot path for straight simple msg translations
    if (parts.length === 1) {
        return parts[0].value;
    }
    return parts.reduce(function (all, part) { return (all += part.value); }, '');
}
// Singleton
var domParser;
var TOKEN_DELIMITER = '@@';
var TOKEN_REGEX = /@@(\d+_\d+)@@/g;
var counter = 0;
function generateId() {
    return Date.now() + "_" + ++counter;
}
function restoreRichPlaceholderMessage(text, objectParts) {
    return text
        .split(TOKEN_REGEX)
        .filter(Boolean)
        .map(function (c) { return (objectParts[c] != null ? objectParts[c] : c); })
        .reduce(function (all, c) {
        if (!all.length) {
            all.push(c);
        }
        else if (typeof c === 'string' &&
            typeof all[all.length - 1] === 'string') {
            all[all.length - 1] += c;
        }
        else {
            all.push(c);
        }
        return all;
    }, []);
}
/**
 * Not exhaustive, just for sanity check
 */
var SIMPLE_XML_REGEX = /(<([0-9a-zA-Z-_]*?)>(.*?)<\/([0-9a-zA-Z-_]*?)>)|(<[0-9a-zA-Z-_]*?\/>)/;
var TEMPLATE_ID = Date.now() + '@@';
var VOID_ELEMENTS = [
    'area',
    'base',
    'br',
    'col',
    'embed',
    'hr',
    'img',
    'input',
    'link',
    'meta',
    'param',
    'source',
    'track',
    'wbr',
];
function formatHTMLElement(el, objectParts, values) {
    var tagName = el.tagName;
    var outerHTML = el.outerHTML, textContent = el.textContent, childNodes = el.childNodes;
    // Regular text
    if (!tagName) {
        return restoreRichPlaceholderMessage(textContent || '', objectParts);
    }
    tagName = tagName.toLowerCase();
    var isVoidElement = ~VOID_ELEMENTS.indexOf(tagName);
    var formatFnOrValue = values[tagName];
    if (formatFnOrValue && isVoidElement) {
        throw new FormatError(tagName + " is a self-closing tag and can not be used, please use another tag name.");
    }
    if (!childNodes.length) {
        return [outerHTML];
    }
    var chunks = Array.prototype.slice.call(childNodes).reduce(function (all, child) {
        return all.concat(formatHTMLElement(child, objectParts, values));
    }, []);
    // Legacy HTML
    if (!formatFnOrValue) {
        return __spreadArrays(["<" + tagName + ">"], chunks, ["</" + tagName + ">"]);
    }
    // HTML Tag replacement
    if (typeof formatFnOrValue === 'function') {
        return [formatFnOrValue.apply(void 0, chunks)];
    }
    return [formatFnOrValue];
}
function formatHTMLMessage(els, locales, formatters, formats, values, 
// For debugging
originalMessage) {
    var parts = formatToParts(els, locales, formatters, formats, values, undefined, originalMessage);
    var objectParts = {};
    var formattedMessage = parts.reduce(function (all, part) {
        if (part.type === 0 /* literal */) {
            return (all += part.value);
        }
        var id = generateId();
        objectParts[id] = part.value;
        return (all += "" + TOKEN_DELIMITER + id + TOKEN_DELIMITER);
    }, '');
    // Not designed to filter out aggressively
    if (!SIMPLE_XML_REGEX.test(formattedMessage)) {
        return restoreRichPlaceholderMessage(formattedMessage, objectParts);
    }
    if (!values) {
        throw new FormatError('Message has placeholders but no values was given');
    }
    if (typeof DOMParser === 'undefined') {
        throw new FormatError('Cannot format XML message without DOMParser');
    }
    if (!domParser) {
        domParser = new DOMParser();
    }
    var content = domParser
        .parseFromString("<formatted-message id=\"" + TEMPLATE_ID + "\">" + formattedMessage + "</formatted-message>", 'text/html')
        .getElementById(TEMPLATE_ID);
    if (!content) {
        throw new FormatError("Malformed HTML message " + formattedMessage);
    }
    var tagsToFormat = Object.keys(values).filter(function (varName) { return !!content.getElementsByTagName(varName).length; });
    // No tags to format
    if (!tagsToFormat.length) {
        return restoreRichPlaceholderMessage(formattedMessage, objectParts);
    }
    var caseSensitiveTags = tagsToFormat.filter(function (tagName) { return tagName !== tagName.toLowerCase(); });
    if (caseSensitiveTags.length) {
        throw new FormatError("HTML tag must be lowercased but the following tags are not: " + caseSensitiveTags.join(', '));
    }
    // We're doing this since top node is `<formatted-message/>` which does not have a formatter
    return Array.prototype.slice
        .call(content.childNodes)
        .reduce(function (all, child) { return all.concat(formatHTMLElement(child, objectParts, values)); }, []);
}

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) {
        return c1;
    }
    return __assign(__assign(__assign({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = __assign(__assign({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, __assign({}, defaultConfig));
}
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: memoizeIntlConstructor(Intl.NumberFormat, cache.number),
        getDateTimeFormat: memoizeIntlConstructor(Intl.DateTimeFormat, cache.dateTime),
        getPluralRules: memoizeIntlConstructor(Intl.PluralRules, cache.pluralRules),
    };
}
var IntlMessageFormat = /** @class */ (function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            return formatToString(_this.ast, _this.locales, _this.formatters, _this.formats, values, _this.message);
        };
        this.formatToParts = function (values) {
            return formatToParts(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.formatHTMLMessage = function (values) {
            return formatHTMLMessage(_this.ast, _this.locales, _this.formatters, _this.formats, values, _this.message);
        };
        this.resolvedOptions = function () { return ({
            locale: Intl.NumberFormat.supportedLocalesOf(_this.locales)[0],
        }); };
        this.getAst = function () { return _this.ast; };
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                normalizeHashtagInPlural: false,
            });
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    IntlMessageFormat.defaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
    IntlMessageFormat.__parse = parse;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
}());
var IntlMessageFormat$1 = IntlMessageFormat;

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

const o=(n,e="")=>{const t={};for(const r in n){const i=e+r;"object"==typeof n[r]?Object.assign(t,o(n[r],i+".")):t[i]=n[r];}return t};let r$1;const i$1=writable({});function a(n){return n in r$1}function l(n,e){if(a(n)){const t=function(n){return r$1[n]||null}(n);if(e in t)return t[e]}return null}function s$2(n){return null==n||a(n)?n:s$2(D(n))}function c(n,...e){const t=e.map(n=>o(n));i$1.update(e=>(e[n]=Object.assign(e[n]||{},...t),e));}derived([i$1],([n])=>Object.keys(n));i$1.subscribe(n=>r$1=n);const m={};function f(n){return m[n]}function d(n){return I(n).reverse().some(n=>{var e;return null===(e=f(n))||void 0===e?void 0:e.size})}function w(n,e){return Promise.all(e.map(e=>(function(n,e){m[n].delete(e),0===m[n].size&&delete m[n];}(n,e),e().then(n=>n.default||n)))).then(e=>c(n,...e))}const g$1={};function b(n){if(!d(n))return n in g$1?g$1[n]:void 0;const e=function(n){return I(n).reverse().map(n=>{const e=f(n);return [n,e?[...e]:[]]}).filter(([,n])=>n.length>0)}(n);return g$1[n]=Promise.all(e.map(([n,e])=>w(n,e))).then(()=>{if(d(n))return b(n);delete g$1[n];}),g$1[n]}/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */function h(n,e){var t={};for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&e.indexOf(o)<0&&(t[o]=n[o]);if(null!=n&&"function"==typeof Object.getOwnPropertySymbols){var r=0;for(o=Object.getOwnPropertySymbols(n);r<o.length;r++)e.indexOf(o[r])<0&&Object.prototype.propertyIsEnumerable.call(n,o[r])&&(t[o[r]]=n[o[r]]);}return t}const y={fallbackLocale:null,initialLocale:null,loadingDelay:200,formats:{number:{scientific:{notation:"scientific"},engineering:{notation:"engineering"},compactLong:{notation:"compact",compactDisplay:"long"},compactShort:{notation:"compact",compactDisplay:"short"}},date:{short:{month:"numeric",day:"numeric",year:"2-digit"},medium:{month:"short",day:"numeric",year:"numeric"},long:{month:"long",day:"numeric",year:"numeric"},full:{weekday:"long",month:"long",day:"numeric",year:"numeric"}},time:{short:{hour:"numeric",minute:"numeric"},medium:{hour:"numeric",minute:"numeric",second:"numeric"},long:{hour:"numeric",minute:"numeric",second:"numeric",timeZoneName:"short"},full:{hour:"numeric",minute:"numeric",second:"numeric",timeZoneName:"short"}}},warnOnMissingMessages:!0};function O(){return y}function v(n){const{formats:e}=n,t=h(n,["formats"]),o=n.initialLocale||n.fallbackLocale;return Object.assign(y,t,{initialLocale:o}),e&&("number"in e&&Object.assign(y.formats.number,e.number),"date"in e&&Object.assign(y.formats.date,e.date),"time"in e&&Object.assign(y.formats.time,e.time)),k.set(o)}const j=writable(!1);let L;const k=writable(null);function x(n,e){return 0===e.indexOf(n)&&n!==e}function E$1(n,e){return n===e||x(n,e)||x(e,n)}function D(n){const e=n.lastIndexOf("-");if(e>0)return n.slice(0,e);const{fallbackLocale:t}=O();return t&&!E$1(n,t)?t:null}function I(n){const e=n.split("-").map((n,e,t)=>t.slice(0,e+1).join("-")),{fallbackLocale:t}=O();return t&&!E$1(n,t)?e.concat(I(t)):e}function N(){return L}k.subscribe(n=>{L=n,"undefined"!=typeof window&&document.documentElement.setAttribute("lang",n);});const P=k.set;k.set=n=>{if(s$2(n)&&d(n)){const{loadingDelay:e}=O();let t;return "undefined"!=typeof window&&null!=N()&&e?t=window.setTimeout(()=>j.set(!0),e):j.set(!0),b(n).then(()=>{P(n);}).finally(()=>{clearTimeout(t),j.set(!1);})}return P(n)},k.update=n=>P(n(L));const Z={},C=(n,e)=>{if(null==e)return null;const t=l(e,n);return t||C(n,D(e))},J=(n,e)=>{if(e in Z&&n in Z[e])return Z[e][n];const t=C(n,e);return t?((n,e,t)=>t?(e in Z||(Z[e]={}),n in Z[e]||(Z[e][n]=t),t):t)(n,e,t):null},U=n=>{const e=Object.create(null);return t=>{const o=JSON.stringify(t);return o in e?e[o]:e[o]=n(t)}},_=(n,e)=>{const{formats:t}=O();if(n in t&&e in t[n])return t[n][e];throw new Error(`[svelte-i18n] Unknown "${e}" ${n} format.`)},q=U(n=>{var{locale:e,format:t}=n,o=h(n,["locale","format"]);if(null==e)throw new Error('[svelte-i18n] A "locale" must be set to format numbers');return t&&(o=_("number",t)),new Intl.NumberFormat(e,o)}),B=U(n=>{var{locale:e,format:t}=n,o=h(n,["locale","format"]);if(null==e)throw new Error('[svelte-i18n] A "locale" must be set to format dates');return t?o=_("date",t):0===Object.keys(o).length&&(o=_("date","short")),new Intl.DateTimeFormat(e,o)}),G=U(n=>{var{locale:e,format:t}=n,o=h(n,["locale","format"]);if(null==e)throw new Error('[svelte-i18n] A "locale" must be set to format time values');return t?o=_("time",t):0===Object.keys(o).length&&(o=_("time","short")),new Intl.DateTimeFormat(e,o)}),H=(n={})=>{var{locale:e=N()}=n,t=h(n,["locale"]);return q(Object.assign({locale:e},t))},K=(n={})=>{var{locale:e=N()}=n,t=h(n,["locale"]);return B(Object.assign({locale:e},t))},Q=(n={})=>{var{locale:e=N()}=n,t=h(n,["locale"]);return G(Object.assign({locale:e},t))},R=U((n,e=N())=>new IntlMessageFormat$1(n,e,O().formats)),V=(n,e={})=>{"object"==typeof n&&(n=(e=n).id);const{values:t,locale:o=N(),default:r}=e;if(null==o)throw new Error("[svelte-i18n] Cannot format a message without first setting the initial locale.");const i=J(n,o);return i?t?R(i,o).format(t):i:(O().warnOnMissingMessages&&console.warn(`[svelte-i18n] The message "${n}" was not found in "${I(o).join('", "')}".${d(N())?"\n\nNote: there are at least one loader still registered to this locale that wasn't executed.":""}`),r||n)},W=(n,e)=>Q(e).format(n),X=(n,e)=>K(e).format(n),Y=(n,e)=>H(e).format(n),nn=derived([k,i$1],()=>V);derived([k],()=>W);derived([k],()=>X);derived([k],()=>Y);

const FALLBACK_LOCALE = 'en-US';
const LOKALISE_URL = 'https://lokalise.attensi.com/app-launcher';
const ALLOWED_ENVS = ['staging', 'production'];
const URLS = {
    ADMIN: {
        staging: 'https://admin-staging.attensi.com',
        production: 'https://admin.attensi.com',
    },
    ENGAGE: {
        staging: 'https://engage-staging.attensi.com',
        production: 'https://engage.attensi.com',
    },
    FAST: {
        staging: 'https://fast-staging.attensi.com',
        production: 'https://fast.attensi.com',
    },
    QUIZRACE: {
        staging: 'https://quizrace-staging.attensi.com',
        production: 'https://quizrace.attensi.com',
    },
    LIVE_LEADERBOARDS: {
        staging: 'https://leaderboards.attensi.com',
        production: 'https://leaderboards.attensi.com',
    },
    INSIGHTS: {
        staging: 'https://insights-staging.attensi.com',
        production: 'https://insights.attensi.com',
    },
    DIALOGUE_REVIEW: {
        staging: 'https://dialogue-staging.attensi.com',
        production: 'https://dialogue.attensi.com',
    },
    PROCESS_DOCS: {
        staging: 'https://process-staging.attensi.com',
        production: 'https://process.attensi.com',
    },
    PORTAL: {
        staging: 'https://portal-staging.attensi.com',
        production: 'https://portal.attensi.com',
    },
    CREATOR: {
        staging: 'https://admin-staging.attensi.com',
        production: 'https://admin.attensi.com',
    },
    ATTENSI_PLATFORM: 'https://attensi.com',
};

var attensi_platform = "Attensi platform";
var launch_apps = "Launch apps";
var apps = {
	admin: {
		title: "Admin",
		subtitle: "Administrate everything"
	},
	engage: {
		title: "Engage",
		subtitle: "Create campaigns and reminders"
	},
	fast: {
		title: "Fast",
		subtitle: "Create games"
	},
	quizrace: {
		title: "Quizrace",
		subtitle: "Create games"
	},
	live_leaderboards: {
		title: "Live leaderboards",
		subtitle: "Browse live leaderboards"
	},
	insights: {
		title: "Insights",
		subtitle: "See insights"
	},
	dialogue_review: {
		title: "Dialogue reviews",
		subtitle: "Review dialogue"
	},
	process_docs: {
		title: "Process docs",
		subtitle: "Read process docs"
	}
};
var links = {
	portal: {
		title: "Portal",
		subtitle: "Launch portal for your company"
	},
	creator: {
		title: "Creator",
		subtitle: "Create and manage games"
	},
	attensi_platform: {
		title: "Attensi platform",
		subtitle: "Read about all our products"
	}
};
var enUS = {
	attensi_platform: attensi_platform,
	launch_apps: launch_apps,
	apps: apps,
	links: links
};

const initLocale = async (locale) => {
    c(FALLBACK_LOCALE, enUS);
    v({
        fallbackLocale: FALLBACK_LOCALE,
        initialLocale: locale,
    });
    await changeLocale(locale);
};
const changeLocale = async (locale) => {
    await loadLocale(locale);
    k.set(locale);
};
/**
 * Loads and registers locale translations from Lokalise to local i18n instance
 */
const loadLocale = async (locale) => {
    const manifest = await fetchManifest();
    const { fileName } = manifest.locales[locale];
    if (!fileName) {
        throw new Error('Cannot load this locale - it is not in the manifest file');
    }
    const fetchedLocale = await fetchLocale(fileName);
    c(locale, fetchedLocale);
};
/**
 * Fetches manifest file directly from the Lokalise server.
 * It lets us know which locales are available for App Launcher
 */
const fetchManifest = async () => {
    const url = `${LOKALISE_URL}/manifest.json`;
    const res = await fetch(url);
    if (!res.ok) {
        throw new Error(`Fetching manifest failed. Status: ${res.status}`);
    }
    return res.json();
};
/**
 * Fetches locale translations in form of JSON, based on the
 * locale file name from Lokalise manifest
 */
const fetchLocale = async (fileName) => {
    const url = `${LOKALISE_URL}/${fileName}`;
    const res = await fetch(url);
    if (!res.ok) {
        throw new Error(`Fetching locale failed. Status: ${res.status}`);
    }
    return res.json();
};

function n$1(n){return null!=n}const i=()=>{let n,t;return {promise:new Promise(((e,r)=>{n=e,t=r;})),resolve:t=>n(t),reject:n=>t(n)}},s$1=n=>{const{promise:t,resolve:e}=i();let r;return {getConfig:()=>(r||(r=new Promise(((e,r)=>{var o;const i=window.setTimeout((()=>{r("Async config timed out");}),null!==(o=null==n?void 0:n.timeout)&&void 0!==o?o:1e4);t.then((n=>{window.clearTimeout(i),e(n);}));}))),r),setConfig:e}};const p=(n,t)=>{const[e,r]=g(n);return e+E(r,t)},g=n=>{const[t,...e]=n.split("?");return [t,e.join("&")]},E=(t,e)=>{const r=new URLSearchParams(t);for(const[t,o]of Object.entries(e))n$1(o)&&r.set(t,String(o));const o=r.toString();return ""===o?"":"?"+o};

const { getConfig, setConfig: _setConfig } = s$1();
const setConfig = (config) => {
    const validatedConfig = validateConfig(config);
    _setConfig(validatedConfig);
};
const validateConfig = (config) => {
    const { env } = config;
    if (!ALLOWED_ENVS.includes(env)) {
        console.warn(`Passed env must equal "staging" or "production". Defaulting to "staging".`);
        return {
            ...config,
            env: 'staging',
        };
    }
    return config;
};

function cubicOut(t) {
    const f = t - 1.0;
    return f * f * f + 1.0;
}

function fade(node, { delay = 0, duration = 400, easing = identity } = {}) {
    const o = +getComputedStyle(node).opacity;
    return {
        delay,
        duration,
        easing,
        css: t => `opacity: ${t * o}`
    };
}
function fly(node, { delay = 0, duration = 400, easing = cubicOut, x = 0, y = 0, opacity = 0 } = {}) {
    const style = getComputedStyle(node);
    const target_opacity = +style.opacity;
    const transform = style.transform === 'none' ? '' : style.transform;
    const od = target_opacity * (1 - opacity);
    const [xValue, xUnit] = split_css_unit(x);
    const [yValue, yUnit] = split_css_unit(y);
    return {
        delay,
        duration,
        easing,
        css: (t, u) => `
			transform: ${transform} translate(${(1 - t) * xValue}${xUnit}, ${(1 - t) * yValue}${yUnit});
			opacity: ${target_opacity - (od * u)}`
    };
}

const isAppLauncherOpen = writable(false);
const toggleAppLauncher = () => isAppLauncherOpen.update((toggleState) => !toggleState);

/* src/assets/apps/Admin.svelte generated by Svelte v3.57.0 */

function create_fragment$h(ctx) {
	let svg;
	let path0;
	let path1;
	let path2;
	let path3;
	let defs;
	let radialGradient0;
	let stop0;
	let stop1;
	let radialGradient1;
	let stop2;
	let stop3;
	let radialGradient2;
	let stop4;
	let stop5;
	let radialGradient3;
	let stop6;
	let stop7;

	return {
		c() {
			svg = svg_element("svg");
			path0 = svg_element("path");
			path1 = svg_element("path");
			path2 = svg_element("path");
			path3 = svg_element("path");
			defs = svg_element("defs");
			radialGradient0 = svg_element("radialGradient");
			stop0 = svg_element("stop");
			stop1 = svg_element("stop");
			radialGradient1 = svg_element("radialGradient");
			stop2 = svg_element("stop");
			stop3 = svg_element("stop");
			radialGradient2 = svg_element("radialGradient");
			stop4 = svg_element("stop");
			stop5 = svg_element("stop");
			radialGradient3 = svg_element("radialGradient");
			stop6 = svg_element("stop");
			stop7 = svg_element("stop");
			attr(path0, "d", "M20.6855 20.8441L25.7891 11.402L42.9169 37.4027H30.5582L20.6855 20.8441Z");
			attr(path0, "fill", "url(#paint0_radial_6485_42294)");
			attr(path1, "d", "M20.6855 20.8441L25.7891 11.402L42.9169 37.4027H30.5582L20.6855 20.8441Z");
			attr(path1, "fill", "url(#paint1_angular_6485_42294)");
			attr(path2, "d", "M25.7888 11.4039L32.1767 21.0994L22.7271 37.5118L10.832 37.5118L25.7888 11.4039Z");
			attr(path2, "fill", "url(#paint2_angular_6485_42294)");
			attr(path3, "d", "M25.7888 11.4039L32.1767 21.0994L22.7271 37.5118L10.832 37.5118L25.7888 11.4039Z");
			attr(path3, "fill", "url(#paint3_radial_6485_42294)");
			attr(stop0, "stop-color", "#2DDEF8");
			attr(stop1, "offset", "1");
			attr(stop1, "stop-color", "#56BCCF");
			attr(radialGradient0, "id", "paint0_radial_6485_42294");
			attr(radialGradient0, "cx", "0");
			attr(radialGradient0, "cy", "0");
			attr(radialGradient0, "r", "1");
			attr(radialGradient0, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient0, "gradientTransform", "translate(29.2078 25.3031) rotate(78.8544) scale(14.1841 12.8268)");
			attr(stop2, "offset", "0.0136891");
			attr(stop2, "stop-color", "#1B2231");
			attr(stop3, "offset", "0.504782");
			attr(stop3, "stop-color", "#2C7790");
			attr(radialGradient1, "id", "paint1_angular_6485_42294");
			attr(radialGradient1, "cx", "0");
			attr(radialGradient1, "cy", "0");
			attr(radialGradient1, "r", "1");
			attr(radialGradient1, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient1, "gradientTransform", "translate(26.2233 30.9739) rotate(-60.7445) scale(13.8351 14.1345)");
			attr(stop4, "offset", "0.0136891");
			attr(stop4, "stop-color", "#1B2231");
			attr(stop5, "offset", "0.504782");
			attr(stop5, "stop-color", "#2C7790");
			attr(radialGradient2, "id", "paint2_angular_6485_42294");
			attr(radialGradient2, "cx", "0");
			attr(radialGradient2, "cy", "0");
			attr(radialGradient2, "r", "1");
			attr(radialGradient2, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient2, "gradientTransform", "translate(26.9276 30.5571) rotate(-60.3335) scale(14.1554)");
			attr(stop6, "stop-color", "#2DDEF8");
			attr(stop7, "offset", "1");
			attr(stop7, "stop-color", "#56BCCF");
			attr(radialGradient3, "id", "paint3_radial_6485_42294");
			attr(radialGradient3, "cx", "0");
			attr(radialGradient3, "cy", "0");
			attr(radialGradient3, "r", "1");
			attr(radialGradient3, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient3, "gradientTransform", "translate(26.7497 18.9979) rotate(114.567) scale(27.1854 23.5822)");
			attr(svg, "width", "52");
			attr(svg, "height", "52");
			attr(svg, "viewBox", "0 0 52 52");
			attr(svg, "fill", "none");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, path0);
			append(svg, path1);
			append(svg, path2);
			append(svg, path3);
			append(svg, defs);
			append(defs, radialGradient0);
			append(radialGradient0, stop0);
			append(radialGradient0, stop1);
			append(defs, radialGradient1);
			append(radialGradient1, stop2);
			append(radialGradient1, stop3);
			append(defs, radialGradient2);
			append(radialGradient2, stop4);
			append(radialGradient2, stop5);
			append(defs, radialGradient3);
			append(radialGradient3, stop6);
			append(radialGradient3, stop7);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

class Admin extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment$h, safe_not_equal, {});
	}
}

/* src/assets/apps/AttensiPlatform.svelte generated by Svelte v3.57.0 */

function create_fragment$g(ctx) {
	let svg;
	let rect;
	let path;

	return {
		c() {
			svg = svg_element("svg");
			rect = svg_element("rect");
			path = svg_element("path");
			attr(rect, "width", "52");
			attr(rect, "height", "54");
			attr(rect, "fill", "white");
			attr(path, "d", "M41.4816 19.011C41.4816 18.6479 41.3785 18.2848 41.224 17.9216C41.0179 17.6104 40.7603 17.2991 40.4512 17.1435L34.5778 13.6159C34.2687 13.4603 33.9595 13.3565 33.5989 13.3046C33.3928 12.9934 33.1867 12.7859 32.8776 12.5784L27.0557 9.15452C26.7466 8.94701 26.386 8.84326 26.0253 8.84326C25.6647 8.84326 25.304 8.94701 24.9949 9.15452L19.07 12.6302C18.7609 12.8377 18.5548 13.0452 18.3487 13.3565C17.9881 13.3565 17.679 13.4603 17.3698 13.6678L11.548 17.1435C11.2389 17.351 10.9813 17.6104 10.7752 17.9216C10.6206 18.2329 10.5176 18.596 10.5176 19.011V26.0143C10.5176 26.3775 10.6206 26.6887 10.7752 27C10.6206 27.3113 10.5176 27.6744 10.5176 27.9857V34.989C10.5176 35.3521 10.6206 35.7671 10.7752 36.0784C10.9813 36.3896 11.2389 36.7009 11.548 36.8565L17.3698 40.3322C17.679 40.5397 17.9881 40.5916 18.3487 40.6435C18.5033 40.9548 18.7609 41.1623 19.07 41.3698L24.8919 44.8455C25.201 45.053 25.5616 45.1567 25.9223 45.1567C26.2829 45.1567 26.6436 45.053 26.9527 44.8455L32.7746 41.3698C33.0837 41.2141 33.2898 40.9548 33.4958 40.6435C33.8565 40.6435 34.1656 40.5397 34.4747 40.3322L40.3996 36.9084C40.7088 36.7009 40.9664 36.4415 41.1724 36.1302C41.3785 35.819 41.4301 35.404 41.4301 35.0408V28.0375C41.4301 27.6744 41.327 27.3631 41.1724 27.0519C41.327 26.7406 41.4301 26.3775 41.4301 26.0662V19.011H41.4816ZM18.0396 23.5243V23.5762V30.5795L17.8851 30.5276L12.0632 27L17.8335 23.5762C17.9366 23.5243 17.9881 23.5243 18.0396 23.5243ZM17.3183 22.6943L11.4965 26.17C11.4965 26.1181 11.4965 26.0143 11.4965 26.0143V19.011C11.4965 18.8035 11.548 18.596 11.651 18.4404C11.7541 18.2848 11.9086 18.1291 12.0632 18.0254L17.8851 14.5497C17.9366 14.4978 17.9881 14.4978 18.0396 14.4978V14.5497V21.5011C18.0396 21.8124 18.0911 22.0717 18.2457 22.383C17.8851 22.383 17.5759 22.4868 17.3183 22.6943ZM11.651 35.5596C11.548 35.404 11.4965 35.1965 11.4965 34.989V27.9857C11.4965 27.9338 11.4965 27.83 11.4965 27.83H11.548L17.3698 31.3057C17.6274 31.4614 17.8851 31.5651 18.1942 31.5651C18.0911 31.8245 17.9881 32.1358 17.9881 32.447V39.4503V39.5022L17.8335 39.4503L12.0632 35.9746C11.9086 35.8709 11.7541 35.7152 11.651 35.5596ZM33.7535 31.5651H33.805C34.1141 31.5132 34.3717 31.4095 34.6293 31.3057L40.4512 27.83C40.4512 27.8819 40.4512 27.9338 40.4512 27.9857V34.989C40.4512 35.1965 40.3996 35.404 40.2966 35.5596C40.1936 35.7152 40.039 35.8709 39.8844 35.9746L34.0626 39.4503L33.908 39.5022V32.447C33.908 32.1358 33.8565 31.8245 33.7535 31.5651ZM40.2966 26.0143C40.2966 26.0662 40.2966 26.1181 40.2966 26.17L34.4747 22.6943C34.2171 22.5386 33.9595 22.4349 33.6504 22.4349H33.7019C33.805 22.1755 33.8565 21.8642 33.908 21.553V14.4978H34.0626L39.7814 17.9735C39.9359 18.0773 40.0905 18.2329 40.1936 18.3885C40.2966 18.5441 40.3481 18.7517 40.3481 18.9592V26.0143H40.2966ZM33.9595 23.5243C33.9595 23.5243 34.0111 23.5243 34.0111 23.5762L39.8844 26.9481L34.1141 30.4238L33.9595 30.4757V23.5243ZM25.3556 19.0629V25.9625L19.6368 22.5386L25.3556 19.0629ZM19.5852 31.5132L25.3556 28.0375V34.9371L19.5852 31.5132ZM32.3109 22.5386L26.5405 26.0143V19.0629L32.3109 22.5386ZM26.5405 34.989V28.0375L32.3624 31.5132L26.5405 34.989ZM27.0557 27L32.8261 23.5243V30.4757L27.0557 27ZM32.7746 21.4492C32.7746 21.5011 32.7746 21.553 32.7746 21.6049L26.9527 18.1291C27.0042 18.0773 27.0558 18.0773 27.1073 18.0254L32.7746 14.5497V21.4492ZM19.0185 21.6567C19.0185 21.6049 19.0185 21.553 19.0185 21.5011V14.5497L24.8404 18.0254L24.9949 18.1291L19.0185 21.6567ZM19.0185 30.4757V23.5762L24.7888 27L19.0185 30.4757ZM32.9291 32.3433C32.9291 32.3951 32.9291 32.4989 32.9291 32.4989V39.5022L27.1588 36.0265L27.0042 35.9227V35.819L32.8261 32.3433H32.9291ZM26.5921 17.0916C26.3345 17.2472 26.1284 17.4547 25.9223 17.7141C25.7677 17.4547 25.5616 17.2472 25.304 17.0916L19.4307 13.6159L19.5852 13.5121L25.4071 10.0883C25.5616 9.98454 25.7677 9.93267 25.9738 9.93267C26.1799 9.93267 26.3345 9.98454 26.5405 10.0883L32.3109 13.564L32.4654 13.6678L26.5921 17.0916ZM19.07 32.5508C19.07 32.4989 19.07 32.447 19.07 32.3951L24.9949 35.9746L24.8404 36.0784L19.07 39.5541V32.5508ZM19.4822 40.3841L25.4071 36.9084C25.6647 36.7528 25.8708 36.5453 26.0253 36.2859C26.1799 36.5453 26.4375 36.7528 26.6951 36.9084L32.517 40.3841L32.3624 40.4879L26.5405 43.9636C26.386 44.0673 26.1799 44.1192 25.9738 44.1192C25.7677 44.1192 25.6132 44.0673 25.4071 43.9636L19.6368 40.4879L19.4822 40.3841Z");
			attr(path, "fill", "#56BCCF");
			attr(svg, "width", "52");
			attr(svg, "height", "54");
			attr(svg, "viewBox", "0 0 52 54");
			attr(svg, "fill", "none");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, rect);
			append(svg, path);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

class AttensiPlatform extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment$g, safe_not_equal, {});
	}
}

/* src/assets/apps/Creator.svelte generated by Svelte v3.57.0 */

function create_fragment$f(ctx) {
	let svg;
	let rect;
	let path0;
	let path1;
	let mask0;
	let path2;
	let path3;
	let g0;
	let path4;
	let path5;
	let path6;
	let path7;
	let path8;
	let mask1;
	let path9;
	let path10;
	let g1;
	let path11;
	let path12;
	let path13;
	let path14;
	let path15;
	let defs;
	let radialGradient0;
	let stop0;
	let stop1;
	let radialGradient1;
	let stop2;
	let stop3;
	let radialGradient2;
	let stop4;
	let stop5;
	let radialGradient3;
	let stop6;
	let stop7;
	let stop8;
	let stop9;
	let radialGradient4;
	let stop10;
	let stop11;
	let radialGradient5;
	let stop12;
	let stop13;
	let radialGradient6;
	let stop14;
	let stop15;
	let radialGradient7;
	let stop16;
	let stop17;
	let radialGradient8;
	let stop18;
	let stop19;
	let stop20;
	let stop21;
	let radialGradient9;
	let stop22;
	let stop23;
	let radialGradient10;
	let stop24;
	let stop25;

	return {
		c() {
			svg = svg_element("svg");
			rect = svg_element("rect");
			path0 = svg_element("path");
			path1 = svg_element("path");
			mask0 = svg_element("mask");
			path2 = svg_element("path");
			path3 = svg_element("path");
			g0 = svg_element("g");
			path4 = svg_element("path");
			path5 = svg_element("path");
			path6 = svg_element("path");
			path7 = svg_element("path");
			path8 = svg_element("path");
			mask1 = svg_element("mask");
			path9 = svg_element("path");
			path10 = svg_element("path");
			g1 = svg_element("g");
			path11 = svg_element("path");
			path12 = svg_element("path");
			path13 = svg_element("path");
			path14 = svg_element("path");
			path15 = svg_element("path");
			defs = svg_element("defs");
			radialGradient0 = svg_element("radialGradient");
			stop0 = svg_element("stop");
			stop1 = svg_element("stop");
			radialGradient1 = svg_element("radialGradient");
			stop2 = svg_element("stop");
			stop3 = svg_element("stop");
			radialGradient2 = svg_element("radialGradient");
			stop4 = svg_element("stop");
			stop5 = svg_element("stop");
			radialGradient3 = svg_element("radialGradient");
			stop6 = svg_element("stop");
			stop7 = svg_element("stop");
			stop8 = svg_element("stop");
			stop9 = svg_element("stop");
			radialGradient4 = svg_element("radialGradient");
			stop10 = svg_element("stop");
			stop11 = svg_element("stop");
			radialGradient5 = svg_element("radialGradient");
			stop12 = svg_element("stop");
			stop13 = svg_element("stop");
			radialGradient6 = svg_element("radialGradient");
			stop14 = svg_element("stop");
			stop15 = svg_element("stop");
			radialGradient7 = svg_element("radialGradient");
			stop16 = svg_element("stop");
			stop17 = svg_element("stop");
			radialGradient8 = svg_element("radialGradient");
			stop18 = svg_element("stop");
			stop19 = svg_element("stop");
			stop20 = svg_element("stop");
			stop21 = svg_element("stop");
			radialGradient9 = svg_element("radialGradient");
			stop22 = svg_element("stop");
			stop23 = svg_element("stop");
			radialGradient10 = svg_element("radialGradient");
			stop24 = svg_element("stop");
			stop25 = svg_element("stop");
			attr(rect, "width", "52");
			attr(rect, "height", "54");
			attr(rect, "fill", "white");
			attr(path0, "d", "M26.0003 8.84344L41.7244 17.9217V36.0783L26.0003 45.1566L10.2763 36.0783V17.9217L26.0003 8.84344Z");
			attr(path0, "fill", "#D9D9D9");
			attr(path1, "d", "M26.0003 8.84344L41.7244 17.9217V36.0783L26.0003 45.1566L10.2763 36.0783V17.9217L26.0003 8.84344Z");
			attr(path1, "fill", "url(#paint0_diamond_6485_42319)");
			attr(path2, "d", "M26.0003 8.84344L41.7244 17.9217V36.0783L26.0003 45.1566L10.2763 36.0783V17.9217L26.0003 8.84344Z");
			attr(path2, "fill", "#D9D9D9");
			attr(path3, "d", "M26.0003 8.84344L41.7244 17.9217V36.0783L26.0003 45.1566L10.2763 36.0783V17.9217L26.0003 8.84344Z");
			attr(path3, "fill", "url(#paint1_diamond_6485_42319)");
			attr(mask0, "id", "mask0_6485_42319");
			set_style(mask0, "mask-type", "alpha");
			attr(mask0, "maskUnits", "userSpaceOnUse");
			attr(mask0, "x", "10");
			attr(mask0, "y", "8");
			attr(mask0, "width", "32");
			attr(mask0, "height", "38");
			attr(path4, "d", "M17.9609 2.98053L34.3723 12.4556V31.4058L17.9609 40.8809L1.54959 31.4058V12.4556L17.9609 2.98053Z");
			attr(path4, "fill", "#D9D9D9");
			attr(path5, "d", "M17.9609 2.98053L34.3723 12.4556V31.4058L17.9609 40.8809L1.54959 31.4058V12.4556L17.9609 2.98053Z");
			attr(path5, "fill", "url(#paint2_diamond_6485_42319)");
			attr(path6, "d", "M17.9609 2.98053L34.3723 12.4556V31.4058L17.9609 40.8809L1.54959 31.4058V12.4556L17.9609 2.98053Z");
			attr(path6, "fill", "url(#paint3_diamond_6485_42319)");
			attr(path7, "d", "M17.9609 2.98053L34.3723 12.4556V31.4058L17.9609 40.8809L1.54959 31.4058V12.4556L17.9609 2.98053Z");
			attr(path7, "fill", "url(#paint4_radial_6485_42319)");
			attr(path8, "d", "M9.5703 -1.42926L25.9816 8.04583V26.996L9.5703 36.4711L-6.84104 26.996V8.04583L9.5703 -1.42926Z");
			attr(path8, "fill", "url(#paint5_radial_6485_42319)");
			attr(g0, "mask", "url(#mask0_6485_42319)");
			attr(path9, "d", "M26.0003 8.84344L41.7244 17.9217V36.0783L26.0003 45.1566L10.2763 36.0783V17.9217L26.0003 8.84344Z");
			attr(path9, "fill", "#D9D9D9");
			attr(path10, "d", "M26.0003 8.84344L41.7244 17.9217V36.0783L26.0003 45.1566L10.2763 36.0783V17.9217L26.0003 8.84344Z");
			attr(path10, "fill", "url(#paint6_diamond_6485_42319)");
			attr(mask1, "id", "mask1_6485_42319");
			set_style(mask1, "mask-type", "alpha");
			attr(mask1, "maskUnits", "userSpaceOnUse");
			attr(mask1, "x", "10");
			attr(mask1, "y", "8");
			attr(mask1, "width", "32");
			attr(mask1, "height", "38");
			attr(path11, "d", "M17.9609 2.98053L34.3723 12.4556V31.4058L17.9609 40.8809L1.54959 31.4058V12.4556L17.9609 2.98053Z");
			attr(path11, "fill", "#D9D9D9");
			attr(path12, "d", "M17.9609 2.98053L34.3723 12.4556V31.4058L17.9609 40.8809L1.54959 31.4058V12.4556L17.9609 2.98053Z");
			attr(path12, "fill", "url(#paint7_diamond_6485_42319)");
			attr(path13, "d", "M17.9609 2.98053L34.3723 12.4556V31.4058L17.9609 40.8809L1.54959 31.4058V12.4556L17.9609 2.98053Z");
			attr(path13, "fill", "url(#paint8_diamond_6485_42319)");
			attr(path14, "d", "M17.9609 2.98053L34.3723 12.4556V31.4058L17.9609 40.8809L1.54959 31.4058V12.4556L17.9609 2.98053Z");
			attr(path14, "fill", "url(#paint9_radial_6485_42319)");
			attr(path15, "d", "M9.5703 -1.42926L25.9816 8.04583V26.996L9.5703 36.4711L-6.84104 26.996V8.04583L9.5703 -1.42926Z");
			attr(path15, "fill", "url(#paint10_radial_6485_42319)");
			attr(g1, "mask", "url(#mask1_6485_42319)");
			attr(stop0, "offset", "0.565625");
			attr(stop0, "stop-color", "#2C7790");
			attr(stop1, "offset", "1");
			attr(stop1, "stop-color", "#1B2231");
			attr(radialGradient0, "id", "paint0_diamond_6485_42319");
			attr(radialGradient0, "cx", "0");
			attr(radialGradient0, "cy", "0");
			attr(radialGradient0, "r", "1");
			attr(radialGradient0, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient0, "gradientTransform", "translate(13.3758 20.3286) rotate(26.7796) scale(31.5396 44.4293)");
			attr(stop2, "offset", "0.565625");
			attr(stop2, "stop-color", "#2C7790");
			attr(stop3, "offset", "1");
			attr(stop3, "stop-color", "#1B2231");
			attr(radialGradient1, "id", "paint1_diamond_6485_42319");
			attr(radialGradient1, "cx", "0");
			attr(radialGradient1, "cy", "0");
			attr(radialGradient1, "r", "1");
			attr(radialGradient1, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient1, "gradientTransform", "translate(13.3758 20.3286) rotate(26.7796) scale(31.5396 44.4293)");
			attr(stop4, "offset", "0.565625");
			attr(stop4, "stop-color", "#2C7790");
			attr(stop5, "offset", "1");
			attr(stop5, "stop-color", "#1B2231");
			attr(radialGradient2, "id", "paint2_diamond_6485_42319");
			attr(radialGradient2, "cx", "0");
			attr(radialGradient2, "cy", "0");
			attr(radialGradient2, "r", "1");
			attr(radialGradient2, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient2, "gradientTransform", "translate(4.78456 14.9677) rotate(26.7796) scale(32.9182 46.3713)");
			attr(stop6, "stop-color", "#2DDEF8");
			attr(stop7, "offset", "0.452877");
			attr(stop7, "stop-color", "#31DBF4");
			attr(stop8, "offset", "0.747503");
			attr(stop8, "stop-color", "#56BCCF");
			attr(stop9, "offset", "1");
			attr(stop9, "stop-color", "#2C7790");
			attr(radialGradient3, "id", "paint3_diamond_6485_42319");
			attr(radialGradient3, "cx", "0");
			attr(radialGradient3, "cy", "0");
			attr(radialGradient3, "r", "1");
			attr(radialGradient3, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient3, "gradientTransform", "translate(13.9591 19.7894) rotate(23.4105) scale(29.0353 35.9193)");
			attr(stop10, "stop-color", "#27E4FF");
			attr(stop10, "stop-opacity", "0");
			attr(stop11, "offset", "1");
			attr(stop11, "stop-color", "#2C7790");
			attr(radialGradient4, "id", "paint4_radial_6485_42319");
			attr(radialGradient4, "cx", "0");
			attr(radialGradient4, "cy", "0");
			attr(radialGradient4, "r", "1");
			attr(radialGradient4, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient4, "gradientTransform", "translate(2.67252 15.7335) rotate(25.2223) scale(39.5908 26.7946)");
			attr(stop12, "stop-color", "#27E4FF");
			attr(stop13, "offset", "1");
			attr(stop13, "stop-color", "#56BCCF");
			attr(radialGradient5, "id", "paint5_radial_6485_42319");
			attr(radialGradient5, "cx", "0");
			attr(radialGradient5, "cy", "0");
			attr(radialGradient5, "r", "1");
			attr(radialGradient5, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient5, "gradientTransform", "translate(16.8178 21.9037) rotate(160.578) scale(43.7906 26.6126)");
			attr(stop14, "offset", "0.565625");
			attr(stop14, "stop-color", "#2C7790");
			attr(stop15, "offset", "1");
			attr(stop15, "stop-color", "#1B2231");
			attr(radialGradient6, "id", "paint6_diamond_6485_42319");
			attr(radialGradient6, "cx", "0");
			attr(radialGradient6, "cy", "0");
			attr(radialGradient6, "r", "1");
			attr(radialGradient6, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient6, "gradientTransform", "translate(13.3758 20.3286) rotate(26.7796) scale(31.5396 44.4293)");
			attr(stop16, "offset", "0.565625");
			attr(stop16, "stop-color", "#2C7790");
			attr(stop17, "offset", "1");
			attr(stop17, "stop-color", "#1B2231");
			attr(radialGradient7, "id", "paint7_diamond_6485_42319");
			attr(radialGradient7, "cx", "0");
			attr(radialGradient7, "cy", "0");
			attr(radialGradient7, "r", "1");
			attr(radialGradient7, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient7, "gradientTransform", "translate(4.78456 14.9677) rotate(26.7796) scale(32.9182 46.3713)");
			attr(stop18, "stop-color", "#2DDEF8");
			attr(stop19, "offset", "0.452877");
			attr(stop19, "stop-color", "#31DBF4");
			attr(stop20, "offset", "0.747503");
			attr(stop20, "stop-color", "#56BCCF");
			attr(stop21, "offset", "1");
			attr(stop21, "stop-color", "#2C7790");
			attr(radialGradient8, "id", "paint8_diamond_6485_42319");
			attr(radialGradient8, "cx", "0");
			attr(radialGradient8, "cy", "0");
			attr(radialGradient8, "r", "1");
			attr(radialGradient8, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient8, "gradientTransform", "translate(13.9591 19.7894) rotate(23.4105) scale(29.0353 35.9193)");
			attr(stop22, "stop-color", "#27E4FF");
			attr(stop22, "stop-opacity", "0");
			attr(stop23, "offset", "1");
			attr(stop23, "stop-color", "#2C7790");
			attr(radialGradient9, "id", "paint9_radial_6485_42319");
			attr(radialGradient9, "cx", "0");
			attr(radialGradient9, "cy", "0");
			attr(radialGradient9, "r", "1");
			attr(radialGradient9, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient9, "gradientTransform", "translate(2.67252 15.7335) rotate(25.2223) scale(39.5908 26.7946)");
			attr(stop24, "stop-color", "#27E4FF");
			attr(stop25, "offset", "1");
			attr(stop25, "stop-color", "#56BCCF");
			attr(radialGradient10, "id", "paint10_radial_6485_42319");
			attr(radialGradient10, "cx", "0");
			attr(radialGradient10, "cy", "0");
			attr(radialGradient10, "r", "1");
			attr(radialGradient10, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient10, "gradientTransform", "translate(16.8178 21.9037) rotate(160.578) scale(43.7906 26.6126)");
			attr(svg, "width", "52");
			attr(svg, "height", "54");
			attr(svg, "viewBox", "0 0 52 54");
			attr(svg, "fill", "none");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, rect);
			append(svg, path0);
			append(svg, path1);
			append(svg, mask0);
			append(mask0, path2);
			append(mask0, path3);
			append(svg, g0);
			append(g0, path4);
			append(g0, path5);
			append(g0, path6);
			append(g0, path7);
			append(g0, path8);
			append(svg, mask1);
			append(mask1, path9);
			append(mask1, path10);
			append(svg, g1);
			append(g1, path11);
			append(g1, path12);
			append(g1, path13);
			append(g1, path14);
			append(g1, path15);
			append(svg, defs);
			append(defs, radialGradient0);
			append(radialGradient0, stop0);
			append(radialGradient0, stop1);
			append(defs, radialGradient1);
			append(radialGradient1, stop2);
			append(radialGradient1, stop3);
			append(defs, radialGradient2);
			append(radialGradient2, stop4);
			append(radialGradient2, stop5);
			append(defs, radialGradient3);
			append(radialGradient3, stop6);
			append(radialGradient3, stop7);
			append(radialGradient3, stop8);
			append(radialGradient3, stop9);
			append(defs, radialGradient4);
			append(radialGradient4, stop10);
			append(radialGradient4, stop11);
			append(defs, radialGradient5);
			append(radialGradient5, stop12);
			append(radialGradient5, stop13);
			append(defs, radialGradient6);
			append(radialGradient6, stop14);
			append(radialGradient6, stop15);
			append(defs, radialGradient7);
			append(radialGradient7, stop16);
			append(radialGradient7, stop17);
			append(defs, radialGradient8);
			append(radialGradient8, stop18);
			append(radialGradient8, stop19);
			append(radialGradient8, stop20);
			append(radialGradient8, stop21);
			append(defs, radialGradient9);
			append(radialGradient9, stop22);
			append(radialGradient9, stop23);
			append(defs, radialGradient10);
			append(radialGradient10, stop24);
			append(radialGradient10, stop25);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

class Creator extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment$f, safe_not_equal, {});
	}
}

/* src/assets/apps/DialogueReview.svelte generated by Svelte v3.57.0 */

function create_fragment$e(ctx) {
	let svg;
	let rect;
	let path0;
	let path1;
	let path2;
	let defs;
	let radialGradient;
	let stop0;
	let stop1;
	let linearGradient;
	let stop2;
	let stop3;

	return {
		c() {
			svg = svg_element("svg");
			rect = svg_element("rect");
			path0 = svg_element("path");
			path1 = svg_element("path");
			path2 = svg_element("path");
			defs = svg_element("defs");
			radialGradient = svg_element("radialGradient");
			stop0 = svg_element("stop");
			stop1 = svg_element("stop");
			linearGradient = svg_element("linearGradient");
			stop2 = svg_element("stop");
			stop3 = svg_element("stop");
			attr(rect, "width", "52");
			attr(rect, "height", "54");
			attr(rect, "transform", "translate(0 0.428467)");
			attr(rect, "fill", "white");
			attr(path0, "fill-rule", "evenodd");
			attr(path0, "clip-rule", "evenodd");
			attr(path0, "d", "M11.1855 17.777H38.7078V35.5021H11.1855V17.777ZM19.6828 35.5025L19.6826 40.5112L13.8992 35.5025H19.6828Z");
			attr(path0, "fill", "#D9D9D9");
			attr(path1, "fill-rule", "evenodd");
			attr(path1, "clip-rule", "evenodd");
			attr(path1, "d", "M11.1855 17.777H38.7078V35.5021H11.1855V17.777ZM19.6828 35.5025L19.6826 40.5112L13.8992 35.5025H19.6828Z");
			attr(path1, "fill", "url(#paint0_radial_6485_42360)");
			attr(path2, "fill-rule", "evenodd");
			attr(path2, "clip-rule", "evenodd");
			attr(path2, "d", "M40.8147 19.9936L35.1781 14.357L32.943 16.5883L38.5815 22.2268L40.8147 19.9936ZM37.3334 23.4749L31.6938 17.8353L22.3005 27.2124L22.1291 33.0426L27.6151 33.1932L37.3334 23.4749Z");
			attr(path2, "fill", "url(#paint1_linear_6485_42360)");
			attr(stop0, "stop-color", "#2DDEF8");
			attr(stop1, "offset", "1");
			attr(stop1, "stop-color", "#56BCCF");
			attr(radialGradient, "id", "paint0_radial_6485_42360");
			attr(radialGradient, "cx", "0");
			attr(radialGradient, "cy", "0");
			attr(radialGradient, "r", "1");
			attr(radialGradient, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient, "gradientTransform", "translate(10.306 42.3493) rotate(-27.5862) scale(36.9 48.6203)");
			attr(stop2, "offset", "0.00312487");
			attr(stop2, "stop-color", "#2C7790");
			attr(stop3, "offset", "1");
			attr(stop3, "stop-color", "#1B2231");
			attr(linearGradient, "id", "paint1_linear_6485_42360");
			attr(linearGradient, "x1", "14.5054");
			attr(linearGradient, "y1", "35.8608");
			attr(linearGradient, "x2", "36.0241");
			attr(linearGradient, "y2", "39.7601");
			attr(linearGradient, "gradientUnits", "userSpaceOnUse");
			attr(svg, "width", "52");
			attr(svg, "height", "55");
			attr(svg, "viewBox", "0 0 52 55");
			attr(svg, "fill", "none");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, rect);
			append(svg, path0);
			append(svg, path1);
			append(svg, path2);
			append(svg, defs);
			append(defs, radialGradient);
			append(radialGradient, stop0);
			append(radialGradient, stop1);
			append(defs, linearGradient);
			append(linearGradient, stop2);
			append(linearGradient, stop3);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

class DialogueReview extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment$e, safe_not_equal, {});
	}
}

/* src/assets/apps/Engage.svelte generated by Svelte v3.57.0 */

function create_fragment$d(ctx) {
	let svg;
	let path0;
	let path1;
	let defs;
	let radialGradient0;
	let stop0;
	let stop1;
	let radialGradient1;
	let stop2;
	let stop3;

	return {
		c() {
			svg = svg_element("svg");
			path0 = svg_element("path");
			path1 = svg_element("path");
			defs = svg_element("defs");
			radialGradient0 = svg_element("radialGradient");
			stop0 = svg_element("stop");
			stop1 = svg_element("stop");
			radialGradient1 = svg_element("radialGradient");
			stop2 = svg_element("stop");
			stop3 = svg_element("stop");
			attr(path0, "fill-rule", "evenodd");
			attr(path0, "clip-rule", "evenodd");
			attr(path0, "d", "M12.3817 35.2857C10.5405 32.7411 9.4498 29.7311 9.2334 26.5976L17.6981 26.013C17.6859 26.1975 17.6797 26.3836 17.6797 26.5712C17.6797 31.1662 21.4047 34.8912 25.9997 34.8912C30.5947 34.8912 34.3197 31.1662 34.3197 26.5712C34.3197 22.4218 31.2822 18.9818 27.3094 18.3537L29.0656 8.92944C32.1533 9.50484 35.0179 10.9346 37.3339 13.0562C39.6499 15.1779 41.3245 17.9065 42.1676 20.9322C43.0107 23.9578 42.9885 27.1593 42.1035 30.1729C41.2185 33.1866 39.5061 35.8917 37.1609 37.981C34.8157 40.0703 31.9316 41.4601 28.8361 41.9926C25.7407 42.5251 22.5579 42.1789 19.6493 40.9934C16.7407 39.8078 14.2229 37.8304 12.3817 35.2857Z");
			attr(path0, "fill", "url(#paint0_radial_6485_42298)");
			attr(path1, "d", "M37.2123 18.1819C38.5674 20.3244 39.2867 22.8073 39.2867 25.3424L42.3689 25.3423L35.3278 33.5856L28.2866 25.3423L31.6635 25.3424C31.6635 24.25 31.3535 23.1801 30.7696 22.2569C30.1857 21.3338 29.3518 20.5952 28.3649 20.1271C27.3779 19.6591 26.2784 19.4806 25.1941 19.6126C24.1097 19.7446 23.0851 20.1815 22.2392 20.8727C21.3934 21.5638 20.761 22.4808 20.4156 23.5171C20.0702 24.5534 20.0259 25.6664 20.2879 26.7268C20.5499 27.7873 21.1074 28.7516 21.8957 29.5078C22.684 30.2639 23.6707 30.7809 24.7411 30.9986L23.2219 38.469C20.7377 37.9638 18.4479 36.764 16.6185 35.0092C14.7891 33.2543 13.4952 31.0164 12.8871 28.5554C12.2791 26.0944 12.3819 23.5114 13.1835 21.1064C13.9851 18.7015 15.4527 16.5734 17.4157 14.9694C19.3787 13.3655 21.7566 12.3514 24.273 12.0452C26.7895 11.7389 29.3412 12.153 31.6316 13.2393C33.9221 14.3256 35.8573 16.0395 37.2123 18.1819Z");
			attr(path1, "fill", "url(#paint1_angular_6485_42298)");
			attr(stop0, "stop-color", "#2DDEF8");
			attr(stop1, "offset", "1");
			attr(stop1, "stop-color", "#56BCCF");
			attr(radialGradient0, "id", "paint0_radial_6485_42298");
			attr(radialGradient0, "cx", "0");
			attr(radialGradient0, "cy", "0");
			attr(radialGradient0, "r", "1");
			attr(radialGradient0, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient0, "gradientTransform", "translate(28.1447 32.8084) rotate(9.82847) scale(32.6171 32.5089)");
			attr(stop2, "stop-color", "#2C7790");
			attr(stop3, "offset", "0.884465");
			attr(stop3, "stop-color", "#1B2231");
			attr(radialGradient1, "id", "paint1_angular_6485_42298");
			attr(radialGradient1, "cx", "0");
			attr(radialGradient1, "cy", "0");
			attr(radialGradient1, "r", "1");
			attr(radialGradient1, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient1, "gradientTransform", "translate(28.0994 25.2125) rotate(75.3552) scale(23.6359 23.6359)");
			attr(svg, "width", "52");
			attr(svg, "height", "53");
			attr(svg, "viewBox", "0 0 52 53");
			attr(svg, "fill", "none");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, path0);
			append(svg, path1);
			append(svg, defs);
			append(defs, radialGradient0);
			append(radialGradient0, stop0);
			append(radialGradient0, stop1);
			append(defs, radialGradient1);
			append(radialGradient1, stop2);
			append(radialGradient1, stop3);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

class Engage extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment$d, safe_not_equal, {});
	}
}

/* src/assets/apps/Fast.svelte generated by Svelte v3.57.0 */

function create_fragment$c(ctx) {
	let svg;
	let path0;
	let path1;
	let defs;
	let radialGradient0;
	let stop0;
	let stop1;
	let radialGradient1;
	let stop2;
	let stop3;

	return {
		c() {
			svg = svg_element("svg");
			path0 = svg_element("path");
			path1 = svg_element("path");
			defs = svg_element("defs");
			radialGradient0 = svg_element("radialGradient");
			stop0 = svg_element("stop");
			stop1 = svg_element("stop");
			radialGradient1 = svg_element("radialGradient");
			stop2 = svg_element("stop");
			stop3 = svg_element("stop");
			attr(path0, "d", "M14.5605 29.6844L31.2848 7.94287L26.0585 29.6844H14.5605Z");
			attr(path0, "fill", "url(#paint0_radial_6485_42300)");
			attr(path1, "d", "M37.4634 22.6012L20.7392 44.3427L24.2629 29.6842H14.5605L20.0091 22.6011L37.4634 22.6012Z");
			attr(path1, "fill", "url(#paint1_angular_6485_42300)");
			attr(stop0, "stop-color", "#2DDEF8");
			attr(stop1, "offset", "1");
			attr(stop1, "stop-color", "#56BCCF");
			attr(radialGradient0, "id", "paint0_radial_6485_42300");
			attr(radialGradient0, "cx", "0");
			attr(radialGradient0, "cy", "0");
			attr(radialGradient0, "r", "1");
			attr(radialGradient0, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient0, "gradientTransform", "translate(22.9511 21.4571) rotate(103.358) scale(17.1616 18.6553)");
			attr(stop2, "offset", "0.164583");
			attr(stop2, "stop-color", "#1B2231");
			attr(stop3, "offset", "1");
			attr(stop3, "stop-color", "#2C7790");
			attr(radialGradient1, "id", "paint1_angular_6485_42300");
			attr(radialGradient1, "cx", "0");
			attr(radialGradient1, "cy", "0");
			attr(radialGradient1, "r", "1");
			attr(radialGradient1, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient1, "gradientTransform", "translate(24.403 29.6101) rotate(102.609) scale(13.047 17.3216)");
			attr(svg, "width", "52");
			attr(svg, "height", "53");
			attr(svg, "viewBox", "0 0 52 53");
			attr(svg, "fill", "none");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, path0);
			append(svg, path1);
			append(svg, defs);
			append(defs, radialGradient0);
			append(radialGradient0, stop0);
			append(radialGradient0, stop1);
			append(defs, radialGradient1);
			append(radialGradient1, stop2);
			append(radialGradient1, stop3);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

class Fast extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment$c, safe_not_equal, {});
	}
}

/* src/assets/apps/Insights.svelte generated by Svelte v3.57.0 */

function create_fragment$b(ctx) {
	let svg;
	let path0;
	let path1;
	let path2;
	let mask;
	let path3;
	let path4;
	let path5;
	let g;
	let path6;
	let path7;
	let defs;
	let radialGradient0;
	let stop0;
	let stop1;
	let radialGradient1;
	let stop2;
	let stop3;
	let radialGradient2;
	let stop4;
	let stop5;
	let radialGradient3;
	let stop6;
	let stop7;
	let radialGradient4;
	let stop8;
	let stop9;
	let radialGradient5;
	let stop10;
	let stop11;
	let radialGradient6;
	let stop12;
	let stop13;

	return {
		c() {
			svg = svg_element("svg");
			path0 = svg_element("path");
			path1 = svg_element("path");
			path2 = svg_element("path");
			mask = svg_element("mask");
			path3 = svg_element("path");
			path4 = svg_element("path");
			path5 = svg_element("path");
			g = svg_element("g");
			path6 = svg_element("path");
			path7 = svg_element("path");
			defs = svg_element("defs");
			radialGradient0 = svg_element("radialGradient");
			stop0 = svg_element("stop");
			stop1 = svg_element("stop");
			radialGradient1 = svg_element("radialGradient");
			stop2 = svg_element("stop");
			stop3 = svg_element("stop");
			radialGradient2 = svg_element("radialGradient");
			stop4 = svg_element("stop");
			stop5 = svg_element("stop");
			radialGradient3 = svg_element("radialGradient");
			stop6 = svg_element("stop");
			stop7 = svg_element("stop");
			radialGradient4 = svg_element("radialGradient");
			stop8 = svg_element("stop");
			stop9 = svg_element("stop");
			radialGradient5 = svg_element("radialGradient");
			stop10 = svg_element("stop");
			stop11 = svg_element("stop");
			radialGradient6 = svg_element("radialGradient");
			stop12 = svg_element("stop");
			stop13 = svg_element("stop");
			attr(path0, "d", "M11.8242 27.0425H19.5633V40.0331H11.8242V27.0425Z");
			attr(path0, "fill", "url(#paint0_angular_6485_42331)");
			attr(path1, "d", "M20.9453 20.9618H29.5135V40.0331H20.9453V20.9618Z");
			attr(path1, "fill", "url(#paint1_angular_6485_42331)");
			attr(path2, "d", "M30.8955 11.0116H40.8457V40.0331H30.8955V11.0116Z");
			attr(path2, "fill", "url(#paint2_angular_6485_42331)");
			attr(path3, "d", "M11.8242 27.0425H19.5633V40.0331H11.8242V27.0425Z");
			attr(path3, "fill", "url(#paint3_angular_6485_42331)");
			attr(path4, "d", "M20.9453 20.9618H29.5135V40.0331H20.9453V20.9618Z");
			attr(path4, "fill", "url(#paint4_angular_6485_42331)");
			attr(path5, "d", "M30.8955 11.0116H40.8457V40.0331H30.8955V11.0116Z");
			attr(path5, "fill", "url(#paint5_angular_6485_42331)");
			attr(mask, "id", "mask0_6485_42331");
			set_style(mask, "mask-type", "alpha");
			attr(mask, "maskUnits", "userSpaceOnUse");
			attr(mask, "x", "11");
			attr(mask, "y", "11");
			attr(mask, "width", "30");
			attr(mask, "height", "30");
			attr(path6, "d", "M11.8242 34.3591L40.8457 19.5398V40.033H11.8242V34.3591Z");
			attr(path6, "fill", "#D9D9D9");
			attr(path7, "d", "M11.8242 34.3591L40.8457 19.5398V40.033H11.8242V34.3591Z");
			attr(path7, "fill", "url(#paint6_radial_6485_42331)");
			attr(g, "mask", "url(#mask0_6485_42331)");
			attr(stop0, "stop-color", "#2C7790");
			attr(stop1, "offset", "1");
			attr(stop1, "stop-color", "#1B2231");
			attr(radialGradient0, "id", "paint0_angular_6485_42331");
			attr(radialGradient0, "cx", "0");
			attr(radialGradient0, "cy", "0");
			attr(radialGradient0, "r", "1");
			attr(radialGradient0, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient0, "gradientTransform", "translate(28.3249 27.2101) rotate(-27.4037) scale(22.7443 22.7443)");
			attr(stop2, "stop-color", "#2C7790");
			attr(stop3, "offset", "1");
			attr(stop3, "stop-color", "#1B2231");
			attr(radialGradient1, "id", "paint1_angular_6485_42331");
			attr(radialGradient1, "cx", "0");
			attr(radialGradient1, "cy", "0");
			attr(radialGradient1, "r", "1");
			attr(radialGradient1, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient1, "gradientTransform", "translate(28.3249 27.2101) rotate(-27.4037) scale(22.7443 22.7443)");
			attr(stop4, "stop-color", "#2C7790");
			attr(stop5, "offset", "1");
			attr(stop5, "stop-color", "#1B2231");
			attr(radialGradient2, "id", "paint2_angular_6485_42331");
			attr(radialGradient2, "cx", "0");
			attr(radialGradient2, "cy", "0");
			attr(radialGradient2, "r", "1");
			attr(radialGradient2, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient2, "gradientTransform", "translate(28.3249 27.2101) rotate(-27.4037) scale(22.7443 22.7443)");
			attr(stop6, "stop-color", "#2C7790");
			attr(stop7, "offset", "1");
			attr(stop7, "stop-color", "#1B2231");
			attr(radialGradient3, "id", "paint3_angular_6485_42331");
			attr(radialGradient3, "cx", "0");
			attr(radialGradient3, "cy", "0");
			attr(radialGradient3, "r", "1");
			attr(radialGradient3, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient3, "gradientTransform", "translate(28.3249 27.2101) rotate(-27.4037) scale(22.7443 22.7443)");
			attr(stop8, "stop-color", "#2C7790");
			attr(stop9, "offset", "1");
			attr(stop9, "stop-color", "#1B2231");
			attr(radialGradient4, "id", "paint4_angular_6485_42331");
			attr(radialGradient4, "cx", "0");
			attr(radialGradient4, "cy", "0");
			attr(radialGradient4, "r", "1");
			attr(radialGradient4, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient4, "gradientTransform", "translate(28.3249 27.2101) rotate(-27.4037) scale(22.7443 22.7443)");
			attr(stop10, "stop-color", "#2C7790");
			attr(stop11, "offset", "1");
			attr(stop11, "stop-color", "#1B2231");
			attr(radialGradient5, "id", "paint5_angular_6485_42331");
			attr(radialGradient5, "cx", "0");
			attr(radialGradient5, "cy", "0");
			attr(radialGradient5, "r", "1");
			attr(radialGradient5, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient5, "gradientTransform", "translate(28.3249 27.2101) rotate(-27.4037) scale(22.7443 22.7443)");
			attr(stop12, "stop-color", "#2DDEF8");
			attr(stop13, "offset", "1");
			attr(stop13, "stop-color", "#56BCCF");
			attr(radialGradient6, "id", "paint6_radial_6485_42331");
			attr(radialGradient6, "cx", "0");
			attr(radialGradient6, "cy", "0");
			attr(radialGradient6, "r", "1");
			attr(radialGradient6, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient6, "gradientTransform", "translate(10.8967 41.69) rotate(-24.0679) scale(37.7702 45.1504)");
			attr(svg, "width", "52");
			attr(svg, "height", "53");
			attr(svg, "viewBox", "0 0 52 53");
			attr(svg, "fill", "none");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, path0);
			append(svg, path1);
			append(svg, path2);
			append(svg, mask);
			append(mask, path3);
			append(mask, path4);
			append(mask, path5);
			append(svg, g);
			append(g, path6);
			append(g, path7);
			append(svg, defs);
			append(defs, radialGradient0);
			append(radialGradient0, stop0);
			append(radialGradient0, stop1);
			append(defs, radialGradient1);
			append(radialGradient1, stop2);
			append(radialGradient1, stop3);
			append(defs, radialGradient2);
			append(radialGradient2, stop4);
			append(radialGradient2, stop5);
			append(defs, radialGradient3);
			append(radialGradient3, stop6);
			append(radialGradient3, stop7);
			append(defs, radialGradient4);
			append(radialGradient4, stop8);
			append(radialGradient4, stop9);
			append(defs, radialGradient5);
			append(radialGradient5, stop10);
			append(radialGradient5, stop11);
			append(defs, radialGradient6);
			append(radialGradient6, stop12);
			append(radialGradient6, stop13);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

class Insights extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment$b, safe_not_equal, {});
	}
}

/* src/assets/apps/LiveLeaderboards.svelte generated by Svelte v3.57.0 */

function create_fragment$a(ctx) {
	let svg;
	let rect;
	let path0;
	let path1;
	let path2;
	let path3;
	let defs;
	let radialGradient0;
	let stop0;
	let stop1;
	let linearGradient;
	let stop2;
	let stop3;
	let radialGradient1;
	let stop4;
	let stop5;

	return {
		c() {
			svg = svg_element("svg");
			rect = svg_element("rect");
			path0 = svg_element("path");
			path1 = svg_element("path");
			path2 = svg_element("path");
			path3 = svg_element("path");
			defs = svg_element("defs");
			radialGradient0 = svg_element("radialGradient");
			stop0 = svg_element("stop");
			stop1 = svg_element("stop");
			linearGradient = svg_element("linearGradient");
			stop2 = svg_element("stop");
			stop3 = svg_element("stop");
			radialGradient1 = svg_element("radialGradient");
			stop4 = svg_element("stop");
			stop5 = svg_element("stop");
			attr(rect, "width", "52");
			attr(rect, "height", "52");
			attr(rect, "transform", "translate(0 0.285645)");
			attr(rect, "fill", "white");
			attr(path0, "fill-rule", "evenodd");
			attr(path0, "clip-rule", "evenodd");
			attr(path0, "d", "M20.1862 22.952L26.0533 16.5732L31.5288 22.6362L18.7279 36.0561L12.3203 36.0561V31.504L19.1506 24.078L19.1602 24.0882L20.1862 22.952ZM18.084 22.9583L12.3203 16.9073V29.2247L18.084 22.9583ZM21.0597 36.0561L38.568 36.0563L39.6799 16.9073L32.84 24.0882L32.6628 23.892L21.0597 36.0561Z");
			attr(path0, "fill", "url(#paint0_angular_6485_42301)");
			attr(path1, "fill-rule", "evenodd");
			attr(path1, "clip-rule", "evenodd");
			attr(path1, "d", "M20.1862 22.952L26.0533 16.5732L31.5288 22.6362L18.7279 36.0561L12.3203 36.0561V31.504L19.1506 24.078L19.1602 24.0882L20.1862 22.952ZM18.084 22.9583L12.3203 16.9073V29.2247L18.084 22.9583ZM21.0597 36.0561L38.568 36.0563L39.6799 16.9073L32.84 24.0882L32.6628 23.892L21.0597 36.0561Z");
			attr(path1, "fill", "url(#paint1_linear_6485_42301)");
			attr(path2, "d", "M20.9805 36.0567L39.6803 16.5146V36.0563H23.801L20.9805 36.0567Z");
			attr(path2, "fill", "white");
			attr(path3, "d", "M20.9805 36.0567L39.6803 16.5146V36.0563H23.801L20.9805 36.0567Z");
			attr(path3, "fill", "url(#paint2_radial_6485_42301)");
			attr(stop0, "offset", "0.247917");
			attr(stop0, "stop-color", "#2C7790");
			attr(stop1, "offset", "1");
			attr(stop1, "stop-color", "#1B2231");
			attr(radialGradient0, "id", "paint0_angular_6485_42301");
			attr(radialGradient0, "cx", "0");
			attr(radialGradient0, "cy", "0");
			attr(radialGradient0, "r", "1");
			attr(radialGradient0, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient0, "gradientTransform", "translate(23.9666 21.7918) rotate(34.1146) scale(14.5209 13.5051)");
			attr(stop2, "offset", "0.00312487");
			attr(stop2, "stop-color", "#2C7790");
			attr(stop3, "offset", "1");
			attr(stop3, "stop-color", "#1B2231");
			attr(linearGradient, "id", "paint1_linear_6485_42301");
			attr(linearGradient, "x1", "7.30749");
			attr(linearGradient, "y1", "40.0619");
			attr(linearGradient, "x2", "26.6622");
			attr(linearGradient, "y2", "12.1917");
			attr(linearGradient, "gradientUnits", "userSpaceOnUse");
			attr(stop4, "stop-color", "#2DDEF8");
			attr(stop5, "offset", "1");
			attr(stop5, "stop-color", "#56BCCF");
			attr(radialGradient1, "id", "paint2_radial_6485_42301");
			attr(radialGradient1, "cx", "0");
			attr(radialGradient1, "cy", "0");
			attr(radialGradient1, "r", "1");
			attr(radialGradient1, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient1, "gradientTransform", "translate(29.2433 28.3972) rotate(38.4394) scale(18.8271 20.6236)");
			attr(svg, "width", "52");
			attr(svg, "height", "53");
			attr(svg, "viewBox", "0 0 52 53");
			attr(svg, "fill", "none");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, rect);
			append(svg, path0);
			append(svg, path1);
			append(svg, path2);
			append(svg, path3);
			append(svg, defs);
			append(defs, radialGradient0);
			append(radialGradient0, stop0);
			append(radialGradient0, stop1);
			append(defs, linearGradient);
			append(linearGradient, stop2);
			append(linearGradient, stop3);
			append(defs, radialGradient1);
			append(radialGradient1, stop4);
			append(radialGradient1, stop5);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

class LiveLeaderboards extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment$a, safe_not_equal, {});
	}
}

/* src/assets/apps/Portal.svelte generated by Svelte v3.57.0 */

function create_fragment$9(ctx) {
	let svg;
	let g;
	let rect0;
	let rect1;
	let rect2;
	let path0;
	let path1;
	let path2;
	let path3;
	let path4;
	let path5;
	let defs;
	let radialGradient0;
	let stop0;
	let stop1;
	let radialGradient1;
	let stop2;
	let stop3;
	let radialGradient2;
	let stop4;
	let stop5;
	let radialGradient3;
	let stop6;
	let stop7;
	let radialGradient4;
	let stop8;
	let stop9;
	let radialGradient5;
	let stop10;
	let stop11;
	let radialGradient6;
	let stop12;
	let stop13;
	let radialGradient7;
	let stop14;
	let stop15;
	let clipPath;
	let rect3;

	return {
		c() {
			svg = svg_element("svg");
			g = svg_element("g");
			rect0 = svg_element("rect");
			rect1 = svg_element("rect");
			rect2 = svg_element("rect");
			path0 = svg_element("path");
			path1 = svg_element("path");
			path2 = svg_element("path");
			path3 = svg_element("path");
			path4 = svg_element("path");
			path5 = svg_element("path");
			defs = svg_element("defs");
			radialGradient0 = svg_element("radialGradient");
			stop0 = svg_element("stop");
			stop1 = svg_element("stop");
			radialGradient1 = svg_element("radialGradient");
			stop2 = svg_element("stop");
			stop3 = svg_element("stop");
			radialGradient2 = svg_element("radialGradient");
			stop4 = svg_element("stop");
			stop5 = svg_element("stop");
			radialGradient3 = svg_element("radialGradient");
			stop6 = svg_element("stop");
			stop7 = svg_element("stop");
			radialGradient4 = svg_element("radialGradient");
			stop8 = svg_element("stop");
			stop9 = svg_element("stop");
			radialGradient5 = svg_element("radialGradient");
			stop10 = svg_element("stop");
			stop11 = svg_element("stop");
			radialGradient6 = svg_element("radialGradient");
			stop12 = svg_element("stop");
			stop13 = svg_element("stop");
			radialGradient7 = svg_element("radialGradient");
			stop14 = svg_element("stop");
			stop15 = svg_element("stop");
			clipPath = svg_element("clipPath");
			rect3 = svg_element("rect");
			attr(rect0, "width", "52");
			attr(rect0, "height", "52");
			attr(rect0, "fill", "white");
			attr(rect1, "width", "22.2714");
			attr(rect1, "height", "8.57775");
			attr(rect1, "transform", "matrix(-0.708317 -0.705895 0.708317 -0.705895 36.502 29.5762)");
			attr(rect1, "fill", "url(#paint0_angular_6485_42332)");
			attr(rect2, "width", "22.2714");
			attr(rect2, "height", "8.57775");
			attr(rect2, "transform", "matrix(-0.708317 -0.705895 0.708317 -0.705895 36.502 29.5762)");
			attr(rect2, "fill", "url(#paint1_radial_6485_42332)");
			attr(path0, "d", "M32.8645 38.1625L42.5742 28.4869L40.0845 26.0011L36.4967 29.5743L32.9134 26.0047L26.7925 32.1159L32.8645 38.1625Z");
			attr(path0, "fill", "url(#paint2_radial_6485_42332)");
			attr(path1, "d", "M32.8645 38.1625L42.5742 28.4869L40.0845 26.0011L36.4967 29.5743L32.9134 26.0047L26.7925 32.1159L32.8645 38.1625Z");
			attr(path1, "fill", "url(#paint3_angular_6485_42332)");
			attr(path2, "d", "M17.0918 22.4399L20.6721 26.008L32.867 38.1612L26.7912 44.2162L11.016 28.4949L13.5133 26.008L17.0918 22.4399Z");
			attr(path2, "fill", "url(#paint4_angular_6485_42332)");
			attr(path3, "d", "M17.0918 22.4399L20.6721 26.008L32.867 38.1612L26.7912 44.2162L11.016 28.4949L13.5133 26.008L17.0918 22.4399Z");
			attr(path3, "fill", "url(#paint5_radial_6485_42332)");
			attr(path4, "d", "M20.7263 13.8553L11.0166 23.5309L13.5063 26.0167L17.0941 22.4435L20.6774 26.0131L26.7984 19.902L20.7263 13.8553Z");
			attr(path4, "fill", "url(#paint6_radial_6485_42332)");
			attr(path5, "d", "M20.7263 13.8553L11.0166 23.5309L13.5063 26.0167L17.0941 22.4435L20.6774 26.0131L26.7984 19.902L20.7263 13.8553Z");
			attr(path5, "fill", "url(#paint7_angular_6485_42332)");
			attr(g, "clip-path", "url(#clip0_6485_42332)");
			attr(stop0, "offset", "0.20625");
			attr(stop0, "stop-color", "#1B2231");
			attr(stop1, "offset", "0.586458");
			attr(stop1, "stop-color", "#2C7790");
			attr(radialGradient0, "id", "paint0_angular_6485_42332");
			attr(radialGradient0, "cx", "0");
			attr(radialGradient0, "cy", "0");
			attr(radialGradient0, "r", "1");
			attr(radialGradient0, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient0, "gradientTransform", "translate(22.1278 -0.102743) rotate(0.51631) scale(16.1279 14.5757)");
			attr(stop2, "stop-color", "#2DDEF8");
			attr(stop3, "offset", "1");
			attr(stop3, "stop-color", "#56BCCF");
			attr(radialGradient1, "id", "paint1_radial_6485_42332");
			attr(radialGradient1, "cx", "0");
			attr(radialGradient1, "cy", "0");
			attr(radialGradient1, "r", "1");
			attr(radialGradient1, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient1, "gradientTransform", "translate(19.93 1.68795) rotate(155.927) scale(21.0136 16.6018)");
			attr(stop4, "stop-color", "#2DDEF8");
			attr(stop5, "offset", "1");
			attr(stop5, "stop-color", "#56BCCF");
			attr(radialGradient2, "id", "paint2_radial_6485_42332");
			attr(radialGradient2, "cx", "0");
			attr(radialGradient2, "cy", "0");
			attr(radialGradient2, "r", "1");
			attr(radialGradient2, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient2, "gradientTransform", "translate(29.3006 35.7816) rotate(-46.6892) scale(14.6423 15.4336)");
			attr(stop6, "offset", "0.20625");
			attr(stop6, "stop-color", "#1B2231");
			attr(stop7, "offset", "0.958333");
			attr(stop7, "stop-color", "#2C7790");
			attr(radialGradient3, "id", "paint3_angular_6485_42332");
			attr(radialGradient3, "cx", "0");
			attr(radialGradient3, "cy", "0");
			attr(radialGradient3, "r", "1");
			attr(radialGradient3, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient3, "gradientTransform", "translate(32.3058 39.2653) rotate(-135.744) scale(14.4464)");
			attr(stop8, "offset", "0.0656249");
			attr(stop8, "stop-color", "#1B2231");
			attr(stop9, "offset", "0.651042");
			attr(stop9, "stop-color", "#2C7790");
			attr(radialGradient4, "id", "paint4_angular_6485_42332");
			attr(radialGradient4, "cx", "0");
			attr(radialGradient4, "cy", "0");
			attr(radialGradient4, "r", "1");
			attr(radialGradient4, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient4, "gradientTransform", "translate(10.9883 28.623) rotate(44.5965) scale(22.288 22.288)");
			attr(stop10, "stop-color", "#2DDEF8");
			attr(stop11, "offset", "1");
			attr(stop11, "stop-color", "#56BCCF");
			attr(radialGradient5, "id", "paint5_radial_6485_42332");
			attr(radialGradient5, "cx", "0");
			attr(radialGradient5, "cy", "0");
			attr(radialGradient5, "r", "1");
			attr(radialGradient5, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient5, "gradientTransform", "translate(17.1832 26.2651) rotate(52.6668) scale(19.6864 15.5135)");
			attr(stop12, "stop-color", "#2DDEF8");
			attr(stop13, "offset", "1");
			attr(stop13, "stop-color", "#56BCCF");
			attr(radialGradient6, "id", "paint6_radial_6485_42332");
			attr(radialGradient6, "cx", "0");
			attr(radialGradient6, "cy", "0");
			attr(radialGradient6, "r", "1");
			attr(radialGradient6, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient6, "gradientTransform", "translate(25.1392 16.2484) rotate(138.207) scale(18.2352 19.2206)");
			attr(stop14, "offset", "0.00520833");
			attr(stop14, "stop-color", "#1B2231");
			attr(stop15, "offset", "0.328125");
			attr(stop15, "stop-color", "#2C7790");
			attr(radialGradient7, "id", "paint7_angular_6485_42332");
			attr(radialGradient7, "cx", "0");
			attr(radialGradient7, "cy", "0");
			attr(radialGradient7, "r", "1");
			attr(radialGradient7, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient7, "gradientTransform", "translate(20.3675 13.2651) rotate(42.3246) scale(20.0951 20.0951)");
			attr(rect3, "width", "52");
			attr(rect3, "height", "52");
			attr(rect3, "fill", "white");
			attr(clipPath, "id", "clip0_6485_42332");
			attr(svg, "width", "52");
			attr(svg, "height", "52");
			attr(svg, "viewBox", "0 0 52 52");
			attr(svg, "fill", "none");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, g);
			append(g, rect0);
			append(g, rect1);
			append(g, rect2);
			append(g, path0);
			append(g, path1);
			append(g, path2);
			append(g, path3);
			append(g, path4);
			append(g, path5);
			append(svg, defs);
			append(defs, radialGradient0);
			append(radialGradient0, stop0);
			append(radialGradient0, stop1);
			append(defs, radialGradient1);
			append(radialGradient1, stop2);
			append(radialGradient1, stop3);
			append(defs, radialGradient2);
			append(radialGradient2, stop4);
			append(radialGradient2, stop5);
			append(defs, radialGradient3);
			append(radialGradient3, stop6);
			append(radialGradient3, stop7);
			append(defs, radialGradient4);
			append(radialGradient4, stop8);
			append(radialGradient4, stop9);
			append(defs, radialGradient5);
			append(radialGradient5, stop10);
			append(radialGradient5, stop11);
			append(defs, radialGradient6);
			append(radialGradient6, stop12);
			append(radialGradient6, stop13);
			append(defs, radialGradient7);
			append(radialGradient7, stop14);
			append(radialGradient7, stop15);
			append(defs, clipPath);
			append(clipPath, rect3);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

class Portal extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment$9, safe_not_equal, {});
	}
}

/* src/assets/apps/ProcessDocs.svelte generated by Svelte v3.57.0 */

function create_fragment$8(ctx) {
	let svg;
	let path0;
	let path1;
	let path2;
	let path3;
	let path4;
	let path5;
	let path6;
	let defs;
	let radialGradient0;
	let stop0;
	let stop1;
	let radialGradient1;
	let stop2;
	let stop3;
	let radialGradient2;
	let stop4;
	let stop5;
	let radialGradient3;
	let stop6;
	let stop7;
	let linearGradient0;
	let stop8;
	let stop9;
	let radialGradient4;
	let stop10;
	let stop11;
	let linearGradient1;
	let stop12;
	let stop13;

	return {
		c() {
			svg = svg_element("svg");
			path0 = svg_element("path");
			path1 = svg_element("path");
			path2 = svg_element("path");
			path3 = svg_element("path");
			path4 = svg_element("path");
			path5 = svg_element("path");
			path6 = svg_element("path");
			defs = svg_element("defs");
			radialGradient0 = svg_element("radialGradient");
			stop0 = svg_element("stop");
			stop1 = svg_element("stop");
			radialGradient1 = svg_element("radialGradient");
			stop2 = svg_element("stop");
			stop3 = svg_element("stop");
			radialGradient2 = svg_element("radialGradient");
			stop4 = svg_element("stop");
			stop5 = svg_element("stop");
			radialGradient3 = svg_element("radialGradient");
			stop6 = svg_element("stop");
			stop7 = svg_element("stop");
			linearGradient0 = svg_element("linearGradient");
			stop8 = svg_element("stop");
			stop9 = svg_element("stop");
			radialGradient4 = svg_element("radialGradient");
			stop10 = svg_element("stop");
			stop11 = svg_element("stop");
			linearGradient1 = svg_element("linearGradient");
			stop12 = svg_element("stop");
			stop13 = svg_element("stop");
			attr(path0, "d", "M17.3143 14.6464L27.3774 24.6932L23.5016 28.5627L13.4385 18.5159L17.3143 14.6464Z");
			attr(path0, "fill", "url(#paint0_radial_6485_42309)");
			attr(path1, "fill-rule", "evenodd");
			attr(path1, "clip-rule", "evenodd");
			attr(path1, "d", "M42.1325 24.6825L35.4079 17.9675L34.1948 16.7562L29.0919 14.4198L21.3103 10.6051L17.948 13.9626L35.4079 31.3975L42.1325 24.6825Z");
			attr(path1, "fill", "url(#paint1_radial_6485_42309)");
			attr(path2, "d", "M26.5654 16.1245L21.3145 10.6235L34.1943 16.7165L26.5654 16.1245Z");
			attr(path2, "fill", "url(#paint2_radial_6485_42309)");
			attr(path3, "d", "M17.9883 35.4266L35.4482 17.9917L42.1728 24.7067L24.7129 42.1417L17.9883 35.4266Z");
			attr(path3, "fill", "url(#paint3_angular_6485_42309)");
			attr(path4, "d", "M17.9883 35.4266L35.4482 17.9917L42.1728 24.7067L24.7129 42.1417L17.9883 35.4266Z");
			attr(path4, "fill", "url(#paint4_linear_6485_42309)");
			attr(path5, "d", "M13.4736 30.8903L23.5368 20.8435L27.4125 24.713L17.3494 34.7598L13.4736 30.8903Z");
			attr(path5, "fill", "url(#paint5_angular_6485_42309)");
			attr(path6, "d", "M13.4736 30.8903L23.5368 20.8435L27.4125 24.713L17.3494 34.7598L13.4736 30.8903Z");
			attr(path6, "fill", "url(#paint6_linear_6485_42309)");
			attr(stop0, "stop-color", "#2DDEF8");
			attr(stop1, "offset", "1");
			attr(stop1, "stop-color", "#56BCCF");
			attr(radialGradient0, "id", "paint0_radial_6485_42309");
			attr(radialGradient0, "cx", "0");
			attr(radialGradient0, "cy", "0");
			attr(radialGradient0, "r", "1");
			attr(radialGradient0, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient0, "gradientTransform", "translate(27.0507 24.6257) rotate(165.735) scale(15.5327 18.5396)");
			attr(stop2, "stop-color", "#2DDEF8");
			attr(stop3, "offset", "1");
			attr(stop3, "stop-color", "#56BCCF");
			attr(radialGradient1, "id", "paint1_radial_6485_42309");
			attr(radialGradient1, "cx", "0");
			attr(radialGradient1, "cy", "0");
			attr(radialGradient1, "r", "1");
			attr(radialGradient1, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient1, "gradientTransform", "translate(27.0507 24.6257) rotate(165.735) scale(15.5327 18.5396)");
			attr(stop4, "stop-color", "#1B2231");
			attr(stop5, "offset", "1");
			attr(stop5, "stop-color", "#2C7790");
			attr(radialGradient2, "id", "paint2_radial_6485_42309");
			attr(radialGradient2, "cx", "0");
			attr(radialGradient2, "cy", "0");
			attr(radialGradient2, "r", "1");
			attr(radialGradient2, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient2, "gradientTransform", "translate(21.8145 9.37331) rotate(44.658) scale(12.4912 5.10574)");
			attr(stop6, "offset", "0.247917");
			attr(stop6, "stop-color", "#2C7790");
			attr(stop7, "offset", "1");
			attr(stop7, "stop-color", "#1B2231");
			attr(radialGradient3, "id", "paint3_angular_6485_42309");
			attr(radialGradient3, "cx", "0");
			attr(radialGradient3, "cy", "0");
			attr(radialGradient3, "r", "1");
			attr(radialGradient3, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient3, "gradientTransform", "translate(28.283 24.5134) rotate(43.4425) scale(14.6363 14.6363)");
			attr(stop8, "offset", "0.00312487");
			attr(stop8, "stop-color", "#2C7790");
			attr(stop9, "offset", "1");
			attr(stop9, "stop-color", "#1B2231");
			attr(linearGradient0, "id", "paint4_linear_6485_42309");
			attr(linearGradient0, "x1", "13.5572");
			attr(linearGradient0, "y1", "47.0915");
			attr(linearGradient0, "x2", "39.072");
			attr(linearGradient0, "y2", "20.8112");
			attr(linearGradient0, "gradientUnits", "userSpaceOnUse");
			attr(stop10, "offset", "0.247917");
			attr(stop10, "stop-color", "#2C7790");
			attr(stop11, "offset", "1");
			attr(stop11, "stop-color", "#1B2231");
			attr(radialGradient4, "id", "paint5_angular_6485_42309");
			attr(radialGradient4, "cx", "0");
			attr(radialGradient4, "cy", "0");
			attr(radialGradient4, "r", "1");
			attr(radialGradient4, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient4, "gradientTransform", "translate(19.5309 24.5762) rotate(44.8571) scale(17.7251 17.7251)");
			attr(stop12, "offset", "0.00312487");
			attr(stop12, "stop-color", "#2C7790");
			attr(stop13, "offset", "1");
			attr(stop13, "stop-color", "#1B2231");
			attr(linearGradient1, "id", "paint6_linear_6485_42309");
			attr(linearGradient1, "x1", "13.5567");
			attr(linearGradient1, "y1", "47.0918");
			attr(linearGradient1, "x2", "39.0716");
			attr(linearGradient1, "y2", "20.8115");
			attr(linearGradient1, "gradientUnits", "userSpaceOnUse");
			attr(svg, "width", "52");
			attr(svg, "height", "52");
			attr(svg, "viewBox", "0 0 52 52");
			attr(svg, "fill", "none");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, path0);
			append(svg, path1);
			append(svg, path2);
			append(svg, path3);
			append(svg, path4);
			append(svg, path5);
			append(svg, path6);
			append(svg, defs);
			append(defs, radialGradient0);
			append(radialGradient0, stop0);
			append(radialGradient0, stop1);
			append(defs, radialGradient1);
			append(radialGradient1, stop2);
			append(radialGradient1, stop3);
			append(defs, radialGradient2);
			append(radialGradient2, stop4);
			append(radialGradient2, stop5);
			append(defs, radialGradient3);
			append(radialGradient3, stop6);
			append(radialGradient3, stop7);
			append(defs, linearGradient0);
			append(linearGradient0, stop8);
			append(linearGradient0, stop9);
			append(defs, radialGradient4);
			append(radialGradient4, stop10);
			append(radialGradient4, stop11);
			append(defs, linearGradient1);
			append(linearGradient1, stop12);
			append(linearGradient1, stop13);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

class ProcessDocs extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment$8, safe_not_equal, {});
	}
}

/* src/assets/apps/QuizRace.svelte generated by Svelte v3.57.0 */

function create_fragment$7(ctx) {
	let svg;
	let g;
	let rect0;
	let path0;
	let path1;
	let path2;
	let path3;
	let defs;
	let radialGradient0;
	let stop0;
	let stop1;
	let radialGradient1;
	let stop2;
	let stop3;
	let clipPath;
	let rect1;

	return {
		c() {
			svg = svg_element("svg");
			g = svg_element("g");
			rect0 = svg_element("rect");
			path0 = svg_element("path");
			path1 = svg_element("path");
			path2 = svg_element("path");
			path3 = svg_element("path");
			defs = svg_element("defs");
			radialGradient0 = svg_element("radialGradient");
			stop0 = svg_element("stop");
			stop1 = svg_element("stop");
			radialGradient1 = svg_element("radialGradient");
			stop2 = svg_element("stop");
			stop3 = svg_element("stop");
			clipPath = svg_element("clipPath");
			rect1 = svg_element("rect");
			attr(rect0, "width", "52");
			attr(rect0, "height", "52");
			attr(rect0, "transform", "translate(0 0.714233)");
			attr(rect0, "fill", "white");
			attr(path0, "d", "M10.9805 25.5628C10.9805 33.7143 17.4999 40.0428 25.1743 40.3195C32.8488 40.5962 41.0186 40.3195 41.0186 40.3195V33.0403C41.0186 33.0403 29.2837 33.0696 25.1743 32.9784C21.065 32.8871 18.043 29.6583 18.043 25.5628C18.043 21.4673 21.2358 18.1472 25.1743 18.1472L28.6493 11.2486C27.5373 10.9577 26.3732 10.8031 25.1743 10.8031C17.3353 10.8031 10.9805 17.4112 10.9805 25.5628Z");
			attr(path0, "fill", "white");
			attr(path1, "d", "M10.9805 25.5628C10.9805 33.7143 17.4999 40.0428 25.1743 40.3195C32.8488 40.5962 41.0186 40.3195 41.0186 40.3195V33.0403C41.0186 33.0403 29.2837 33.0696 25.1743 32.9784C21.065 32.8871 18.043 29.6583 18.043 25.5628C18.043 21.4673 21.2358 18.1472 25.1743 18.1472L28.6493 11.2486C27.5373 10.9577 26.3732 10.8031 25.1743 10.8031C17.3353 10.8031 10.9805 17.4112 10.9805 25.5628Z");
			attr(path1, "fill", "url(#paint0_radial_6485_42334)");
			attr(path2, "d", "M32.3056 25.5628C32.3056 21.4673 29.1128 18.1472 25.1743 18.1472C21.2905 18.1472 18.1296 21.9979 18.0426 26.0147C18.0171 25.6691 18.0065 24.6976 18.0065 24.3451C18.0065 17.8891 22.3511 12.4882 28.1659 11.1315C34.5683 12.5598 39.3682 18.4784 39.3682 25.5628C39.3682 27.6394 38.9558 29.6158 38.2115 31.4084H29.5628C31.2324 30.0511 32.3056 27.9373 32.3056 25.5628Z");
			attr(path2, "fill", "#D9D9D9");
			attr(path3, "d", "M32.3056 25.5628C32.3056 21.4673 29.1128 18.1472 25.1743 18.1472C21.2905 18.1472 18.1296 21.9979 18.0426 26.0147C18.0171 25.6691 18.0065 24.6976 18.0065 24.3451C18.0065 17.8891 22.3511 12.4882 28.1659 11.1315C34.5683 12.5598 39.3682 18.4784 39.3682 25.5628C39.3682 27.6394 38.9558 29.6158 38.2115 31.4084H29.5628C31.2324 30.0511 32.3056 27.9373 32.3056 25.5628Z");
			attr(path3, "fill", "url(#paint1_angular_6485_42334)");
			attr(g, "clip-path", "url(#clip0_6485_42334)");
			attr(stop0, "stop-color", "#2DDEF8");
			attr(stop1, "offset", "1");
			attr(stop1, "stop-color", "#56BCCF");
			attr(radialGradient0, "id", "paint0_radial_6485_42334");
			attr(radialGradient0, "cx", "0");
			attr(radialGradient0, "cy", "0");
			attr(radialGradient0, "r", "1");
			attr(radialGradient0, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient0, "gradientTransform", "translate(24.2529 28.8254) rotate(13.166) scale(18.5391 18.3788)");
			attr(stop2, "stop-color", "#2C7790");
			attr(stop3, "offset", "0.794792");
			attr(stop3, "stop-color", "#1B2231");
			attr(radialGradient1, "id", "paint1_angular_6485_42334");
			attr(radialGradient1, "cx", "0");
			attr(radialGradient1, "cy", "0");
			attr(radialGradient1, "r", "1");
			attr(radialGradient1, "gradientUnits", "userSpaceOnUse");
			attr(radialGradient1, "gradientTransform", "translate(17.448 30.5999) rotate(2.68691) scale(40.0523 35.6373)");
			attr(rect1, "width", "52");
			attr(rect1, "height", "52");
			attr(rect1, "fill", "white");
			attr(rect1, "transform", "translate(0 0.714233)");
			attr(clipPath, "id", "clip0_6485_42334");
			attr(svg, "width", "52");
			attr(svg, "height", "53");
			attr(svg, "viewBox", "0 0 52 53");
			attr(svg, "fill", "none");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, g);
			append(g, rect0);
			append(g, path0);
			append(g, path1);
			append(g, path2);
			append(g, path3);
			append(svg, defs);
			append(defs, radialGradient0);
			append(radialGradient0, stop0);
			append(radialGradient0, stop1);
			append(defs, radialGradient1);
			append(radialGradient1, stop2);
			append(radialGradient1, stop3);
			append(defs, clipPath);
			append(clipPath, rect1);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

class QuizRace extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment$7, safe_not_equal, {});
	}
}

const IconAsSvelteComponent = (t) => t;
const appIcons = IconAsSvelteComponent({
    ADMIN: Admin,
    ATTENSI_PLATFORM: AttensiPlatform,
    CREATOR: Creator,
    DIALOGUE_REVIEW: DialogueReview,
    ENGAGE: Engage,
    FAST: Fast,
    INSIGHTS: Insights,
    LIVE_LEADERBOARDS: LiveLeaderboards,
    PORTAL: Portal,
    PROCESS_DOCS: ProcessDocs,
    QUIZRACE: QuizRace,
});

const getAppEntries = (env) => [
    {
        id: 'ADMIN',
        title: 'apps.admin.title',
        subtitle: 'apps.admin.subtitle',
        url: URLS.ADMIN[env],
        isSessionTransfer: true, // ✅ Session transfer works correctly ✅ URL cleansed
    },
    {
        id: 'ENGAGE',
        title: 'apps.engage.title',
        subtitle: 'apps.engage.subtitle',
        url: URLS.ENGAGE[env],
        isSessionTransfer: true, // ✅ Session transfer works correctly ❌ URL not cleansed
    },
    {
        id: 'FAST',
        title: 'apps.fast.title',
        subtitle: 'apps.fast.subtitle',
        url: URLS.FAST[env],
        isSessionTransfer: true, // ❌ Session transfer not working
    },
    {
        id: 'QUIZRACE',
        title: 'apps.quizrace.title',
        subtitle: 'apps.quizrace.subtitle',
        url: URLS.QUIZRACE[env],
        isSessionTransfer: true, // ❌ Session transfer not working
    },
    {
        id: 'LIVE_LEADERBOARDS',
        title: 'apps.live_leaderboards.title',
        subtitle: 'apps.live_leaderboards.subtitle',
        url: URLS.LIVE_LEADERBOARDS[env],
        isSessionTransfer: true, // ✅ Session transfer works correctly ❌ URL not cleansed
    },
    {
        id: 'INSIGHTS',
        title: 'apps.insights.title',
        subtitle: 'apps.insights.subtitle',
        url: URLS.INSIGHTS[env],
        isSessionTransfer: true, // ✅ Session transfer works correctly ❌ URL not cleansed
    },
    {
        id: 'DIALOGUE_REVIEW',
        title: 'apps.dialogue_review.title',
        subtitle: 'apps.dialogue_review.subtitle',
        url: URLS.DIALOGUE_REVIEW[env],
        isSessionTransfer: true, // ❓ Session transfer seems to work, but I get 401
    },
    {
        id: 'PROCESS_DOCS',
        title: 'apps.process_docs.title',
        subtitle: 'apps.process_docs.subtitle',
        url: URLS.PROCESS_DOCS[env],
        isSessionTransfer: true, // ❌ Session transfer not working
    },
];
const getLinkEntries = (env) => [
    {
        id: 'PORTAL',
        title: 'links.portal.title',
        subtitle: 'links.portal.subtitle',
        url: URLS.PORTAL[env],
        isSessionTransfer: true, // ✅ Session transfer works correctly ✅ URL cleansed
    },
    {
        id: 'CREATOR',
        title: 'links.creator.title',
        subtitle: 'links.creator.subtitle',
        url: URLS.CREATOR[env],
        isSessionTransfer: true, // ❓ I don't know how to redirect this
    },
    {
        id: 'ATTENSI_PLATFORM',
        title: 'links.attensi_platform.title',
        subtitle: 'links.attensi_platform.subtitle',
        url: URLS.ATTENSI_PLATFORM,
        isSessionTransfer: false, // ❓ I assume this one does not need session transfer at all
    },
];

const getApps = async () => {
    const { env } = await getConfig();
    const appEntries = getAppEntries(env);
    const linkEntries = getLinkEntries(env);
    return {
        appEntries: await filterEnabledEntries(appEntries),
        linkEntries: await filterEnabledEntries(linkEntries),
    };
};
const getAppIcon = (appId) => {
    const appIcon = appIcons[appId];
    return appIcon;
};
const filterEnabledEntries = async (entries) => {
    const { enabledApps } = await getConfig();
    return entries.filter((app) => enabledApps.includes(app.id));
};

function t(t,e,n,r){return new(n||(n=Promise))((function(o,s){function c(t){try{a(r.next(t));}catch(t){s(t);}}function i(t){try{a(r.throw(t));}catch(t){s(t);}}function a(t){var e;t.done?o(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e);}))).then(c,i);}a((r=r.apply(t,e||[])).next());}))}function e(t){var e,{message:r,text:o,method:s="GET",cause:c}=t,i=function(t,e){var n={};for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&e.indexOf(r)<0&&(n[r]=t[r]);if(null!=t&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(t);o<r.length;o++)e.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(t,r[o])&&(n[r[o]]=t[r[o]]);}return n}(t,["message","text","method","cause"]);const a=Error(r),u=Object.create(a);return Object.assign(u,i,{name:"AttensiFetchError",message:r,method:s,cause:c,text:o,json:n(o),stack:null!==(e=null==c?void 0:c.stack)&&void 0!==e?e:u.stack})}function n(t){if(void 0!==t)try{return JSON.parse(t)}catch(t){return}}function r(t){return t instanceof Error&&"AttensiFetchError"===t.name}function s(n,o={},s={}){var c,i;return t(this,void 0,void 0,(function*(){try{const r=yield fetch(n,yield function(e,n){var r;return t(this,void 0,void 0,(function*(){const t=yield Promise.resolve(null===(r=n.getHeaders)||void 0===r?void 0:r.call(n,e.context)),o=Object.assign(Object.assign({},t),null==e?void 0:e.headers);return Object.assign(Object.assign({},e),{headers:o})}))}(o,s));if(r.ok)return r;throw e({message:"HTTP status code "+r.status,status:r.status,text:yield r.text(),method:o.method,url:n})}catch(t){if(r(t))throw null===(c=s.onError)||void 0===c||c.call(s,t,o.context),t;const a=e({message:t.message,cause:t,method:o.method,url:n});throw null===(i=s.onError)||void 0===i||i.call(s,a,o.context),a}}))}

const redirectToApp = async (app) => {
    if (app.isSessionTransfer)
        await redirectWithSession(app);
    else
        redirectNoSession(app);
};
const redirectNoSession = (app) => {
    window.open(app.url, '_blank');
};
const redirectWithSession = async (app) => {
    const { subdomain, companyNameKey } = await getConfig();
    const transfer_key = await accessTokenToTransferKey();
    const redirectUrl = p(app.url, {
        subdomain,
        transfer_key,
        company_name_key: companyNameKey,
    });
    window.open(redirectUrl, '_blank');
};
const accessTokenToTransferKey = async () => {
    const { authUrl, accessToken } = await getConfig();
    const response = await s(`${authUrl}/api/v1/sessions/transfer`, {
        method: 'PUT',
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    const json = (await response.json());
    return json.TransferKey;
};

___$insertStylesToHeader("@import 'https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&family=Oswald:wght@300;400;600&display=swap';\nhtml {\n  font-size: 62.5%;\n  font-weight: 400;\n  box-sizing: border-box;\n}\n\n.appLink.svelte-i441zx {\n  display: flex;\n  align-items: center;\n  gap: 2.4rem;\n  padding: 1.2rem;\n  border: none;\n  border-radius: 2.4rem;\n  background-color: transparent;\n  cursor: pointer;\n}\n\n.appLink.svelte-i441zx:hover {\n  background-color: #e3e3e3;\n}\n\n.appLink__thumbnail.svelte-i441zx {\n  overflow: hidden;\n  min-width: 5.2rem;\n  min-height: 5.2rem;\n  max-width: 5.2rem;\n  max-height: 5.2rem;\n  background-color: #ffffff;\n  border: 1px solid #e3e3e3;\n  border-radius: 1.4rem;\n  box-shadow: 0px 0px 4.39853px rgba(0, 0, 0, 0.05), 0px 7.03765px 29.91px rgba(0, 0, 0, 0.05);\n}\n\n.appLink__info.svelte-i441zx {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n}\n\n.appLink__title.svelte-i441zx {\n  all: unset;\n  line-height: 2.2rem;\n  font-size: 1.6rem;\n  font-family: \"Lato\", sans-serif;\n  font-weight: 700;\n  color: #4a4a4a;\n}\n\n.appLink__subtitle.svelte-i441zx {\n  all: unset;\n  line-height: 2rem;\n  font-size: 1.2rem;\n  font-family: \"Lato\", sans-serif;\n  font-weight: 400;\n  color: #9b9b9b;\n}");

/* src/components/Sidebar/AppLink.svelte generated by Svelte v3.57.0 */

function create_fragment$6(ctx) {
	let button;
	let div0;
	let switch_instance;
	let t0;
	let div1;
	let h2;
	let t1_value = /*$t*/ ctx[1](/*app*/ ctx[0].title) + "";
	let t1;
	let t2;
	let p;
	let t3_value = /*$t*/ ctx[1](/*app*/ ctx[0].subtitle) + "";
	let t3;
	let current;
	let mounted;
	let dispose;
	var switch_value = /*appIcon*/ ctx[2];

	function switch_props(ctx) {
		return {};
	}

	if (switch_value) {
		switch_instance = construct_svelte_component(switch_value, switch_props());
	}

	return {
		c() {
			button = element("button");
			div0 = element("div");
			if (switch_instance) create_component(switch_instance.$$.fragment);
			t0 = space();
			div1 = element("div");
			h2 = element("h2");
			t1 = text(t1_value);
			t2 = space();
			p = element("p");
			t3 = text(t3_value);
			attr(div0, "class", "appLink__thumbnail svelte-i441zx");
			attr(h2, "class", "appLink__title svelte-i441zx");
			attr(p, "class", "appLink__subtitle svelte-i441zx");
			attr(div1, "class", "appLink__info svelte-i441zx");
			attr(button, "class", "appLink svelte-i441zx");
		},
		m(target, anchor) {
			insert(target, button, anchor);
			append(button, div0);
			if (switch_instance) mount_component(switch_instance, div0, null);
			append(button, t0);
			append(button, div1);
			append(div1, h2);
			append(h2, t1);
			append(div1, t2);
			append(div1, p);
			append(p, t3);
			current = true;

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler*/ ctx[3]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (switch_value !== (switch_value = /*appIcon*/ ctx[2])) {
				if (switch_instance) {
					group_outros();
					const old_component = switch_instance;

					transition_out(old_component.$$.fragment, 1, 0, () => {
						destroy_component(old_component, 1);
					});

					check_outros();
				}

				if (switch_value) {
					switch_instance = construct_svelte_component(switch_value, switch_props());
					create_component(switch_instance.$$.fragment);
					transition_in(switch_instance.$$.fragment, 1);
					mount_component(switch_instance, div0, null);
				} else {
					switch_instance = null;
				}
			}

			if ((!current || dirty & /*$t, app*/ 3) && t1_value !== (t1_value = /*$t*/ ctx[1](/*app*/ ctx[0].title) + "")) set_data(t1, t1_value);
			if ((!current || dirty & /*$t, app*/ 3) && t3_value !== (t3_value = /*$t*/ ctx[1](/*app*/ ctx[0].subtitle) + "")) set_data(t3, t3_value);
		},
		i(local) {
			if (current) return;
			if (switch_instance) transition_in(switch_instance.$$.fragment, local);
			current = true;
		},
		o(local) {
			if (switch_instance) transition_out(switch_instance.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(button);
			if (switch_instance) destroy_component(switch_instance);
			mounted = false;
			dispose();
		}
	};
}

function instance$4($$self, $$props, $$invalidate) {
	let $t;
	component_subscribe($$self, nn, $$value => $$invalidate(1, $t = $$value));
	let { app } = $$props;
	const appIcon = getAppIcon(app.id);
	const click_handler = () => redirectToApp(app);

	$$self.$$set = $$props => {
		if ('app' in $$props) $$invalidate(0, app = $$props.app);
	};

	return [app, $t, appIcon, click_handler];
}

class AppLink extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance$4, create_fragment$6, safe_not_equal, { app: 0 });
	}
}

/* src/assets/Chocolate.svelte generated by Svelte v3.57.0 */

function create_fragment$5(ctx) {
	let svg;
	let path0;
	let path1;
	let path2;
	let path3;
	let path4;
	let path5;
	let path6;
	let path7;
	let path8;

	return {
		c() {
			svg = svg_element("svg");
			path0 = svg_element("path");
			path1 = svg_element("path");
			path2 = svg_element("path");
			path3 = svg_element("path");
			path4 = svg_element("path");
			path5 = svg_element("path");
			path6 = svg_element("path");
			path7 = svg_element("path");
			path8 = svg_element("path");
			attr(path0, "fill-rule", "evenodd");
			attr(path0, "clip-rule", "evenodd");
			attr(path0, "d", "M1.20305 0H6.37739C6.86324 0 7.2572 0.487374 7.2572 0.882566V6.00258C7.2572 6.48996 6.86324 6.88515 6.37739 6.88515H1.20305C0.717199 6.88515 0.323242 6.39777 0.323242 6.00258V0.882566C0.323242 0.395191 0.717199 0 1.20305 0Z");
			attr(path1, "fill-rule", "evenodd");
			attr(path1, "clip-rule", "evenodd");
			attr(path1, "d", "M10.2851 0H15.4594C15.9453 0 16.3392 0.487374 16.3392 0.882566V6.00258C16.3392 6.48996 15.9453 6.88515 15.4594 6.88515H10.2851C9.79923 6.88515 9.40527 6.39777 9.40527 6.00258V0.882566C9.40527 0.395191 9.79923 0 10.2851 0Z");
			attr(path2, "fill-rule", "evenodd");
			attr(path2, "clip-rule", "evenodd");
			attr(path2, "d", "M19.2939 0H24.4682C24.9541 0 25.348 0.487374 25.348 0.882566V6.00258C25.348 6.48996 24.9541 6.88515 24.4682 6.88515H19.2939C18.808 6.88515 18.4141 6.39777 18.4141 6.00258V0.882566C18.4141 0.395191 18.808 0 19.2939 0Z");
			attr(path3, "fill-rule", "evenodd");
			attr(path3, "clip-rule", "evenodd");
			attr(path3, "d", "M1.20305 8.93176H6.37739C6.86324 8.93176 7.2572 9.41914 7.2572 9.81433V14.9343C7.2572 15.4217 6.86324 15.8169 6.37739 15.8169H1.20305C0.717199 15.8169 0.323242 15.3295 0.323242 14.9343V9.81433C0.323242 9.32695 0.717199 8.93176 1.20305 8.93176Z");
			attr(path4, "fill-rule", "evenodd");
			attr(path4, "clip-rule", "evenodd");
			attr(path4, "d", "M10.2851 8.93176H15.4594C15.9453 8.93176 16.3392 9.41914 16.3392 9.81433V14.9343C16.3392 15.4217 15.9453 15.8169 15.4594 15.8169H10.2851C9.79923 15.8169 9.40527 15.3295 9.40527 14.9343V9.81433C9.40527 9.32695 9.79923 8.93176 10.2851 8.93176Z");
			attr(path5, "fill-rule", "evenodd");
			attr(path5, "clip-rule", "evenodd");
			attr(path5, "d", "M19.2939 8.93176H24.4682C24.9541 8.93176 25.348 9.41914 25.348 9.81433V14.9343C25.348 15.4217 24.9541 15.8169 24.4682 15.8169H19.2939C18.808 15.8169 18.4141 15.3295 18.4141 14.9343V9.81433C18.4141 9.32695 18.808 8.93176 19.2939 8.93176Z");
			attr(path6, "fill-rule", "evenodd");
			attr(path6, "clip-rule", "evenodd");
			attr(path6, "d", "M1.20305 17.9015H6.37739C6.86324 17.9015 7.2572 18.3889 7.2572 18.7841V23.9041C7.2572 24.3914 6.86324 24.7866 6.37739 24.7866H1.20305C0.717199 24.7866 0.323242 24.2993 0.323242 23.9041V18.7841C0.323242 18.2967 0.717199 17.9015 1.20305 17.9015Z");
			attr(path7, "fill-rule", "evenodd");
			attr(path7, "clip-rule", "evenodd");
			attr(path7, "d", "M10.2851 17.9015H15.4594C15.9453 17.9015 16.3392 18.3889 16.3392 18.7841V23.9041C16.3392 24.3914 15.9453 24.7866 15.4594 24.7866H10.2851C9.79923 24.7866 9.40527 24.2993 9.40527 23.9041V18.7841C9.40527 18.2967 9.79923 17.9015 10.2851 17.9015Z");
			attr(path8, "fill-rule", "evenodd");
			attr(path8, "clip-rule", "evenodd");
			attr(path8, "d", "M19.2939 17.9015H24.4682C24.9541 17.9015 25.348 18.3889 25.348 18.7841V23.9041C25.348 24.3914 24.9541 24.7866 24.4682 24.7866H19.2939C18.808 24.7866 18.4141 24.2993 18.4141 23.9041V18.7841C18.4141 18.2967 18.808 17.9015 19.2939 17.9015Z");
			attr(svg, "width", "26");
			attr(svg, "height", "25");
			attr(svg, "viewBox", "0 0 26 25");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
			attr(svg, "fill", "currentColor");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, path0);
			append(svg, path1);
			append(svg, path2);
			append(svg, path3);
			append(svg, path4);
			append(svg, path5);
			append(svg, path6);
			append(svg, path7);
			append(svg, path8);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

class Chocolate extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment$5, safe_not_equal, {});
	}
}

___$insertStylesToHeader("@import 'https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&family=Oswald:wght@300;400;600&display=swap';\nhtml {\n  font-size: 62.5%;\n  font-weight: 400;\n  box-sizing: border-box;\n}\n\n.toggleBtn.svelte-ut405x {\n  display: flex;\n  width: max-content;\n  height: max-content;\n  color: #4a4a4a;\n  background-color: #ffffff;\n  padding: 1.2rem;\n  border-radius: 1.6rem;\n  border: 1px solid #e3e3e3;\n  cursor: pointer;\n}\n\n.toggleBtn--active.svelte-ut405x {\n  background-color: #e3e3e3;\n}");

/* src/components/AppLauncherButton.svelte generated by Svelte v3.57.0 */

function create_fragment$4(ctx) {
	let button;
	let iconchocolate;
	let button_class_value;
	let current;
	let mounted;
	let dispose;
	iconchocolate = new Chocolate({});

	return {
		c() {
			button = element("button");
			create_component(iconchocolate.$$.fragment);
			attr(button, "class", button_class_value = "" + (null_to_empty(`toggleBtn ${/*isOpen*/ ctx[0] ? 'toggleBtn--active' : ''}`) + " svelte-ut405x"));
		},
		m(target, anchor) {
			insert(target, button, anchor);
			mount_component(iconchocolate, button, null);
			current = true;

			if (!mounted) {
				dispose = listen(button, "click", toggleAppLauncher);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*isOpen*/ 1 && button_class_value !== (button_class_value = "" + (null_to_empty(`toggleBtn ${/*isOpen*/ ctx[0] ? 'toggleBtn--active' : ''}`) + " svelte-ut405x"))) {
				attr(button, "class", button_class_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(iconchocolate.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(iconchocolate.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(button);
			destroy_component(iconchocolate);
			mounted = false;
			dispose();
		}
	};
}

function instance$3($$self, $$props, $$invalidate) {
	let isOpen;
	isAppLauncherOpen.subscribe(value => $$invalidate(0, isOpen = value));
	return [isOpen];
}

class AppLauncherButton extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance$3, create_fragment$4, safe_not_equal, {});
	}
}

___$insertStylesToHeader("@import 'https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&family=Oswald:wght@300;400;600&display=swap';\nhtml {\n  font-size: 62.5%;\n  font-weight: 400;\n  box-sizing: border-box;\n}\n\n.header.svelte-q6t6oc {\n  position: sticky;\n  top: 0;\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  padding: 2rem 2.4rem;\n  border-bottom: 1px solid #e3e3e3;\n  background-color: #fbfbfb;\n  color: #4a4a4a;\n}\n\n.header__title.svelte-q6t6oc {\n  all: unset;\n  font-family: \"Lato\", sans-serif;\n  font-size: 2.2rem;\n  font-weight: 600;\n}");

/* src/components/Sidebar/Header.svelte generated by Svelte v3.57.0 */

function create_fragment$3(ctx) {
	let header;
	let applauncherbutton;
	let t0;
	let h1;
	let t1_value = /*$t*/ ctx[0]('attensi_platform') + "";
	let t1;
	let current;
	applauncherbutton = new AppLauncherButton({});

	return {
		c() {
			header = element("header");
			create_component(applauncherbutton.$$.fragment);
			t0 = space();
			h1 = element("h1");
			t1 = text(t1_value);
			attr(h1, "class", "header__title svelte-q6t6oc");
			attr(header, "class", "header svelte-q6t6oc");
		},
		m(target, anchor) {
			insert(target, header, anchor);
			mount_component(applauncherbutton, header, null);
			append(header, t0);
			append(header, h1);
			append(h1, t1);
			current = true;
		},
		p(ctx, [dirty]) {
			if ((!current || dirty & /*$t*/ 1) && t1_value !== (t1_value = /*$t*/ ctx[0]('attensi_platform') + "")) set_data(t1, t1_value);
		},
		i(local) {
			if (current) return;
			transition_in(applauncherbutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(applauncherbutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(header);
			destroy_component(applauncherbutton);
		}
	};
}

function instance$2($$self, $$props, $$invalidate) {
	let $t;
	component_subscribe($$self, nn, $$value => $$invalidate(0, $t = $$value));
	return [$t];
}

class Header extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance$2, create_fragment$3, safe_not_equal, {});
	}
}

___$insertStylesToHeader("@import 'https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&family=Oswald:wght@300;400;600&display=swap';\nhtml {\n  font-size: 62.5%;\n  font-weight: 400;\n  box-sizing: border-box;\n}\n\n.skeleton.svelte-1ss3s7u.svelte-1ss3s7u {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 2.4rem;\n  padding: 1.2rem;\n  border-radius: 2.4rem;\n  overflow: hidden;\n}\n\n.skeleton.svelte-1ss3s7u .svelte-1ss3s7u:not(:last-child) {\n  margin-bottom: 0.2rem;\n}\n\n.skeleton__left.svelte-1ss3s7u.svelte-1ss3s7u {\n  min-width: 5.2rem;\n  min-height: 5.2rem;\n  max-width: 5.2rem;\n  max-height: 5.2rem;\n  background-color: #e3e3e3;\n  border-radius: 1.4rem;\n}\n\n.skeleton__right.svelte-1ss3s7u.svelte-1ss3s7u {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.6rem;\n  width: 100%;\n}\n\n.skeleton__title.svelte-1ss3s7u.svelte-1ss3s7u, .skeleton__subtitle.svelte-1ss3s7u.svelte-1ss3s7u {\n  background-color: #e3e3e3;\n  border-radius: 0.6rem;\n  height: 1.6rem;\n}\n\n.skeleton__title.svelte-1ss3s7u.svelte-1ss3s7u {\n  width: 90%;\n}\n\n.skeleton__subtitle.svelte-1ss3s7u.svelte-1ss3s7u {\n  width: 60%;\n}\n\n.skeleton.svelte-1ss3s7u.svelte-1ss3s7u::after {\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));\n  animation: svelte-1ss3s7u-shimmer 2s infinite;\n  content: \"\";\n}\n\n@keyframes svelte-1ss3s7u-shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}");

/* src/components/Sidebar/AppLinkSkeleton.svelte generated by Svelte v3.57.0 */

function create_fragment$2(ctx) {
	let div4;

	return {
		c() {
			div4 = element("div");

			div4.innerHTML = `<div class="skeleton__left svelte-1ss3s7u"></div> 
  <div class="skeleton__right svelte-1ss3s7u"><div class="skeleton__title svelte-1ss3s7u"></div> 
    <div class="skeleton__subtitle svelte-1ss3s7u"></div></div>`;

			attr(div4, "class", "skeleton svelte-1ss3s7u");
		},
		m(target, anchor) {
			insert(target, div4, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div4);
		}
	};
}

class AppLinkSkeleton extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment$2, safe_not_equal, {});
	}
}

___$insertStylesToHeader("@import 'https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&family=Oswald:wght@300;400;600&display=swap';\nhtml {\n  font-size: 62.5%;\n  font-weight: 400;\n  box-sizing: border-box;\n}\n\n.sidebar.svelte-1av2aui {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  inset: 0;\n  height: 100vh;\n  width: 100%;\n  max-width: 360px;\n  background-color: #fbfbfb;\n  pointer-events: all;\n}\n\n.section.svelte-1av2aui {\n  padding: 1.2rem;\n  background-color: #fbfbfb;\n}\n\n.section__title.svelte-1av2aui {\n  font-size: 1.2rem;\n  font-family: \"Lato\", sans-serif;\n  color: #9b9b9b;\n  margin: 1.2rem;\n}\n\n.section__entries.svelte-1av2aui {\n  display: flex;\n  flex-direction: column;\n}\n\n.section__apps.svelte-1av2aui {\n  overflow-y: scroll;\n}\n\n.section__links.svelte-1av2aui {\n  position: sticky;\n  bottom: 0;\n  margin: auto 0 0 0;\n  border-top: 1px solid #e3e3e3;\n}");

/* src/components/Sidebar/Sidebar.svelte generated by Svelte v3.57.0 */

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[6] = list[i];
	return child_ctx;
}

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[3] = list[i];
	return child_ctx;
}

function get_each_context_3(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[6] = list[i];
	return child_ctx;
}

function get_each_context_2(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[3] = list[i];
	return child_ctx;
}

// (11:0) {#if isOpen}
function create_if_block$1(ctx) {
	let aside;
	let header;
	let t0;
	let section0;
	let div0;
	let t1_value = /*$t*/ ctx[1]('launch_apps') + "";
	let t1;
	let t2;
	let div1;
	let t3;
	let section1;
	let div2;
	let aside_transition;
	let current;
	header = new Header({});

	let info = {
		ctx,
		current: null,
		token: null,
		hasCatch: false,
		pending: create_pending_block_1,
		then: create_then_block_1,
		catch: create_catch_block_1,
		value: 2,
		blocks: [,,,]
	};

	handle_promise(/*entries*/ ctx[2], info);

	let info_1 = {
		ctx,
		current: null,
		token: null,
		hasCatch: false,
		pending: create_pending_block,
		then: create_then_block,
		catch: create_catch_block,
		value: 2,
		blocks: [,,,]
	};

	handle_promise(/*entries*/ ctx[2], info_1);

	return {
		c() {
			aside = element("aside");
			create_component(header.$$.fragment);
			t0 = space();
			section0 = element("section");
			div0 = element("div");
			t1 = text(t1_value);
			t2 = space();
			div1 = element("div");
			info.block.c();
			t3 = space();
			section1 = element("section");
			div2 = element("div");
			info_1.block.c();
			attr(div0, "class", "section__title svelte-1av2aui");
			attr(div1, "class", "section__entries svelte-1av2aui");
			attr(section0, "class", "section section__apps svelte-1av2aui");
			attr(div2, "class", "section__entries svelte-1av2aui");
			attr(section1, "class", "section section__links svelte-1av2aui");
			attr(aside, "class", "sidebar svelte-1av2aui");
		},
		m(target, anchor) {
			insert(target, aside, anchor);
			mount_component(header, aside, null);
			append(aside, t0);
			append(aside, section0);
			append(section0, div0);
			append(div0, t1);
			append(section0, t2);
			append(section0, div1);
			info.block.m(div1, info.anchor = null);
			info.mount = () => div1;
			info.anchor = null;
			append(aside, t3);
			append(aside, section1);
			append(section1, div2);
			info_1.block.m(div2, info_1.anchor = null);
			info_1.mount = () => div2;
			info_1.anchor = null;
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			if ((!current || dirty & /*$t*/ 2) && t1_value !== (t1_value = /*$t*/ ctx[1]('launch_apps') + "")) set_data(t1, t1_value);
			update_await_block_branch(info, ctx, dirty);
			update_await_block_branch(info_1, ctx, dirty);
		},
		i(local) {
			if (current) return;
			transition_in(header.$$.fragment, local);
			transition_in(info.block);
			transition_in(info_1.block);

			add_render_callback(() => {
				if (!current) return;
				if (!aside_transition) aside_transition = create_bidirectional_transition(aside, fly, { x: -360, duration: 500 }, true);
				aside_transition.run(1);
			});

			current = true;
		},
		o(local) {
			transition_out(header.$$.fragment, local);

			for (let i = 0; i < 3; i += 1) {
				const block = info.blocks[i];
				transition_out(block);
			}

			for (let i = 0; i < 3; i += 1) {
				const block = info_1.blocks[i];
				transition_out(block);
			}

			if (!aside_transition) aside_transition = create_bidirectional_transition(aside, fly, { x: -360, duration: 500 }, false);
			aside_transition.run(0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(aside);
			destroy_component(header);
			info.block.d();
			info.token = null;
			info = null;
			info_1.block.d();
			info_1.token = null;
			info_1 = null;
			if (detaching && aside_transition) aside_transition.end();
		}
	};
}

// (1:0) <script lang="ts">import { fly }
function create_catch_block_1(ctx) {
	return {
		c: noop,
		m: noop,
		p: noop,
		i: noop,
		o: noop,
		d: noop
	};
}

// (21:8) {:then entries}
function create_then_block_1(ctx) {
	let each_blocks = [];
	let each_1_lookup = new Map();
	let each_1_anchor;
	let current;
	let each_value_3 = /*entries*/ ctx[2].appEntries;
	const get_key = ctx => /*app*/ ctx[6];

	for (let i = 0; i < each_value_3.length; i += 1) {
		let child_ctx = get_each_context_3(ctx, each_value_3, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block_3(key, child_ctx));
	}

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(target, anchor);
				}
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*entries*/ 4) {
				each_value_3 = /*entries*/ ctx[2].appEntries;
				group_outros();
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value_3, each_1_lookup, each_1_anchor.parentNode, outro_and_destroy_block, create_each_block_3, each_1_anchor, get_each_context_3);
				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_3.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d(detaching);
			}

			if (detaching) detach(each_1_anchor);
		}
	};
}

// (22:10) {#each entries.appEntries as app (app)}
function create_each_block_3(key_1, ctx) {
	let first;
	let applink;
	let current;
	applink = new AppLink({ props: { app: /*app*/ ctx[6] } });

	return {
		key: key_1,
		first: null,
		c() {
			first = empty();
			create_component(applink.$$.fragment);
			this.first = first;
		},
		m(target, anchor) {
			insert(target, first, anchor);
			mount_component(applink, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
		},
		i(local) {
			if (current) return;
			transition_in(applink.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(applink.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(first);
			destroy_component(applink, detaching);
		}
	};
}

// (17:24)            {#each Array(3) as _}
function create_pending_block_1(ctx) {
	let each_1_anchor;
	let current;
	let each_value_2 = Array(3);
	let each_blocks = [];

	for (let i = 0; i < each_value_2.length; i += 1) {
		each_blocks[i] = create_each_block_2(get_each_context_2(ctx, each_value_2, i));
	}

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(target, anchor);
				}
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_2.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (18:10) {#each Array(3) as _}
function create_each_block_2(ctx) {
	let applinkskeleton;
	let current;
	applinkskeleton = new AppLinkSkeleton({});

	return {
		c() {
			create_component(applinkskeleton.$$.fragment);
		},
		m(target, anchor) {
			mount_component(applinkskeleton, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(applinkskeleton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(applinkskeleton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(applinkskeleton, detaching);
		}
	};
}

// (1:0) <script lang="ts">import { fly }
function create_catch_block(ctx) {
	return {
		c: noop,
		m: noop,
		p: noop,
		i: noop,
		o: noop,
		d: noop
	};
}

// (34:8) {:then entries}
function create_then_block(ctx) {
	let each_blocks = [];
	let each_1_lookup = new Map();
	let each_1_anchor;
	let current;
	let each_value_1 = /*entries*/ ctx[2].linkEntries;
	const get_key = ctx => /*app*/ ctx[6];

	for (let i = 0; i < each_value_1.length; i += 1) {
		let child_ctx = get_each_context_1(ctx, each_value_1, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block_1(key, child_ctx));
	}

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(target, anchor);
				}
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*entries*/ 4) {
				each_value_1 = /*entries*/ ctx[2].linkEntries;
				group_outros();
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value_1, each_1_lookup, each_1_anchor.parentNode, outro_and_destroy_block, create_each_block_1, each_1_anchor, get_each_context_1);
				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_1.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d(detaching);
			}

			if (detaching) detach(each_1_anchor);
		}
	};
}

// (35:10) {#each entries.linkEntries as app (app)}
function create_each_block_1(key_1, ctx) {
	let first;
	let applink;
	let current;
	applink = new AppLink({ props: { app: /*app*/ ctx[6] } });

	return {
		key: key_1,
		first: null,
		c() {
			first = empty();
			create_component(applink.$$.fragment);
			this.first = first;
		},
		m(target, anchor) {
			insert(target, first, anchor);
			mount_component(applink, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
		},
		i(local) {
			if (current) return;
			transition_in(applink.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(applink.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(first);
			destroy_component(applink, detaching);
		}
	};
}

// (30:24)            {#each Array(3) as _}
function create_pending_block(ctx) {
	let each_1_anchor;
	let current;
	let each_value = Array(3);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(target, anchor);
				}
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (31:10) {#each Array(3) as _}
function create_each_block(ctx) {
	let applinkskeleton;
	let current;
	applinkskeleton = new AppLinkSkeleton({});

	return {
		c() {
			create_component(applinkskeleton.$$.fragment);
		},
		m(target, anchor) {
			mount_component(applinkskeleton, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(applinkskeleton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(applinkskeleton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(applinkskeleton, detaching);
		}
	};
}

function create_fragment$1(ctx) {
	let if_block_anchor;
	let current;
	let if_block = /*isOpen*/ ctx[0] && create_if_block$1(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*isOpen*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*isOpen*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block$1(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance$1($$self, $$props, $$invalidate) {
	let $t;
	component_subscribe($$self, nn, $$value => $$invalidate(1, $t = $$value));
	let { isOpen } = $$props;
	let entries = getApps();

	$$self.$$set = $$props => {
		if ('isOpen' in $$props) $$invalidate(0, isOpen = $$props.isOpen);
	};

	return [isOpen, $t, entries];
}

class Sidebar extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance$1, create_fragment$1, safe_not_equal, { isOpen: 0 });
	}
}

___$insertStylesToHeader("@import 'https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&family=Oswald:wght@300;400;600&display=swap';\nhtml {\n  font-size: 62.5%;\n  font-weight: 400;\n  box-sizing: border-box;\n}\n\n.appLauncher.svelte-5bc7tl {\n  z-index: 9999;\n  position: fixed;\n  inset: 0;\n  display: flex;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.appLauncher__dimmer.svelte-5bc7tl {\n  position: absolute;\n  inset: 0;\n  background-color: rgba(74, 74, 74, 0.3);\n  pointer-events: all;\n}");

/* src/components/AppLauncher.svelte generated by Svelte v3.57.0 */

function create_if_block(ctx) {
	let div;
	let div_transition;
	let current;
	let mounted;
	let dispose;

	return {
		c() {
			div = element("div");
			attr(div, "class", "appLauncher__dimmer svelte-5bc7tl");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			current = true;

			if (!mounted) {
				dispose = listen(div, "click", toggleAppLauncher);
				mounted = true;
			}
		},
		p: noop,
		i(local) {
			if (current) return;

			add_render_callback(() => {
				if (!current) return;
				if (!div_transition) div_transition = create_bidirectional_transition(div, fade, { duration: 500 }, true);
				div_transition.run(1);
			});

			current = true;
		},
		o(local) {
			if (!div_transition) div_transition = create_bidirectional_transition(div, fade, { duration: 500 }, false);
			div_transition.run(0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (detaching && div_transition) div_transition.end();
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let div;
	let t;
	let sidebar;
	let current;
	let if_block = /*isOpen*/ ctx[0] && create_if_block();
	sidebar = new Sidebar({ props: { isOpen: /*isOpen*/ ctx[0] } });

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			t = space();
			create_component(sidebar.$$.fragment);
			attr(div, "class", "appLauncher svelte-5bc7tl");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
			append(div, t);
			mount_component(sidebar, div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*isOpen*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*isOpen*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block();
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(div, t);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			const sidebar_changes = {};
			if (dirty & /*isOpen*/ 1) sidebar_changes.isOpen = /*isOpen*/ ctx[0];
			sidebar.$set(sidebar_changes);
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			transition_in(sidebar.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			transition_out(sidebar.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
			destroy_component(sidebar);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let isOpen = false;
	isAppLauncherOpen.subscribe(value => $$invalidate(0, isOpen = value));
	return [isOpen];
}

class AppLauncher extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

const initAppLauncher = (userConfig) => {
    setConfig(userConfig);
    initLocale(userConfig.locale);
    const appLauncher = new AppLauncher({
        target: document.body,
    });
    return appLauncher;
};

export { AppLauncherButton, changeLocale as changeAppLauncherLocale, initAppLauncher, toggleAppLauncher };
//# sourceMappingURL=index.js.map
